import { cx, css } from 'emotion';
import React from 'react';
import { ThemeContext } from '@weave-design/theme-context';

function stylesheet(props, themeData) {
  const {
    color,
    stylesheet: customStylesheet
  } = props;
  const fillColor = color || themeData["colorScheme.icon.default"];
  const styles = {
    fill: fillColor,
    "> *": {
      fill: fillColor
    }
  };
  return customStylesheet ? customStylesheet(styles, props, themeData) : styles;
}

var _path$5C;

function _extends$5K() { _extends$5K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5K.apply(this, arguments); }

var SvgHelp$2 = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5K({
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5C || (_path$5C = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12A6 6 0 106 0a6 6 0 000 12zm-.99-8.9c-.163.193-.26.493-.26.872h-1.5c0-.607.153-1.293.615-1.84.48-.57 1.208-.882 2.135-.882.916 0 1.646.296 2.132.863.468.546.618 1.237.618 1.86 0 .573-.199 1.018-.525 1.353-.277.286-.627.465-.857.583l-.026.013c-.277.141-.411.217-.5.305-.047.047-.092.103-.092.273v1.515h-1.5V6.5c0-.57.205-1.008.533-1.335.27-.27.61-.443.836-.558l.04-.02c.27-.139.404-.216.49-.306.05-.05.101-.119.101-.309 0-.405-.1-.7-.257-.883-.139-.162-.41-.339-.993-.339-.573 0-.846.18-.99.35zM7 10a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "gray"
  })));
};

var _path$5B;

function _extends$5J() { _extends$5J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5J.apply(this, arguments); }

var SvgError$2 = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5J({
    width: 12,
    height: 12
  }, props), _path$5B || (_path$5B = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0L0 6l6 6 6-6-6-6zm-.5 6.773c0 .124.11.227.25.227h.5c.14 0 .25-.103.25-.227L7 3.46C7 3.33 6.47 3 6.33 3h-.66c-.14 0-.67.33-.67.46l.5 3.313zM6 8c-.552 0-1 .224-1 .5s.448.5 1 .5 1-.224 1-.5S6.552 8 6 8z"
  })));
};

var _path$5A;

function _extends$5I() { _extends$5I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5I.apply(this, arguments); }

var SvgComplete$2 = function SvgComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5I({
    width: 12,
    height: 12
  }, props), _path$5A || (_path$5A = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.75 6a5.25 5.25 0 1110.5 0A5.25 5.25 0 01.75 6zm2.145.862l2.453 2.063 3.75-4.853-.848-.652-3.067 3.968-1.598-1.35-.69.824z"
  })));
};

var _path$5z;

function _extends$5H() { _extends$5H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5H.apply(this, arguments); }

var SvgAlert$2 = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5H({
    width: 12,
    height: 12
  }, props), _path$5z || (_path$5z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.035 10.77L5.815.115A.241.241 0 016.018 0c.08 0 .156.043.202.115L11.97 10.77c.09.156-.037.23-.209.23H.244c-.21 0-.3-.074-.21-.23zM5.75 8h.5c.14 0 .25-.103.25-.227L7 4.46C7 4.33 6.47 4 6.33 4h-.66c-.14 0-.67.33-.67.46l.5 3.313c0 .124.11.227.25.227zM6 9c-.552 0-1 .224-1 .5s.448.5 1 .5 1-.224 1-.5S6.552 9 6 9z"
  })));
};

var _path$5y;

function _extends$5G() { _extends$5G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5G.apply(this, arguments); }

var SvgOperatorPlusXs = function SvgOperatorPlusXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5G({
    width: 16,
    height: 16
  }, props), _path$5y || (_path$5y = /*#__PURE__*/React.createElement("path", {
    d: "M7 7V4h2v3h3v2H9v3H7V9H4V7h3z"
  })));
};

var _path$5x;

function _extends$5F() { _extends$5F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5F.apply(this, arguments); }

var SvgOperatorPlusS = function SvgOperatorPlusS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5F({
    width: 16,
    height: 16
  }, props), _path$5x || (_path$5x = /*#__PURE__*/React.createElement("path", {
    d: "M7 7V2h2v5h5v2H9v5H7V9H2V7h5z"
  })));
};

var _path$5w;

function _extends$5E() { _extends$5E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5E.apply(this, arguments); }

var SvgOperatorMinusXs = function SvgOperatorMinusXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5E({
    width: 16,
    height: 16
  }, props), _path$5w || (_path$5w = /*#__PURE__*/React.createElement("path", {
    d: "M4 7h8v2H4z"
  })));
};

var _path$5v;

function _extends$5D() { _extends$5D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5D.apply(this, arguments); }

var SvgOperatorMinusS = function SvgOperatorMinusS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5D({
    width: 16,
    height: 16
  }, props), _path$5v || (_path$5v = /*#__PURE__*/React.createElement("path", {
    d: "M2 7h12v2H2V7z"
  })));
};

var _path$5u;

function _extends$5C() { _extends$5C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5C.apply(this, arguments); }

var SvgHoldXs = function SvgHoldXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5C({
    width: 3,
    height: 3
  }, props), _path$5u || (_path$5u = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H0l3-3v3z"
  })));
};

var _path$5t;

function _extends$5B() { _extends$5B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5B.apply(this, arguments); }

var SvgHoldS = function SvgHoldS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5B({
    width: 5,
    height: 5
  }, props), _path$5t || (_path$5t = /*#__PURE__*/React.createElement("path", {
    d: "M5 5H0l5-5v5z"
  })));
};

var _path$5s;

function _extends$5A() { _extends$5A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5A.apply(this, arguments); }

var SvgHamburgerDefault = function SvgHamburgerDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5A({
    width: 16,
    height: 16
  }, props), _path$5s || (_path$5s = /*#__PURE__*/React.createElement("path", {
    d: "M0 2h16v2H0zm0 5h16v2H0zm0 5h16v2H0z"
  })));
};

var _path$5r;

function _extends$5z() { _extends$5z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5z.apply(this, arguments); }

var SvgHamburgerClose = function SvgHamburgerClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5z({
    width: 16,
    height: 16
  }, props), _path$5r || (_path$5r = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 6.4L14.2 0l1.4 1.4-6.4 6.4 6.5 6.5-1.4 1.4-6.5-6.5-6.4 6.4L0 14.2l6.4-6.4L0 1.4 1.4 0z"
  })));
};

var _circle$i, _circle2$8, _circle3$4;

function _extends$5y() { _extends$5y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5y.apply(this, arguments); }

var SvgEllipsisXs = function SvgEllipsisXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5y({
    width: 12,
    height: 12,
    fill: "none"
  }, props), _circle$i || (_circle$i = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 6,
    r: 1,
    fill: "gray"
  })), _circle2$8 || (_circle2$8 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 1,
    fill: "gray"
  })), _circle3$4 || (_circle3$4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 6,
    r: 1,
    fill: "gray"
  })));
};

var _circle$h, _circle2$7, _circle3$3;

function _extends$5x() { _extends$5x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5x.apply(this, arguments); }

var SvgEllipsisS = function SvgEllipsisS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5x({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _circle$h || (_circle$h = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 8,
    r: 2,
    fill: "gray"
  })), _circle2$7 || (_circle2$7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2,
    fill: "gray"
  })), _circle3$3 || (_circle3$3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 8,
    r: 2,
    fill: "gray"
  })));
};

var _circle$g, _circle2$6, _circle3$2;

function _extends$5w() { _extends$5w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5w.apply(this, arguments); }

var SvgEllipsisM = function SvgEllipsisM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5w({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle$g || (_circle$g = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 12,
    r: 2.5,
    fill: "gray"
  })), _circle2$6 || (_circle2$6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.5,
    fill: "gray"
  })), _circle3$2 || (_circle3$2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 12,
    r: 2.5,
    fill: "gray"
  })));
};

var _path$5q;

function _extends$5v() { _extends$5v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5v.apply(this, arguments); }

var SvgCloseXs = function SvgCloseXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5v({
    width: 16,
    height: 16
  }, props), _path$5q || (_path$5q = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 5.4l-.8-.8L8 7.3 5.4 4.6l-.8.8L7.3 8l-2.7 2.6.8.8L8 8.7l2.6 2.7.8-.8L8.7 8l2.7-2.6z"
  })));
};

var _path$5p;

function _extends$5u() { _extends$5u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5u.apply(this, arguments); }

var SvgCloseS = function SvgCloseS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5u({
    width: 16,
    height: 16
  }, props), _path$5p || (_path$5p = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 3.4l-.8-.8L8 7.3 3.4 2.6l-.8.8L7.3 8l-4.7 4.6.8.8L8 8.7l4.6 4.7.8-.8L8.7 8l4.7-4.6z"
  })));
};

var _path$5o;

function _extends$5t() { _extends$5t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5t.apply(this, arguments); }

var SvgCloseM = function SvgCloseM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5t({
    width: 16,
    height: 16
  }, props), _path$5o || (_path$5o = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 2.4l-.8-.8L8 7.3 2.4 1.6l-.8.8L7.3 8l-5.7 5.6.8.8L8 8.7l5.6 5.7.8-.8L8.7 8l5.7-5.6z"
  })));
};

var _path$5n;

function _extends$5s() { _extends$5s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5s.apply(this, arguments); }

var SvgCloseL = function SvgCloseL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5s({
    width: 16,
    height: 16
  }, props), _path$5n || (_path$5n = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 1.4l-.8-.8L8 7.3 1.4.6l-.8.8L7.3 8 .6 14.6l.8.8L8 8.7l6.6 6.7.8-.8L8.7 8l6.7-6.6z"
  })));
};

var _path$5m;

function _extends$5r() { _extends$5r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5r.apply(this, arguments); }

var SvgCheckmarkXs = function SvgCheckmarkXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5r({
    width: 16,
    height: 16
  }, props), _path$5m || (_path$5m = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 8.6l1.4-1.5 1.7 1.5 3.6-4 1.5 1.3-5 5.5-3.2-2.8z"
  })));
};

var _path$5l;

function _extends$5q() { _extends$5q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5q.apply(this, arguments); }

var SvgCheckmarkS = function SvgCheckmarkS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5q({
    width: 16,
    height: 16
  }, props), _path$5l || (_path$5l = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 12L2 8.1l1.3-1.3 2.9 2.7L12.7 3 14 4.3 6.2 12z"
  })));
};

var _path$5k;

function _extends$5p() { _extends$5p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5p.apply(this, arguments); }

var SvgCaretUpXs = function SvgCaretUpXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5p({
    width: 5,
    height: 3
  }, props), _path$5k || (_path$5k = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0L5 3H0l2.5-3z"
  })));
};

var _path$5j;

function _extends$5o() { _extends$5o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5o.apply(this, arguments); }

var SvgCaretUpS = function SvgCaretUpS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5o({
    width: 7,
    height: 4
  }, props), _path$5j || (_path$5j = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L7 4H0l3.5-4z"
  })));
};

var _path$5i;

function _extends$5n() { _extends$5n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5n.apply(this, arguments); }

var SvgCaretUpM = function SvgCaretUpM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5n({
    width: 10,
    height: 10
  }, props), _path$5i || (_path$5i = /*#__PURE__*/React.createElement("path", {
    d: "M8.71 6.78a.75.75 0 01-1.06 0L5 4.13 2.35 6.78a.75.75 0 01-1.06 0 .74.74 0 010-1.06l3.36-3.36a.5.5 0 01.7 0l3.36 3.36a.74.74 0 010 1.06z"
  })));
};

var _path$5h;

function _extends$5m() { _extends$5m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5m.apply(this, arguments); }

var SvgCaretRightXs = function SvgCaretRightXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5m({
    width: 3,
    height: 5
  }, props), _path$5h || (_path$5h = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.5L0 5V0l3 2.5z"
  })));
};

var _path$5g;

function _extends$5l() { _extends$5l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5l.apply(this, arguments); }

var SvgCaretRightS = function SvgCaretRightS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5l({
    width: 4,
    height: 7
  }, props), _path$5g || (_path$5g = /*#__PURE__*/React.createElement("path", {
    d: "M0 7V0l4 3.5L0 7z"
  })));
};

var _path$5f;

function _extends$5k() { _extends$5k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5k.apply(this, arguments); }

var SvgCaretRightM = function SvgCaretRightM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5k({
    width: 10,
    height: 10
  }, props), _path$5f || (_path$5f = /*#__PURE__*/React.createElement("path", {
    d: "M3.22 1.29a.75.75 0 000 1.06L5.87 5 3.22 7.65a.75.75 0 000 1.06.74.74 0 001.06 0l3.36-3.36a.5.5 0 000-.7L4.28 1.29a.74.74 0 00-1.06 0z"
  })));
};

var _path$5e;

function _extends$5j() { _extends$5j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5j.apply(this, arguments); }

var SvgCaretLeftXs = function SvgCaretLeftXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5j({
    width: 3,
    height: 5
  }, props), _path$5e || (_path$5e = /*#__PURE__*/React.createElement("path", {
    d: "M3 0v5L0 2.5 3 0z"
  })));
};

var _path$5d;

function _extends$5i() { _extends$5i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5i.apply(this, arguments); }

var SvgCaretLeftS = function SvgCaretLeftS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5i({
    width: 4,
    height: 7
  }, props), _path$5d || (_path$5d = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.5L4 0v7L0 3.5z"
  })));
};

var _path$5c;

function _extends$5h() { _extends$5h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5h.apply(this, arguments); }

var SvgCaretLeftM = function SvgCaretLeftM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5h({
    width: 10,
    height: 10
  }, props), _path$5c || (_path$5c = /*#__PURE__*/React.createElement("path", {
    d: "M6.78 8.71a.75.75 0 000-1.06L4.13 5l2.65-2.65a.75.75 0 000-1.06.74.74 0 00-1.06 0L2.36 4.65a.5.5 0 000 .7l3.36 3.36a.74.74 0 001.06 0z"
  })));
};

var _path$5b;

function _extends$5g() { _extends$5g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5g.apply(this, arguments); }

var SvgCaretDownXs = function SvgCaretDownXs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5g({
    width: 5,
    height: 3
  }, props), _path$5b || (_path$5b = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h5L2.5 3 0 0z"
  })));
};

var _path$5a;

function _extends$5f() { _extends$5f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5f.apply(this, arguments); }

var SvgCaretDownS = function SvgCaretDownS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5f({
    width: 7,
    height: 4
  }, props), _path$5a || (_path$5a = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h7L3.5 4 0 0z"
  })));
};

var _path$59;

function _extends$5e() { _extends$5e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5e.apply(this, arguments); }

var SvgCaretDownM = function SvgCaretDownM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5e({
    width: 10,
    height: 10
  }, props), _path$59 || (_path$59 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71 3.22a.75.75 0 00-1.06 0L5 5.87 2.35 3.22a.75.75 0 00-1.06 0 .74.74 0 000 1.06l3.36 3.36a.5.5 0 00.7 0l3.36-3.36a.74.74 0 000-1.06z"
  })));
};

var _path$58, _path2$26;

function _extends$5d() { _extends$5d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5d.apply(this, arguments); }

var SvgZoomOut$1 = function SvgZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5d({
    width: 16,
    height: 16
  }, props), _path$58 || (_path$58 = /*#__PURE__*/React.createElement("path", {
    d: "M10.297 11.706l1.414-1.414 4.002 4.002-1.414 1.414zM6 0a6 6 0 106 6 6 6 0 00-6-6zm0 10.5A4.5 4.5 0 1110.5 6 4.51 4.51 0 016 10.5z"
  })), _path2$26 || (_path2$26 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5h6v2H3z"
  })));
};

var _path$57, _path2$25;

function _extends$5c() { _extends$5c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5c.apply(this, arguments); }

var SvgZoomIn$1 = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5c({
    width: 16,
    height: 16
  }, props), _path$57 || (_path$57 = /*#__PURE__*/React.createElement("path", {
    d: "M10.297 11.706l1.414-1.414 4.002 4.002-1.414 1.414zM6 0a6 6 0 106 6 6 6 0 00-6-6zm0 10.5A4.5 4.5 0 1110.5 6 4.51 4.51 0 016 10.5z"
  })), _path2$25 || (_path2$25 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H5v2H3v2h2v2h2V7h2V5H7V3z"
  })));
};

var _path$56, _path2$24;

function _extends$5b() { _extends$5b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5b.apply(this, arguments); }

var SvgVolume$1 = function SvgVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5b({
    width: 16,
    height: 16
  }, props), _path$56 || (_path$56 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12l5 4V-.08l-5 4V12zM0 4h3v8H0zM13.08 2.17l-.29.41a.3.3 0 000 .38 6.94 6.94 0 010 10.08.3.3 0 000 .38l.29.41a.21.21 0 00.33 0 7.95 7.95 0 000-11.74.21.21 0 00-.33.08z"
  })), _path2$24 || (_path2$24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.07 10.53a.33.33 0 000 .39l.3.43a.19.19 0 00.31 0 4.93 4.93 0 000-6.76.19.19 0 00-.31 0l-.3.43a.33.33 0 000 .39 3.91 3.91 0 010 5.06z"
  })));
};

var _path$55;

function _extends$5a() { _extends$5a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5a.apply(this, arguments); }

var SvgVisible$1 = function SvgVisible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5a({
    width: 16,
    height: 16
  }, props), _path$55 || (_path$55 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8a3 3 0 113 3 3 3 0 01-3-3zM0 8a9.36 9.36 0 008 5 9.37 9.37 0 008-5 9.42 9.42 0 00-8-5 9.46 9.46 0 00-8 5zm6 0a2 2 0 102-2 2 2 0 00-2 2z"
  })));
};

var _path$54, _path2$23;

function _extends$59() { _extends$59 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$59.apply(this, arguments); }

var SvgUserInactive$1 = function SvgUserInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$59({
    width: 16,
    height: 16
  }, props), _path$54 || (_path$54 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7c1.62 0 2.86-1.79 2.86-3.41A3.08 3.08 0 007 .44a2.93 2.93 0 00-2.87 3v.18C4.14 5.58 5.38 7 7 7zM6.75 12.5a4.76 4.76 0 013-4.41 5.58 5.58 0 00-2.38-.59h-.65C4.39 7.6 2.07 8.84 2 12.19V16h6.32a4.71 4.71 0 01-1.57-3.5z"
  })), _path2$23 || (_path2$23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9a3.5 3.5 0 103.5 3.5A3.5 3.5 0 0011.5 9zM9 13v-1h5v1z"
  })));
};

var _path$53, _path2$22;

function _extends$58() { _extends$58 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$58.apply(this, arguments); }

var SvgUpload$1 = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$58({
    width: 16,
    height: 16
  }, props), _path$53 || (_path$53 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14 12h3.69V6.75h2.96L7.99 0l-4.8 6.75h2.95V12z"
  })), _path2$22 || (_path2$22 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11v3H2v-3H0v5h16v-5h-2z"
  })));
};

var _path$52;

function _extends$57() { _extends$57 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$57.apply(this, arguments); }

var SvgUp$1 = function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$57({
    width: 16,
    height: 16
  }, props), _path$52 || (_path$52 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8L8 0 2 8h3.5v8h5V8z",
    fillRule: "evenodd"
  })));
};

var _path$51;

function _extends$56() { _extends$56 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$56.apply(this, arguments); }

var SvgUnpin$1 = function SvgUnpin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$56({
    width: 16,
    height: 16
  }, props), _path$51 || (_path$51 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.49L.32 15.54l5.04-3.45-1.61-1.6zM3.46 5.88h-.55L1.74 7.06l7.07 7.07 1.17-1.18v-.51L3.46 5.88zM7.39 4.76l3.69 3.74 1.71-1.7.97.97 2.12-2.13-5.66-5.65L8.1 2.11l.97.97-1.68 1.68zM2.4 1.13L1.26 2.25l12.28 12.36 1.12-1.05L2.4 1.13z"
  })));
};

var _path$50;

function _extends$55() { _extends$55 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$55.apply(this, arguments); }

var SvgUnlock$1 = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$55({
    width: 16,
    height: 16
  }, props), _path$50 || (_path$50 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0A3.5 3.5 0 009 3.5V6H2v9h11V6h-2V3.5a1.5 1.5 0 013 0V6h2V3.5A3.5 3.5 0 0012.5 0zM8 12H7V9h1z"
  })));
};

var _path$4$;

function _extends$54() { _extends$54 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$54.apply(this, arguments); }

var SvgUnlink$1 = function SvgUnlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$54({
    width: 16,
    height: 16
  }, props), _path$4$ || (_path$4$ = /*#__PURE__*/React.createElement("path", {
    d: "M11.12 2.76a1.51 1.51 0 012.12 0 1.49 1.49 0 010 2.12l-2.85 2.86 1.41 1.42 2.86-2.86a3.5 3.5 0 00-4.95-4.95L6.88 4.18l1.4 1.42zM4.77 13.37a1.5 1.5 0 01-2.12-2.12L5.5 8.39 4.09 7 1.24 9.84a3.5 3.5 0 005 4.95L9 12l-1.4-1.43zM1.26 2.53l12.28 12.36 1.12-1.05L2.4 1.41 1.26 2.53z"
  })));
};

var _path$4_;

function _extends$53() { _extends$53 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$53.apply(this, arguments); }

var SvgUndo$1 = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$53({
    width: 16,
    height: 16
  }, props), _path$4_ || (_path$4_ = /*#__PURE__*/React.createElement("path", {
    d: "M8 3L0 8l8 5v-3h4a4.11 4.11 0 014 2.19v-.92C16 8.5 14.25 6 11.49 6H8V3z"
  })));
};

var _path$4Z;

function _extends$52() { _extends$52 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$52.apply(this, arguments); }

var SvgUnavailable$1 = function SvgUnavailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$52({
    width: 16,
    height: 16
  }, props), _path$4Z || (_path$4Z = /*#__PURE__*/React.createElement("path", {
    d: "M8 1a7 7 0 107 7 7 7 0 00-7-7zM3 9V7h10v2z"
  })));
};

var _path$4Y;

function _extends$51() { _extends$51 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$51.apply(this, arguments); }

var SvgTreeView$1 = function SvgTreeView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$51({
    width: 16,
    height: 16
  }, props), _path$4Y || (_path$4Y = /*#__PURE__*/React.createElement("path", {
    d: "M16 10V5H9v2H4V4h3V0H0v4h3v10h6v2h7v-5H9v2H4V8h5v2h7z"
  })));
};

var _path$4X;

function _extends$50() { _extends$50 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$50.apply(this, arguments); }

var SvgTrash$1 = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$50({
    width: 16,
    height: 16
  }, props), _path$4X || (_path$4X = /*#__PURE__*/React.createElement("path", {
    d: "M10 2H6v-.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5zM5 2H2v2h12V2h-3V0H5zM3 5h10v11H3z"
  })));
};

var _path$4W;

function _extends$4$() { _extends$4$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4$.apply(this, arguments); }

var SvgTag$1 = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4$({
    width: 16,
    height: 16
  }, props), _path$4W || (_path$4W = /*#__PURE__*/React.createElement("path", {
    d: "M7.69 1H1v6.92L8.29 15 15 8.25zM4.5 6A1.5 1.5 0 116 4.5 1.5 1.5 0 014.5 6z"
  })));
};

var _path$4V;

function _extends$4_() { _extends$4_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4_.apply(this, arguments); }

var SvgSync$1 = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4_({
    width: 16,
    height: 16
  }, props), _path$4V || (_path$4V = /*#__PURE__*/React.createElement("path", {
    d: "M8 13a5.62 5.62 0 01-4.11-1.82L6 9.62l-6-2 .16 6.28 2.1-1.55A7.56 7.56 0 0015 10.25l-1.9-.64A5.57 5.57 0 018 13zM8 .94a7.58 7.58 0 00-7 4.84l1.94.64a5.53 5.53 0 019.22-1.63L10 6.32l6 2L15.84 2l-2.1 1.55A7.62 7.62 0 008 .94z"
  })));
};

var _path$4U;

function _extends$4Z() { _extends$4Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4Z.apply(this, arguments); }

var SvgSurveyEquipment$1 = function SvgSurveyEquipment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4Z({
    width: 16,
    height: 16
  }, props), _path$4U || (_path$4U = /*#__PURE__*/React.createElement("path", {
    d: "M13 2h-1v9h1v3h1a1 1 0 001-1V9zM4 14a1 1 0 001 1v1h6v-1a1 1 0 001-1v-2H4zM6 10h4a1 1 0 001-1V1a1 1 0 00-1-1H6a1 1 0 00-1 1v8a1 1 0 001 1zm2-7a2 2 0 11-2 2 2 2 0 012-2zM4 2H3L1 9v4a1 1 0 001 1h1v-3h1z"
  })));
};

var _path$4T;

function _extends$4Y() { _extends$4Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4Y.apply(this, arguments); }

var SvgSupport$1 = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4Y({
    width: 16,
    height: 16
  }, props), _path$4T || (_path$4T = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 108 8 8 8 0 00-8-8zm4.28 12.11c-.3.38-1.18 1.38-2.11 1.14-3.48-.93-6.51-6.06-5.57-9.6.25-.93 1.55-1.2 2-1.26a.24.24 0 01.25.14L7.86 5a.21.21 0 01-.09.26 4.14 4.14 0 01-1.88.64c-.46 1.73 1.32 4.72 3 5.16.11-.5 1.11-1.14 1.47-1.38a.23.23 0 01.27.05l1.64 2.09a.26.26 0 01.01.29z"
  })));
};

var _path$4S, _path2$21, _path3$n, _path4$2;

function _extends$4X() { _extends$4X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4X.apply(this, arguments); }

var SvgSubscription$1 = function SvgSubscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4X({
    width: 16,
    height: 16
  }, props), _path$4S || (_path$4S = /*#__PURE__*/React.createElement("path", {
    d: "M3 3h2v2H3zM6 3h4v2H6zM3 6h2v2H3zM3 9h2v2H3zM8 9H6v2h1.1A4.84 4.84 0 018 9z"
  })), _path2$21 || (_path2$21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.94 11.44l-1.24.11a2.3 2.3 0 01.05.45 2.79 2.79 0 11-1.68-2.52l-.74 1.29 3.55-.33-1.47-3.25-.7 1.21A3.94 3.94 0 0012 8a4 4 0 104 4 3.43 3.43 0 00-.06-.56z",
    fillRule: "evenodd"
  })), _path3$n || (_path3$n = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.42V6H6v2h3a5.53 5.53 0 011-.58z"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H2V2h9v5.1a5.05 5.05 0 012 0V0H0v15h8a4.92 4.92 0 01-1-3z"
  })));
};

var _path$4R;

function _extends$4W() { _extends$4W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4W.apply(this, arguments); }

var SvgSort$1 = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4W({
    width: 16,
    height: 16
  }, props), _path$4R || (_path$4R = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.54 9.38V3h-3.08v6.38H8L12 15l4-5.62h-2.46zM4 1L0 6.63h2.46V13h3.08V6.63H8L4 1z"
  })));
};

var _path$4Q;

function _extends$4V() { _extends$4V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4V.apply(this, arguments); }

var SvgSocialYoutube$1 = function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4V({
    width: 16,
    height: 16
  }, props), _path$4Q || (_path$4Q = /*#__PURE__*/React.createElement("path", {
    d: "M15.67 3.87a2.11 2.11 0 00-1.42-1.51A44.44 44.44 0 008 2a44.44 44.44 0 00-6.25.36A2.11 2.11 0 00.33 3.87 24.23 24.23 0 000 8a24.23 24.23 0 00.33 4.13 2.11 2.11 0 001.42 1.51A44.44 44.44 0 008 14a44.44 44.44 0 006.25-.36 2.11 2.11 0 001.42-1.51A24.23 24.23 0 0016 8a24.23 24.23 0 00-.33-4.13zM6 11V5l5 3z"
  })));
};

var _path$4P;

function _extends$4U() { _extends$4U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4U.apply(this, arguments); }

var SvgSocialTwitter$1 = function SvgSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4U({
    width: 16,
    height: 16
  }, props), _path$4P || (_path$4P = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.54a6.61 6.61 0 01-1.89.52 3.32 3.32 0 001.45-1.82 6.62 6.62 0 01-2.09.8 3.28 3.28 0 00-5.68 2.24 3.08 3.08 0 00.09.72 9.32 9.32 0 01-6.77-3.4A3.29 3.29 0 002.13 7a3.29 3.29 0 01-1.49-.43 3.28 3.28 0 002.64 3.26 3.22 3.22 0 01-1.49.06 3.3 3.3 0 003.07 2.28 6.58 6.58 0 01-4.08 1.4 5.11 5.11 0 01-.78-.05A9.22 9.22 0 005 15a9.27 9.27 0 009.34-9.34v-.42A6.79 6.79 0 0016 3.54z"
  })));
};

var _path$4O;

function _extends$4T() { _extends$4T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4T.apply(this, arguments); }

var SvgSocialLinkedin$1 = function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4T({
    width: 16,
    height: 16
  }, props), _path$4O || (_path$4O = /*#__PURE__*/React.createElement("path", {
    d: "M2.34 6h2.29v7H2.34zM2 3.5A1.5 1.5 0 113.5 5 1.5 1.5 0 012 3.5zM6 6h2v1c1.81-2 5-.9 5 1.12V13h-2.13V8.79c0-1.19-1.73-1.51-2.74-.19V13H6zM0 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2H2a2 2 0 00-2 2z"
  })));
};

var _path$4N, _path2$20, _circle$f;

function _extends$4S() { _extends$4S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4S.apply(this, arguments); }

var SvgSocialInstagram$1 = function SvgSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4S({
    width: 16,
    height: 16
  }, props), _path$4N || (_path$4N = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.44c2.14 0 2.39 0 3.23.05a4.33 4.33 0 011.49.27 2.67 2.67 0 011.52 1.52 4.33 4.33 0 01.27 1.49c0 .84.05 1.09.05 3.23s0 2.39-.05 3.23a4.33 4.33 0 01-.27 1.49 2.67 2.67 0 01-1.52 1.52 4.33 4.33 0 01-1.49.27c-.84 0-1.09.05-3.23.05s-2.39 0-3.23-.05a4.33 4.33 0 01-1.49-.27 2.67 2.67 0 01-1.52-1.52 4.33 4.33 0 01-.27-1.49c0-.84-.05-1.09-.05-3.23s0-2.39.05-3.23a4.33 4.33 0 01.27-1.49 2.67 2.67 0 011.52-1.52 4.33 4.33 0 011.49-.27c.84 0 1.09-.05 3.23-.05M8 0C5.83 0 5.55 0 4.7.05a5.85 5.85 0 00-1.94.37A4 4 0 00.42 2.76 5.85 5.85 0 00.05 4.7C0 5.55 0 5.83 0 8s0 2.45.05 3.3a5.85 5.85 0 00.37 1.94 4 4 0 002.34 2.34A5.85 5.85 0 004.7 16H8c2.17 0 2.44 0 3.3-.05a5.85 5.85 0 001.94-.37 4 4 0 002.34-2.34A5.85 5.85 0 0016 11.3c0-.85.05-1.13.05-3.3S16 5.55 16 4.7a5.85 5.85 0 00-.37-1.94A4 4 0 0013.24.42 5.85 5.85 0 0011.3.05C10.44 0 10.17 0 8 0z"
  })), _path2$20 || (_path2$20 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.89A4.11 4.11 0 1012.11 8 4.11 4.11 0 008 3.89zm0 6.78A2.67 2.67 0 1110.67 8 2.68 2.68 0 018 10.67z"
  })), _circle$f || (_circle$f = /*#__PURE__*/React.createElement("circle", {
    cx: 12.27,
    cy: 3.73,
    r: 0.96
  })));
};

var _path$4M;

function _extends$4R() { _extends$4R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4R.apply(this, arguments); }

var SvgSocialFacebook$1 = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4R({
    width: 16,
    height: 16
  }, props), _path$4M || (_path$4M = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H1a1 1 0 00-1 1v14a1 1 0 001 1h8.07V9.61H7V7.13h2.07V5.29A3 3 0 0111.76 2h.39a16.26 16.26 0 011.85.1v2.22h-1.27c-1 0-1.19.49-1.19 1.21v1.6h2.37l-.31 2.49h-2.06V16H15a1 1 0 001-1V1a1 1 0 00-1-1z"
  })));
};

var _circle$e, _path$4L, _path2$1$;

function _extends$4Q() { _extends$4Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4Q.apply(this, arguments); }

var SvgSocialBlog$1 = function SvgSocialBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4Q({
    width: 16,
    height: 16
  }, props), _circle$e || (_circle$e = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 13,
    r: 2
  })), _path$4L || (_path$4L = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1H1v2h.5A11.5 11.5 0 0113 14.5v.5h2v-.5A13.49 13.49 0 001.5 1z"
  })), _path2$1$ || (_path2$1$ = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6H1v2a4.19 4.19 0 01.5 0A6.5 6.5 0 018 14.5a4.19 4.19 0 010 .5h2v-.5A8.51 8.51 0 001.5 6z"
  })));
};

var _path$4K, _path2$1_, _path3$m;

function _extends$4P() { _extends$4P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4P.apply(this, arguments); }

var SvgSignOut$1 = function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4P({
    viewBox: "0 0 16 16"
  }, props), _path$4K || (_path$4K = /*#__PURE__*/React.createElement("path", {
    d: "M11 6V4l4.92 3.5L11 11V9H8V6z",
    fillRule: "evenodd"
  })), _path2$1_ || (_path2$1_ = /*#__PURE__*/React.createElement("path", {
    d: "M0 1h10v4H9V2H2.41L6 3.5V16l-6-2.5z"
  })), _path3$m || (_path3$m = /*#__PURE__*/React.createElement("path", {
    d: "M7 13h2v-3h1v4H7z"
  })));
};

var _path$4J;

function _extends$4O() { _extends$4O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4O.apply(this, arguments); }

var SvgShare$1 = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4O({
    width: 16,
    height: 16
  }, props), _path$4J || (_path$4J = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5a2.37 2.37 0 00.18.93L5 6.53A2.47 2.47 0 003.5 6a2.5 2.5 0 101.86 4.18l4.7 2.8a2.24 2.24 0 00-.06.52 2.5 2.5 0 102.5-2.5 2.45 2.45 0 00-1.86.84L6 9a2.87 2.87 0 000-.5 2.72 2.72 0 00-.18-1L11 4.47a2.5 2.5 0 10-1-2z"
  })));
};

var _path$4I;

function _extends$4N() { _extends$4N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4N.apply(this, arguments); }

var SvgSettings$1 = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4N({
    width: 16,
    height: 16
  }, props), _path$4I || (_path$4I = /*#__PURE__*/React.createElement("path", {
    d: "M15 9V6h-2.21a5.34 5.34 0 00-.49-1.18l1.56-1.56-2.12-2.12-1.56 1.56A5.34 5.34 0 009 2.21V0H6v2.21a5.34 5.34 0 00-1.18.49L3.26 1.14 1.14 3.26 2.7 4.82A5.34 5.34 0 002.21 6H0v3h2.21a5.34 5.34 0 00.49 1.18l-1.56 1.56 2.12 2.12 1.56-1.56a5.34 5.34 0 001.18.49V15h3v-2.21a5.34 5.34 0 001.18-.49l1.56 1.56 2.12-2.12-1.56-1.56A5.34 5.34 0 0012.79 9zm-5-1.5A2.48 2.48 0 117.52 5 2.5 2.5 0 0110 7.5z"
  })));
};

var _path$4H;

function _extends$4M() { _extends$4M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4M.apply(this, arguments); }

var SvgService$1 = function SvgService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4M({
    width: 16,
    height: 16
  }, props), _path$4H || (_path$4H = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 00-6.63 12.48L4.81 9a4 4 0 015.55-5l-2.8 2.79.1 1.55 1.55.1L12 5.64a4 4 0 01-5 5.55l-3.48 3.44A8 8 0 108 0z"
  })));
};

var _path$4G, _path2$1Z;

function _extends$4L() { _extends$4L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4L.apply(this, arguments); }

var SvgSelectNone$1 = function SvgSelectNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4L({
    width: 16,
    height: 16
  }, props), _path$4G || (_path$4G = /*#__PURE__*/React.createElement("path", {
    d: "M13 4v2h1v8H6v-1H4v3h12V4h-3z"
  })), _path2$1Z || (_path2$1Z = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H0v12h12zm-2 10H2V2h8z"
  })));
};

var _path$4F, _path2$1Y;

function _extends$4K() { _extends$4K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4K.apply(this, arguments); }

var SvgSelectAll$1 = function SvgSelectAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4K({
    width: 16,
    height: 16
  }, props), _path$4F || (_path$4F = /*#__PURE__*/React.createElement("path", {
    d: "M13 4v9H4v3h12V4h-3z"
  })), _path2$1Y || (_path2$1Y = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H0v12h12zM5 9.37L1.65 6 3 4.65l2 2 4-5L10.34 3z"
  })));
};

var _path$4E;

function _extends$4J() { _extends$4J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4J.apply(this, arguments); }

var SvgSecurity$1 = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4J({
    width: 16,
    height: 16
  }, props), _path$4E || (_path$4E = /*#__PURE__*/React.createElement("path", {
    d: "M14.15 2.65A8.54 8.54 0 018 0a8.54 8.54 0 01-6.15 2.65H1C1 12.79 7.25 16 8 16s7-3.21 7-13.39c-.18.02-.56.04-.85.04z"
  })));
};

var _path$4D;

function _extends$4I() { _extends$4I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4I.apply(this, arguments); }

var SvgSearch$1 = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4I({
    width: 16,
    height: 16
  }, props), _path$4D || (_path$4D = /*#__PURE__*/React.createElement("path", {
    d: "M10.297 11.706l1.414-1.414 4.002 4.002-1.414 1.414zM6 0a6 6 0 106 6 6 6 0 00-6-6zm0 10.5A4.5 4.5 0 1110.5 6 4.51 4.51 0 016 10.5z"
  })));
};

var _path$4C;

function _extends$4H() { _extends$4H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4H.apply(this, arguments); }

var SvgSave$1 = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4H({
    width: 16,
    height: 16
  }, props), _path$4C || (_path$4C = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H1v11l3 3h11zm-4 13h-1v-3H6v3H5v-4h6zm1-7H4V2h1v4h6V2h1z"
  })));
};

var _path$4B;

function _extends$4G() { _extends$4G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4G.apply(this, arguments); }

var SvgSaveAs$1 = function SvgSaveAs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4G({
    width: 16,
    height: 16
  }, props), _path$4B || (_path$4B = /*#__PURE__*/React.createElement("path", {
    d: "M6.86 12.93L6 16l3.07-.86h.01l-2.22-2.22v.01zM7.573 12.22l4.1-4.102 2.214 2.213-4.101 4.102zM14.12 6h-.19a.62.62 0 00-.32.17l-1.23 1.24 2.21 2.21 1.23-1.23a.62.62 0 00.18-.32v-.15A1.88 1.88 0 0014.12 6zM5 11v2H4v-3h4.37l4.53-4.53a1.67 1.67 0 01.83-.47H14V0H0v11l3 3h2.52L6 12.4 7.37 11zM3 1h1v4h6V1h1v5H3z"
  })));
};

var _path$4A;

function _extends$4F() { _extends$4F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4F.apply(this, arguments); }

var SvgReport$1 = function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4F({
    width: 16,
    height: 16
  }, props), _path$4A || (_path$4A = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H1v16h14zM3 4h5v1H3zm10 10H3v-1h1V8h2v5h1v-3h2v3h1V6h2v7h1zm0-11H3V2h10z"
  })));
};

var _path$4z, _path2$1X;

function _extends$4E() { _extends$4E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4E.apply(this, arguments); }

var SvgRename$1 = function SvgRename(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4E({
    viewBox: "0 0 16 16"
  }, props), _path$4z || (_path$4z = /*#__PURE__*/React.createElement("path", {
    d: "M12 1h1V0h-3v1h1v13h-1v1h3v-1h-1V1zM10 12H1V3h9V2H0v11h10v-1z"
  })), _path2$1X || (_path2$1X = /*#__PURE__*/React.createElement("path", {
    d: "M2 4h8v7H2zM13 2v1h2v9h-2v1h3V2h-3z"
  })));
};

var _path$4y;

function _extends$4D() { _extends$4D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4D.apply(this, arguments); }

var SvgRemove$1 = function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4D({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4y || (_path$4y = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7v2h12V7H2z",
    fill: "gray"
  })));
};

var _path$4x;

function _extends$4C() { _extends$4C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4C.apply(this, arguments); }

var SvgRedo$1 = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4C({
    width: 16,
    height: 16
  }, props), _path$4x || (_path$4x = /*#__PURE__*/React.createElement("path", {
    d: "M8 3v3H4.5C1.74 6 0 8.5 0 11.27v.92A4.11 4.11 0 014 10h4v3l8-5-8-5z"
  })));
};

var _path$4w;

function _extends$4B() { _extends$4B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4B.apply(this, arguments); }

var SvgRecommend$1 = function SvgRecommend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4B({
    width: 16,
    height: 16
  }, props), _path$4w || (_path$4w = /*#__PURE__*/React.createElement("path", {
    d: "M12.72 14.11s.07 0 .11-.11A1.26 1.26 0 0014 12.75a1.23 1.23 0 00-.25-.75.25.25 0 010-.5 1.25 1.25 0 000-2.5.25.25 0 01-.25-.25.26.26 0 01.27-.23A1.28 1.28 0 0015 7.25 1.25 1.25 0 0013.75 6h-5c0-1.44 1-2.56 1-4.95a1 1 0 10-2 0c0 2.24-4.17 5.24-4.17 6.8a1.08 1.08 0 01-.8.63 1 1 0 00-.72 1v3.91a1 1 0 00.82 1 1.56 1.56 0 011 .72 4.52 4.52 0 002.78 1h4a2.1 2.1 0 002.06-2z"
  })));
};

var _defs$3, _path$4v, _path2$1W, _path3$l;

function _extends$4A() { _extends$4A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4A.apply(this, arguments); }

var SvgRecentFile$1 = function SvgRecentFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4A({
    id: "recent-file_svg__assets",
    width: 16,
    height: 16
  }, props), _defs$3 || (_defs$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".recent-file_svg__cls-1{fill-rule:evenodd}"))), _path$4v || (_path$4v = /*#__PURE__*/React.createElement("path", {
    className: "recent-file_svg__cls-1",
    d: "M4 0L0 4h4V0z"
  })), _path2$1W || (_path2$1W = /*#__PURE__*/React.createElement("path", {
    className: "recent-file_svg__cls-1",
    d: "M11.5 6c.52 0 1.02.08 1.5.21V0H5v5H0v10h7.26A5.451 5.451 0 016 11.5C6 8.46 8.46 6 11.5 6z"
  })), _path3$l || (_path3$l = /*#__PURE__*/React.createElement("path", {
    className: "recent-file_svg__cls-1",
    d: "M11.5 7C9.01 7 7 9.01 7 11.5S9.01 16 11.5 16s4.5-2.01 4.5-4.5S13.99 7 11.5 7zm.5 5h-1V8h1v3h3v1h-3z"
  })));
};

var _path$4u;

function _extends$4z() { _extends$4z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4z.apply(this, arguments); }

var SvgQuantities$1 = function SvgQuantities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4z({
    width: 16,
    height: 16
  }, props), _path$4u || (_path$4u = /*#__PURE__*/React.createElement("path", {
    d: "M0 11h16v3H0zM8 0v6h3v4h2V6h3V0zm7 3H9V1h6zM1 15h14v1H1z"
  })));
};

var _path$4t, _path2$1V;

function _extends$4y() { _extends$4y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4y.apply(this, arguments); }

var SvgPublish$1 = function SvgPublish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4y({
    width: 16,
    height: 16
  }, props), _path$4t || (_path$4t = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H1v4h14zm-3 3H4v-2h8z"
  })), _path2$1V || (_path2$1V = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.37 5.91H3.79L7.99 0l4.2 5.91H9.61V10H6.37V5.91z"
  })));
};

var _path$4s, _path2$1U;

function _extends$4x() { _extends$4x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4x.apply(this, arguments); }

var SvgProperties$1 = function SvgProperties(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4x({
    width: 16,
    height: 16
  }, props), _path$4s || (_path$4s = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H2v16h12zm-1 13h-2v1h-1v-1H3v-1h7v-1h1v1h2zm0-3H6v1H5v-1H3V9h2V8h1v1h7zm0-4H3V1h10z"
  })), _path2$1U || (_path2$1U = /*#__PURE__*/React.createElement("path", {
    d: "M4 2h8v3H4z"
  })));
};

var _path$4r, _path2$1T;

function _extends$4w() { _extends$4w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4w.apply(this, arguments); }

var SvgProjectManagement$1 = function SvgProjectManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4w({
    width: 16,
    height: 16
  }, props), _path$4r || (_path$4r = /*#__PURE__*/React.createElement("path", {
    d: "M6.61 9a5.51 5.51 0 011.74-2H2V6h7v.61A5.44 5.44 0 0111 6V0H0v13h6.21a5.46 5.46 0 010-3H2V9zM2 3h7v1H2z"
  })), _path2$1T || (_path2$1T = /*#__PURE__*/React.createElement("path", {
    d: "M15.37 9.1a3.59 3.59 0 00-1.47-1.47 4.57 4.57 0 00-6.27 6.27 3.59 3.59 0 001.47 1.47 4.57 4.57 0 006.27-6.27zM15 12h-4V8h1v3h3z"
  })));
};

var _path$4q;

function _extends$4v() { _extends$4v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4v.apply(this, arguments); }

var SvgProfile$1 = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4v({
    width: 16,
    height: 16
  }, props), _path$4q || (_path$4q = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 108 8 8 8 0 00-8-8zm0 3.36a2.46 2.46 0 012.3 2.53A2.65 2.65 0 018 8.62a2.48 2.48 0 01-2.28-2.73A2.35 2.35 0 018 3.36zm4 10.38a7 7 0 01-8 0v-1A3.62 3.62 0 017.79 9h.52c1.94.08 3.69 1.09 3.69 4z"
  })));
};

var _path$4p;

function _extends$4u() { _extends$4u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4u.apply(this, arguments); }

var SvgProductsAndServices$1 = function SvgProductsAndServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4u({
    width: 16,
    height: 16
  }, props), _path$4p || (_path$4p = /*#__PURE__*/React.createElement("path", {
    d: "M7.52 0L0 3.35v8.14L7.48 16 15 11.49V3.35zM14 4.44L7.92 8.12v6.47l-.42.25-.42-.25V8.12L1 4.43V4l.5-.23 6 3.65 6-3.64.5.22z"
  })));
};

var _path$4o, _path2$1S, _path3$k;

function _extends$4t() { _extends$4t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4t.apply(this, arguments); }

var SvgPrint$1 = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4t({
    width: 16,
    height: 16
  }, props), _path$4o || (_path$4o = /*#__PURE__*/React.createElement("path", {
    d: "M14 3v2H2V3H0v10h2v-2h12v2h2V3h-2z"
  })), _path2$1S || (_path2$1S = /*#__PURE__*/React.createElement("path", {
    d: "M3 0h10v4H3zM12 12v3H4v-3H3v4h10v-4h-1z"
  })), _path3$k || (_path3$k = /*#__PURE__*/React.createElement("path", {
    d: "M5 12h6v2H5z"
  })));
};

var _path$4n;

function _extends$4s() { _extends$4s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4s.apply(this, arguments); }

var SvgPlaybackStop$1 = function SvgPlaybackStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4s({
    width: 16,
    height: 16
  }, props), _path$4n || (_path$4n = /*#__PURE__*/React.createElement("path", {
    d: "M2 2h12v12H2z"
  })));
};

var _path$4m, _path2$1R;

function _extends$4r() { _extends$4r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4r.apply(this, arguments); }

var SvgPlaybackShuffle$1 = function SvgPlaybackShuffle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4r({
    width: 16,
    height: 16
  }, props), _path$4m || (_path$4m = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 5.4l1.33 1.77L6.38 5.5l-1-1.3A3 3 0 003 3H0v2h3a1 1 0 01.8.4zM16 12l-4-3v2h-1a1 1 0 01-.8-.4L8.87 8.83 7.62 10.5l1 1.3A3 3 0 0011 13h1v2z"
  })), _path2$1R || (_path2$1R = /*#__PURE__*/React.createElement("path", {
    d: "M16 4l-4-3v2h-1a3 3 0 00-2.4 1.2l-4.8 6.4a1 1 0 01-.8.4H0v2h3a3 3 0 002.4-1.2l4.8-6.4A1 1 0 0111 5h1v2z",
    fillRule: "evenodd"
  })));
};

var _path$4l;

function _extends$4q() { _extends$4q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4q.apply(this, arguments); }

var SvgPlaybackRewind$1 = function SvgPlaybackRewind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4q({
    width: 16,
    height: 16
  }, props), _path$4l || (_path$4l = /*#__PURE__*/React.createElement("path", {
    d: "M8 8l8 5V3L8 8zM0 8l8 5V3L0 8z"
  })));
};

var _circle$d;

function _extends$4p() { _extends$4p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4p.apply(this, arguments); }

var SvgPlaybackRecord$1 = function SvgPlaybackRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4p({
    width: 16,
    height: 16
  }, props), _circle$d || (_circle$d = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6
  })));
};

var _path$4k;

function _extends$4o() { _extends$4o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4o.apply(this, arguments); }

var SvgPlaybackPrevious$1 = function SvgPlaybackPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4o({
    width: 16,
    height: 16
  }, props), _path$4k || (_path$4k = /*#__PURE__*/React.createElement("path", {
    d: "M4 8l9 5.73V2.27L4 8zM2 2v12h2V2H2z"
  })));
};

var _path$4j, _path2$1Q;

function _extends$4n() { _extends$4n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4n.apply(this, arguments); }

var SvgPlaybackPlay$1 = function SvgPlaybackPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4n({
    width: 16,
    height: 16
  }, props), _path$4j || (_path$4j = /*#__PURE__*/React.createElement("path", {
    d: "M14 8L3 15V1l11 7z"
  })), _path2$1Q || (_path2$1Q = /*#__PURE__*/React.createElement("path", {
    d: "M14 8L3 15V1l11 7z"
  })));
};

var _path$4i;

function _extends$4m() { _extends$4m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4m.apply(this, arguments); }

var SvgPlaybackPause$1 = function SvgPlaybackPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4m({
    width: 16,
    height: 16
  }, props), _path$4i || (_path$4i = /*#__PURE__*/React.createElement("path", {
    d: "M3 2h4v12H3zM9 2h4v12H9z"
  })));
};

var _path$4h;

function _extends$4l() { _extends$4l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4l.apply(this, arguments); }

var SvgPlaybackNext$1 = function SvgPlaybackNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4l({
    width: 16,
    height: 16
  }, props), _path$4h || (_path$4h = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.73L12 8 3 2.27v11.46zM12 2v12h2V2h-2z"
  })));
};

var _path$4g;

function _extends$4k() { _extends$4k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4k.apply(this, arguments); }

var SvgPlaybackLoop$1 = function SvgPlaybackLoop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4k({
    width: 16,
    height: 16
  }, props), _path$4g || (_path$4g = /*#__PURE__*/React.createElement("path", {
    d: "M9 4L5 1v2H3a3 3 0 00-3 3v5a3 3 0 003 3h1v-2H3a1 1 0 01-1-1V6a1 1 0 011-1h2v2zM13 3h-1v2h1a1 1 0 011 1v5a1 1 0 01-1 1h-2v-2l-4 3 4 3v-2h2a3 3 0 003-3V6a3 3 0 00-3-3z"
  })));
};

var _path$4f;

function _extends$4j() { _extends$4j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4j.apply(this, arguments); }

var SvgPlaybackGoToStart$1 = function SvgPlaybackGoToStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4j({
    width: 16,
    height: 16
  }, props), _path$4f || (_path$4f = /*#__PURE__*/React.createElement("path", {
    d: "M16 3L9 7.38V3L2 7.38V2H0v12h2V8.63L9 13V8.63L16 13V3z"
  })));
};

var _path$4e;

function _extends$4i() { _extends$4i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4i.apply(this, arguments); }

var SvgPlaybackGoToEnd$1 = function SvgPlaybackGoToEnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4i({
    width: 16,
    height: 16
  }, props), _path$4e || (_path$4e = /*#__PURE__*/React.createElement("path", {
    d: "M14 2v5.38L7 3v4.38L0 3v10l7-4.37V13l7-4.37V14h2V2h-2z"
  })));
};

var _path$4d;

function _extends$4h() { _extends$4h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4h.apply(this, arguments); }

var SvgPlaybackFastForward$1 = function SvgPlaybackFastForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4h({
    width: 16,
    height: 16
  }, props), _path$4d || (_path$4d = /*#__PURE__*/React.createElement("path", {
    d: "M0 13l8-5-8-5v10zM16 8L8 3v10l8-5z"
  })));
};

var _path$4c;

function _extends$4g() { _extends$4g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4g.apply(this, arguments); }

var SvgPlaceholder$1 = function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4g({
    width: 16,
    height: 16
  }, props), _path$4c || (_path$4c = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 12.58a7.22 7.22 0 01-2.38 1.79l.41.91a8 8 0 002.72-2l-.75-.65zM8.51 15a7.08 7.08 0 01-2.95-.42l-.35.94a8.05 8.05 0 003.37.48l-.07-1zM3.42 13.3a7.36 7.36 0 01-1.79-2.38l-.9.41a7.92 7.92 0 002 2.72l.65-.75zM1 8.51a7.08 7.08 0 01.42-2.95L.5 5.21A8.05 8.05 0 000 8.58l1-.07zM2.7 3.42a7.29 7.29 0 012.39-1.79l-.42-.9A8 8 0 002 2.77l.75.65zM7.49 1a7.08 7.08 0 012.95.42l.35-.92A8.05 8.05 0 007.42 0l.07 1zM12.58 2.7a7.16 7.16 0 011.79 2.39l.91-.42a8 8 0 00-2-2.72l-.65.75zM15 7.49a7.08 7.08 0 01-.42 2.95l.94.35A8.05 8.05 0 0016 7.42l-1 .07z"
  })));
};

var _path$4b;

function _extends$4f() { _extends$4f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4f.apply(this, arguments); }

var SvgPin$1 = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4f({
    width: 16,
    height: 16
  }, props), _path$4b || (_path$4b = /*#__PURE__*/React.createElement("path", {
    d: "M10.22.1L8.1 2.22l1 1L6.24 6H2.91L1.74 7.17l7.07 7.07L10 13.06V9.74l2.83-2.83 1 1 2.12-2.12zM3.75 10.6L.32 15.66l5.04-3.45-1.61-1.61z"
  })));
};

var _path$4a, _path2$1P;

function _extends$4e() { _extends$4e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4e.apply(this, arguments); }

var SvgPhotos$1 = function SvgPhotos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4e({
    width: 16,
    height: 16
  }, props), _path$4a || (_path$4a = /*#__PURE__*/React.createElement("path", {
    d: "M0 16h13V3H0zM9.5 5A1.5 1.5 0 118 6.5 1.5 1.5 0 019.5 5zM2 9.84l.29-.41a2 2 0 013.3 0l2.53 3.48a.28.28 0 00.44 0l.95-1.17a1.23 1.23 0 011-.46 1.14 1.14 0 01.52.13V14H2z"
  })), _path2$1P || (_path2$1P = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H1v2h13v12h2V0h-2z"
  })));
};

var _path$49;

function _extends$4d() { _extends$4d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4d.apply(this, arguments); }

var SvgPermissionIndividual$1 = function SvgPermissionIndividual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4d({
    width: 16,
    height: 16
  }, props), _path$49 || (_path$49 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72 7.49C5.39 7.6 3.07 8.84 3 12.19V16h10v-3.5c0-3.64-2.2-4.9-4.63-5h-.65zM8 7c1.62 0 2.86-1.78 2.86-3.41A3.08 3.08 0 008 .44a2.93 2.93 0 00-2.86 3.17C5.14 5.58 6.38 7 8 7z"
  })));
};

var _path$48;

function _extends$4c() { _extends$4c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4c.apply(this, arguments); }

var SvgPermissionGroup$1 = function SvgPermissionGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4c({
    width: 16,
    height: 16
  }, props), _path$48 || (_path$48 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72 7.49C1.39 7.6.07 8.84 0 12.19V16h8v-3.5c0-3.64-1.2-4.9-3.63-5h-.65zM4 7c1.62 0 2.86-1.76 2.86-3.39A3.08 3.08 0 004 .44a2.93 2.93 0 00-2.86 3.17C1.14 5.58 2.38 7 4 7zM11.56 8.57c1.34 0 2.37-1.48 2.37-2.82a2.56 2.56 0 00-2.37-2.63 2.43 2.43 0 00-2.37 2.63 2.56 2.56 0 002.37 2.82zM11.86 9h-.53a2.78 2.78 0 00-2.51 1.3A11.94 11.94 0 019 12.5V16h5.87v-2.9c0-3.01-.99-4.05-3.01-4.1z"
  })));
};

var _path$47, _path2$1O;

function _extends$4b() { _extends$4b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4b.apply(this, arguments); }

var SvgPaste$1 = function SvgPaste(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4b({
    width: 16,
    height: 16
  }, props), _path$47 || (_path$47 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6h3V2H9v1H1V2H0v12h7V6zM16 10h-3V7l3 3z"
  })), _path2$1O || (_path2$1O = /*#__PURE__*/React.createElement("path", {
    d: "M12 11V7H8v9h8v-5h-4zM7.5 1H7V0H3v1h-.5a.5.5 0 00-.5.5V2h6v-.5a.5.5 0 00-.5-.5z"
  })));
};

var _path$46, _circle$c;

function _extends$4a() { _extends$4a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4a.apply(this, arguments); }

var SvgOnlineViewers$1 = function SvgOnlineViewers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4a({
    width: 16,
    height: 16
  }, props), _path$46 || (_path$46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29 11.25h2.42A10 10 0 017.25 10V7.75H2.76a13 13 0 00.53 3.5zM2.76 7.25h4.49v-3.5h-4a13.43 13.43 0 00-.49 3.5zM7.75 0v3.25h3.81A9 9 0 0010 .45 7.57 7.57 0 007.75 0zM7.25 3.25V0A7.57 7.57 0 005 .45a9 9 0 00-1.52 2.8zM4.77 13.08a2.17 2.17 0 01.46-1.33H3.45A9 9 0 005 14.55l.54.17-.19-.2a2.13 2.13 0 01-.58-1.44zM12.17 8.89a10.57 10.57 0 00.07-1.14H7.75v1.91A6.59 6.59 0 0111 8.77a6.37 6.37 0 011.17.12zM11.72 3.75h-4v3.5h4.49a13.43 13.43 0 00-.49-3.5zM12.74 7.25H15a7.45 7.45 0 00-1-3.5h-1.75a14 14 0 01.49 3.5zM2.75 11.25a14.42 14.42 0 01-.49-3.5H0a7.45 7.45 0 001 3.5zM2.75 3.75H1a7.45 7.45 0 00-1 3.5h2.26a14 14 0 01.49-3.5zM2.9 11.75H1.32A7.58 7.58 0 004 14.14a10.33 10.33 0 01-1.1-2.39zM12.74 7.75c0 .43 0 .85-.07 1.27a8 8 0 011.94.84A7.3 7.3 0 0015 7.75zM12.1 3.25h1.58A7.54 7.54 0 0011 .86a10.31 10.31 0 011.1 2.39zM2.9 3.25A10.31 10.31 0 014 .86a7.54 7.54 0 00-2.68 2.39zM15.77 12.42c-1.31-1.49-5.26-4.55-9.52 0a.91.91 0 00-.23.62 1 1 0 00.23.63A6.77 6.77 0 0011.08 16a5.47 5.47 0 004.69-2.38A1 1 0 0016 13a.94.94 0 00-.23-.58zM11 15a2 2 0 112-2 2 2 0 01-2 2z"
  })), _circle$c || (_circle$c = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 13,
    r: 1
  })));
};

var _path$45;

function _extends$49() { _extends$49 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$49.apply(this, arguments); }

var SvgNotification$1 = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$49({
    width: 16,
    height: 16
  }, props), _path$45 || (_path$45 = /*#__PURE__*/React.createElement("path", {
    d: "M11.84 8.77V6.52a4.17 4.17 0 00-3.1-4.18V.62A.62.62 0 008.12 0H6.88a.62.62 0 00-.62.62v1.67a4.26 4.26 0 00-3.1 4.23v2.25a3.26 3.26 0 01-2.16 3V13h13v-1.24a3.25 3.25 0 01-2.16-2.99zM7.5 16a2.25 2.25 0 002.09-2H5.41a2.25 2.25 0 002.09 2z"
  })));
};

var _path$44;

function _extends$48() { _extends$48 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$48.apply(this, arguments); }

var SvgNotificationOff$1 = function SvgNotificationOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$48({
    width: 16,
    height: 16
  }, props), _path$44 || (_path$44 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.5a3.58 3.58 0 01-.11-.73V6.52a4.17 4.17 0 00-3.15-4.17V.62A.62.62 0 008.12 0H6.88a.62.62 0 00-.62.62v1.67a3.87 3.87 0 00-1 .43zM3.23 5.76a4.77 4.77 0 00-.06.76V8.77a3.25 3.25 0 01-2.16 3V13h9.42zM2.42 1.26L1.28 2.38l12.28 12.36 1.12-1.05L2.42 1.26zM7.5 16a2.25 2.25 0 002.09-2H5.41a2.25 2.25 0 002.09 2z"
  })));
};

var _path$43;

function _extends$47() { _extends$47 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$47.apply(this, arguments); }

var SvgNotEditable$1 = function SvgNotEditable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$47({
    width: 16,
    height: 16
  }, props), _path$43 || (_path$43 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38 11.08l3.54 3.54L0 16l1.38-4.92zM13 0h-.31a1 1 0 00-.52.27l-2.09 2.11 3.54 3.54 2.09-2.09a1 1 0 00.29-.52 1.94 1.94 0 000-.24V3a3 3 0 00-3-3zM11 8.54l1.77-1.77-3.54-3.54-1.74 1.74L11 8.54zM4.96 7.5l-2.73 2.73 3.54 3.54 2.72-2.72L4.96 7.5zM2.4 1.24L1.26 2.36l12.28 12.36 1.12-1.05L2.4 1.24z"
  })));
};

var _path$42;

function _extends$46() { _extends$46 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$46.apply(this, arguments); }

var SvgMute$1 = function SvgMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$46({
    width: 16,
    height: 16
  }, props), _path$42 || (_path$42 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 8.03l1.68-1.61-.76-.75L13 7.33l-1.62-1.66-.76.75 1.68 1.61-1.68 1.62.76.75L13 8.73l1.62 1.67.76-.75-1.68-1.62zM4 12.02L9 16V0L4 3.98v8.04zM0 4h3v8H0z"
  })));
};

var _circle$b, _circle2$5, _circle3$1;

function _extends$45() { _extends$45 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$45.apply(this, arguments); }

var SvgMore$1 = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$45({
    width: 16,
    height: 16
  }, props), _circle$b || (_circle$b = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 8.5,
    r: 1.5
  })), _circle2$5 || (_circle2$5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 8.5,
    r: 1.5
  })), _circle3$1 || (_circle3$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 8.5,
    r: 1.5
  })));
};

var _circle$a, _circle2$4, _circle3;

function _extends$44() { _extends$44 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$44.apply(this, arguments); }

var SvgMoreVertical$1 = function SvgMoreVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$44({
    width: 16,
    height: 16
  }, props), _circle$a || (_circle$a = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 14.5,
    r: 1.5
  })), _circle2$4 || (_circle2$4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 8.5,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 2.5,
    r: 1.5
  })));
};

var _path$41;

function _extends$43() { _extends$43 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$43.apply(this, arguments); }

var SvgMinimize$1 = function SvgMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$43({
    width: 16,
    height: 16
  }, props), _path$41 || (_path$41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16h8V8H0zm2-6h4v4H2zM15.71 1.71L14.29.29l-3.52 3.52-1.76-1.77L8 8l5.96-1.01-1.77-1.76 3.52-3.52z",
    fillRule: "evenodd"
  })));
};

var _path$40;

function _extends$42() { _extends$42 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$42.apply(this, arguments); }

var SvgMaximize$1 = function SvgMaximize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$42({
    width: 16,
    height: 16
  }, props), _path$40 || (_path$40 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1l1.77 1.77L8.59 6H0v10h10V7.41l3.22-3.22L15 6l1-6zM8 14H2V8h6z",
    fillRule: "evenodd"
  })));
};

var _path$3$, _path2$1N;

function _extends$41() { _extends$41 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$41.apply(this, arguments); }

var SvgManageAccess$1 = function SvgManageAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$41({
    width: 16,
    height: 16
  }, props), _path$3$ || (_path$3$ = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.63c1.51 0 2.66-1.63 2.66-3.18A2.87 2.87 0 005 .5a2.72 2.72 0 00-2.66 3c0 1.79 1.15 3.13 2.66 3.13zM15 13.2v-1.4h-1a2.66 2.66 0 00-.23-.55l.73-.73-1-1-.73.73a2.66 2.66 0 00-.57-.25V9h-1.4v1a2.66 2.66 0 00-.55.23l-.73-.73-1 1 .73.73a2.66 2.66 0 00-.25.57H8v1.4h1a2.66 2.66 0 00.23.55l-.73.73 1 1 .73-.73a2.66 2.66 0 00.55.23v1h1.4V15a2.66 2.66 0 00.55-.23l.73.73 1-1-.73-.73a2.66 2.66 0 00.27-.57zm-3.49.47a1.17 1.17 0 111.16-1.17 1.18 1.18 0 01-1.16 1.17z"
  })), _path2$1N || (_path2$1N = /*#__PURE__*/React.createElement("path", {
    d: "M8.44 9.22A4.26 4.26 0 005 7.12a4.12 4.12 0 00-4 4.33V15h6.76a4.47 4.47 0 01.68-5.78z"
  })));
};

var _path$3_;

function _extends$40() { _extends$40 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$40.apply(this, arguments); }

var SvgMail$1 = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$40({
    width: 16,
    height: 16
  }, props), _path$3_ || (_path$3_ = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.8V3.7l-4 4zM.21 13H14.8l-4.55-4.55L7.4 11.3 4.66 8.56zM0 3.9v7.89l3.94-3.95zM0 2v.48l7.4 7.4L15 2.3V2z"
  })));
};

var _path$3Z;

function _extends$3$() { _extends$3$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3$.apply(this, arguments); }

var SvgLock$1 = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3$({
    width: 16,
    height: 16
  }, props), _path$3Z || (_path$3Z = /*#__PURE__*/React.createElement("path", {
    d: "M11 6v-.5a3.5 3.5 0 00-7 0V6H2v9h11V6zm-5-.5a1.5 1.5 0 013 0V6H6zM8 12H7V9h1z"
  })));
};

var _path$3Y;

function _extends$3_() { _extends$3_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3_.apply(this, arguments); }

var SvgLocation$1 = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3_({
    width: 16,
    height: 16
  }, props), _path$3Y || (_path$3Y = /*#__PURE__*/React.createElement("path", {
    d: "M6.06 5A1.94 1.94 0 118 7a1.94 1.94 0 01-1.94-2zM3 5.05c0 2.79 2.55 6.74 5 11 2.47-4.24 5-8.16 5-10.95a5 5 0 10-10 0z"
  })));
};

var _path$3X;

function _extends$3Z() { _extends$3Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Z.apply(this, arguments); }

var SvgList$1 = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3Z({
    width: 16,
    height: 16
  }, props), _path$3X || (_path$3X = /*#__PURE__*/React.createElement("path", {
    d: "M4 2h11v2H4zM1 2h2v2H1zM4 7h11v2H4zM1 7h2v2H1zM4 12h11v2H4zM1 12h2v2H1z"
  })));
};

var _path$3W, _path2$1M;

function _extends$3Y() { _extends$3Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Y.apply(this, arguments); }

var SvgLink$1 = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3Y({
    width: 16,
    height: 16
  }, props), _path$3W || (_path$3W = /*#__PURE__*/React.createElement("path", {
    d: "M14.66 1.35a3.49 3.49 0 00-4.95 0L6 5.06a3.49 3.49 0 000 5l.19.16 1.23-1.28a.26.26 0 000-.35 1.51 1.51 0 010-2.12l3.71-3.71a1.51 1.51 0 012.12 0 1.49 1.49 0 010 2.12l-1.78 1.78A4.7 4.7 0 0111.94 9l2.72-2.7a3.51 3.51 0 000-4.95z"
  })), _path2$1M || (_path2$1M = /*#__PURE__*/React.createElement("path", {
    d: "M9.69 6L8.46 7.19a.26.26 0 000 .35 1.51 1.51 0 010 2.12l-3.7 3.71a1.51 1.51 0 01-2.12 0 1.49 1.49 0 010-2.12l1.77-1.78a4.7 4.7 0 01-.47-2.35L1.22 9.83a3.5 3.5 0 005 4.95l3.71-3.71a3.49 3.49 0 000-4.95z"
  })));
};

var _defs$2, _g$1;

function _extends$3X() { _extends$3X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3X.apply(this, arguments); }

var SvgLibrary$1 = function SvgLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3X({
    viewBox: "0 0 16 16"
  }, props), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "library_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  })))), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#library_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 5H0v8h3zM3 14H0v2h3zM3 2H0v2h3zM13.25 5.22l-2.9.78 2 7.1 2.9-.8zM15.47 13.28l-2.89.79.53 1.93 2.89-.79zM12.46 2.34l-2.89.79.52 1.87L13 4.25zM8 14H5v2h3zM8 0H5v2h3zM8 3H5v10h3z"
  }))));
};

var _path$3V;

function _extends$3W() { _extends$3W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3W.apply(this, arguments); }

var SvgItem$1 = function SvgItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3W({
    width: 16,
    height: 16
  }, props), _path$3V || (_path$3V = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0v16h15zm-3 13H3v-1h9zm0-3H3V9h9zm0-3H3V6h9zm0-3H3V3h9z"
  })));
};

var _path$3U;

function _extends$3V() { _extends$3V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3V.apply(this, arguments); }

var SvgInfo$1 = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3V({
    width: 16,
    height: 16
  }, props), _path$3U || (_path$3U = /*#__PURE__*/React.createElement("path", {
    d: "M8 1a7 7 0 107 7 7 7 0 00-7-7zm1 11H7V7h2zM8 6.25A1.25 1.25 0 119.25 5 1.25 1.25 0 018 6.25z"
  })));
};

var _path$3T, _path2$1L;

function _extends$3U() { _extends$3U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3U.apply(this, arguments); }

var SvgInbox$1 = function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3U({
    width: 16,
    height: 16
  }, props), _path$3T || (_path$3T = /*#__PURE__*/React.createElement("path", {
    d: "M10.82 11a3 3 0 01-5.64 0H1v5h14v-5zM1 0v10h1V3h12v7h1V0H1z"
  })), _path2$1L || (_path2$1L = /*#__PURE__*/React.createElement("path", {
    d: "M3 4v6h3a2 2 0 004 0h3V4z"
  })));
};

var _path$3S, _path2$1K, _path3$j;

function _extends$3T() { _extends$3T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3T.apply(this, arguments); }

var SvgImport$1 = function SvgImport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3T({
    width: 16,
    height: 16
  }, props), _path$3S || (_path$3S = /*#__PURE__*/React.createElement("path", {
    d: "M12 0v4h4l-4-4z"
  })), _path2$1K || (_path2$1K = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H3v4.76L9.66 9.5 3 14.24V15h13V5h-5V0z"
  })), _path3$j || (_path3$j = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.02 8.15V6l4.92 3.5L3.02 13v-2.15H0v-2.7h3.02z"
  })));
};

var _path$3R, _path2$1J;

function _extends$3S() { _extends$3S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3S.apply(this, arguments); }

var SvgHome$1 = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3S({
    width: 16,
    height: 16
  }, props), _path$3R || (_path$3R = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.59V2h-2v1.59l-3-3-8 8L1.41 10 2 9.41V15h4v-5h4v5h4V9.41l.59.59L16 8.59l-3-3z"
  })), _path2$1J || (_path2$1J = /*#__PURE__*/React.createElement("path", {
    d: "M7 11h2v4H7z"
  })));
};

var _path$3Q;

function _extends$3R() { _extends$3R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3R.apply(this, arguments); }

var SvgHierarchy$1 = function SvgHierarchy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3R({
    width: 16,
    height: 16
  }, props), _path$3Q || (_path$3Q = /*#__PURE__*/React.createElement("path", {
    d: "M3 0v7h4v2H2v3H0v4h5v-4H3v-2h9v2h-2v4h5v-4h-2V9H8V7h4V0z"
  })));
};

var _path$3P;

function _extends$3Q() { _extends$3Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Q.apply(this, arguments); }

var SvgHidden$1 = function SvgHidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3Q({
    width: 16,
    height: 16
  }, props), _path$3P || (_path$3P = /*#__PURE__*/React.createElement("path", {
    d: "M5.61 10a3.13 3.13 0 01-.74-2.2l-2.6-2.59A9.74 9.74 0 000 8a9.37 9.37 0 008 5 8.09 8.09 0 001.83-.23l-1.66-1.66A3.12 3.12 0 015.61 10zM10.23 5.74a3.13 3.13 0 01.91 2.5l2.58 2.57A9.57 9.57 0 0016 8a9.46 9.46 0 00-8-5 8.25 8.25 0 00-1.85.23l1.6 1.61a3.12 3.12 0 012.48.9zM1.25 2.36l12.29 12.36 1.12-1.05L2.4 1.24 1.25 2.36z"
  })));
};

var _path$3O;

function _extends$3P() { _extends$3P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3P.apply(this, arguments); }

var SvgHelp$1 = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3P({
    width: 16,
    height: 16
  }, props), _path$3O || (_path$3O = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 108 8 8 8 0 00-8-8zm1 14H7v-2h2zm1-5.55c-.62.29-1 .5-1 1V11H7V8.92a1.88 1.88 0 01.59-1.45c.46-.41 2.16-.91 2.16-1.88 0-.59-.3-1.26-1.52-1.26-1.48 0-2 2.33-2 2.33l-1.78-.41s.41-3.86 3.8-3.86a3.33 3.33 0 013.52 3.13A3.17 3.17 0 0110 8.45z"
  })));
};

var _path$3N;

function _extends$3O() { _extends$3O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3O.apply(this, arguments); }

var SvgGrid$1 = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3O({
    width: 16,
    height: 16
  }, props), _path$3N || (_path$3N = /*#__PURE__*/React.createElement("path", {
    d: "M7 9H1v6h6zm0-8H1v6h6zm8 8H9v6h6zm0-8H9v6h6z"
  })));
};

var _path$3M, _path2$1I;

function _extends$3N() { _extends$3N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3N.apply(this, arguments); }

var SvgGraph$1 = function SvgGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3N({
    width: 16,
    height: 16
  }, props), _path$3M || (_path$3M = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.21l3 3L14.85.85l-.7-.7L8.5 5.79l-3-3L.15 8.15l.7.7L5.5 4.21zM0 12h3v4H0z"
  })), _path2$1I || (_path2$1I = /*#__PURE__*/React.createElement("path", {
    d: "M4 8h3v8H4zM8 9h3v7H8zM12 6h3v10h-3z"
  })));
};

var _path$3L;

function _extends$3M() { _extends$3M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3M.apply(this, arguments); }

var SvgGlobe$1 = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3M({
    width: 16,
    height: 16
  }, props), _path$3L || (_path$3L = /*#__PURE__*/React.createElement("path", {
    d: "M2.76 7.25h4.49v-3.5h-4a13.43 13.43 0 00-.49 3.5zM7.25 3.25V0A7.57 7.57 0 005 .45a9 9 0 00-1.52 2.8zM3.28 11.25h4v-3.5H2.76a13.43 13.43 0 00.52 3.5zM12.1 3.25h1.58A7.54 7.54 0 0011 .86a10.31 10.31 0 011.1 2.39zM7.25 15v-3.25H3.44A9 9 0 005 14.55a7.57 7.57 0 002.25.45zM12.25 3.75a14 14 0 01.49 3.5H15a7.45 7.45 0 00-1-3.5zM10 .45A7.57 7.57 0 007.75 0v3.25h3.81A9 9 0 0010 .45zM12.25 11.25H14a7.45 7.45 0 001-3.5h-2.26a14 14 0 01-.49 3.5zM12.24 7.75H7.75v3.5h4a13.43 13.43 0 00.49-3.5zM2.9 11.75H1.32A7.54 7.54 0 004 14.14a10.31 10.31 0 01-1.1-2.39zM0 7.75a7.45 7.45 0 001 3.5h1.75a14 14 0 01-.49-3.5zM12.1 11.75a10.31 10.31 0 01-1.1 2.39 7.54 7.54 0 002.69-2.39zM1 3.75a7.45 7.45 0 00-1 3.5h2.26a14 14 0 01.49-3.5zM7.75 11.75V15a7.57 7.57 0 002.25-.45 9 9 0 001.52-2.8zM11.72 3.75h-4v3.5h4.49a13.43 13.43 0 00-.49-3.5zM2.9 3.25A10.31 10.31 0 014 .86a7.54 7.54 0 00-2.68 2.39z"
  })));
};

var _path$3K;

function _extends$3L() { _extends$3L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3L.apply(this, arguments); }

var SvgForward$1 = function SvgForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3L({
    width: 16,
    height: 16
  }, props), _path$3K || (_path$3K = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5H0v5h8V14l8-6-8-6z",
    fillRule: "evenodd"
  })));
};

var _path$3J;

function _extends$3K() { _extends$3K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3K.apply(this, arguments); }

var SvgForums$1 = function SvgForums(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3K({
    width: 16,
    height: 16
  }, props), _path$3J || (_path$3J = /*#__PURE__*/React.createElement("path", {
    d: "M13.29 8.81a2.05 2.05 0 00-1.29.42V14h4v-2c0-2.28-.78-3.11-2.31-3.18h-.4zM8.24 8h-.5C5.92 8.08 5.06 9 5 11.49V14h6v-2.23c0-2.71-.86-3.69-2.76-3.77zM13.5 7.88a1.91 1.91 0 001.69-2 1.91 1.91 0 00-1.69-2 1.8 1.8 0 00-1.69 2 1.77 1.77 0 001.69 2zM0 12v2h4V9.23a2.05 2.05 0 00-1.29-.42h-.4C.78 8.87 0 9.7 0 12zM2.5 3.88a1.91 1.91 0 00-1.69 2 1.91 1.91 0 001.69 2 1.77 1.77 0 001.69-2 1.8 1.8 0 00-1.69-2zM8 6.75a2.32 2.32 0 002.06-2.45A2.32 2.32 0 008 1.85 2.21 2.21 0 005.94 4.3 2.17 2.17 0 008 6.75z"
  })));
};

var _path$3I;

function _extends$3J() { _extends$3J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3J.apply(this, arguments); }

var SvgFolder$1 = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3J({
    width: 16,
    height: 16
  }, props), _path$3I || (_path$3I = /*#__PURE__*/React.createElement("path", {
    d: "M0 2v2h6.34l1-1-1-1zm0 3v9h15V3H9L7 5z"
  })));
};

var _path$3H, _path2$1H;

function _extends$3I() { _extends$3I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3I.apply(this, arguments); }

var SvgFolderOpen$1 = function SvgFolderOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3I({
    width: 16,
    height: 16
  }, props), _path$3H || (_path$3H = /*#__PURE__*/React.createElement("path", {
    d: "M12 5V4H8L6 2H0v9.76L3.38 5H12z"
  })), _path2$1H || (_path2$1H = /*#__PURE__*/React.createElement("path", {
    d: "M4 6l-4 8h12l4-8H4z"
  })));
};

var _path$3G;

function _extends$3H() { _extends$3H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3H.apply(this, arguments); }

var SvgFlag$1 = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3H({
    width: 16,
    height: 16
  }, props), _path$3G || (_path$3G = /*#__PURE__*/React.createElement("path", {
    d: "M12.13 2.3a7 7 0 01-3.05.7 7.06 7.06 0 01-3-.67A3.56 3.56 0 004.54 2a3.49 3.49 0 00-2.39 1l4 6a3.45 3.45 0 012.42-1c1.48 0 2.32 1 4.54 1A7 7 0 0016 8.38zM.88 2.85L0 3.4 7.82 15l.06.1L8 15l.74-.49z"
  })));
};

var _path$3F;

function _extends$3G() { _extends$3G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3G.apply(this, arguments); }

var SvgFilter$1 = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3G({
    width: 16,
    height: 16
  }, props), _path$3F || (_path$3F = /*#__PURE__*/React.createElement("path", {
    d: "M0 2h15v2L9 8.5V13l-3 2V8.5L0 3.89V2z"
  })));
};

var _path$3E;

function _extends$3F() { _extends$3F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3F.apply(this, arguments); }

var SvgFilterTokens$1 = function SvgFilterTokens(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3F({
    width: 16,
    height: 16
  }, props), _path$3E || (_path$3E = /*#__PURE__*/React.createElement("path", {
    d: "M0 1v6h16V1zm4 4H2V3h2zM0 15h16V9H0zm2-4h2v2H2z"
  })));
};

var _path$3D, _path2$1G;

function _extends$3E() { _extends$3E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3E.apply(this, arguments); }

var SvgFileZip$1 = function SvgFileZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3E({
    width: 16,
    height: 16
  }, props), _path$3D || (_path$3D = /*#__PURE__*/React.createElement("path", {
    d: "M1 0v16h13V5h-4v3H8v1h1v1H8v1h1v1H8v1h1v1H8v1H6v-1h1v-1H6v-1h1v-1H6v-1h1V9H6V8H5V0z"
  })), _path2$1G || (_path2$1G = /*#__PURE__*/React.createElement("path", {
    d: "M10 0v4h4zM7 4h1v2H7zM6 0v7h3V0z"
  })));
};

var _path$3C, _path2$1F;

function _extends$3D() { _extends$3D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3D.apply(this, arguments); }

var SvgFileVideo$1 = function SvgFileVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3D({
    width: 16,
    height: 16
  }, props), _path$3C || (_path$3C = /*#__PURE__*/React.createElement("path", {
    d: "M3 6h3v4H3zM9 6h3v4H9z"
  })), _path2$1F || (_path2$1F = /*#__PURE__*/React.createElement("path", {
    d: "M15 5V2H0v3h1v6H0v3h15v-3h-1V5zm-2-2h1v1h-1zm-2 0h1v1h-1zM9 3h1v1H9zM7 3h1v1H7zM5 3h1v1H5zM3 3h1v1H3zM1 3h1v1H1zm1 2h5v6H2zm0 8H1v-1h1zm2 0H3v-1h1zm2 0H5v-1h1zm2 0H7v-1h1zm2 0H9v-1h1zm2 0h-1v-1h1zm2 0h-1v-1h1zm-1-2H8V5h5z"
  })));
};

var _path$3B;

function _extends$3C() { _extends$3C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3C.apply(this, arguments); }

var SvgFileSpreadsheet$1 = function SvgFileSpreadsheet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3C({
    width: 16,
    height: 16
  }, props), _path$3B || (_path$3B = /*#__PURE__*/React.createElement("path", {
    d: "M0 2v13h16V2zm9 12H4v-2h5zm0-3H4V9h5zm0-3H4V6h5zm0-3H4V3h5zm6 9h-5v-2h5zm0-3h-5V9h5zm0-3h-5V6h5zm0-3h-5V3h5z",
    fill: "#87bc40"
  })));
};

var _path$3A, _path2$1E;

function _extends$3B() { _extends$3B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3B.apply(this, arguments); }

var SvgFilePresentation$1 = function SvgFilePresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3B({
    width: 16,
    height: 16
  }, props), _path$3A || (_path$3A = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1H.5a.5.5 0 000 1H1v9h4.33l-2.11 2.92a.5.5 0 10.81.59L6.56 11H7v3.38a.57.57 0 00.5.62.57.57 0 00.5-.62V11h.44L11 14.51a.5.5 0 10.81-.59L9.67 11H14V2h.5a.5.5 0 000-1zM13 10H2V2h11z",
    fill: "#faa21b"
  })), _path2$1E || (_path2$1E = /*#__PURE__*/React.createElement("path", {
    fill: "#faa21b",
    d: "M3 3h9v6H3z"
  })));
};

var _path$3z;

function _extends$3A() { _extends$3A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3A.apply(this, arguments); }

var SvgFilePdf$1 = function SvgFilePdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3A({
    width: 16,
    height: 16
  }, props), _path$3z || (_path$3z = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H1v16h13V4zM3 5h4v3H3zm6 7H3v-1h6zm3-2H3V9h9zm0-2H8V7h4zm0-2H8V5h4z",
    fill: "#ec4a41"
  })));
};

var _path$3y;

function _extends$3z() { _extends$3z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3z.apply(this, arguments); }

var SvgFilePart$1 = function SvgFilePart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3z({
    width: 16,
    height: 16
  }, props), _path$3y || (_path$3y = /*#__PURE__*/React.createElement("path", {
    fill: "#ec4a41",
    d: "M11 8V3H5v5H0v5h16V8h-5z"
  })));
};

var _path$3x;

function _extends$3y() { _extends$3y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3y.apply(this, arguments); }

var SvgFileImage$1 = function SvgFileImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3y({
    width: 16,
    height: 16
  }, props), _path$3x || (_path$3x = /*#__PURE__*/React.createElement("path", {
    d: "M1 1v14h14V1zm12 12H3V8.51l.4-.58a2.2 2.2 0 013.6 0l2.76 3.79a.3.3 0 00.48 0l1-1.27a1.36 1.36 0 011.11-.45 1.29 1.29 0 01.65.18zm-2-6a2 2 0 112-2 2 2 0 01-2 2z"
  })));
};

var _path$3w;

function _extends$3x() { _extends$3x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3x.apply(this, arguments); }

var SvgFileGeneric$1 = function SvgFileGeneric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3x({
    width: 16,
    height: 16
  }, props), _path$3w || (_path$3w = /*#__PURE__*/React.createElement("path", {
    d: "M1 0v16h13V5H9V0zm9 0v4h4z"
  })));
};

var _path$3v;

function _extends$3w() { _extends$3w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3w.apply(this, arguments); }

var SvgFileDocument$1 = function SvgFileDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3w({
    width: 16,
    height: 16
  }, props), _path$3v || (_path$3v = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H1v16h13V4zM9 12H3v-1h6zm3-2H3V9h9zm0-2H3V7h9zm0-2H3V5h9z",
    fill: "#0696d7"
  })));
};

var _path$3u, _path2$1D;

function _extends$3v() { _extends$3v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3v.apply(this, arguments); }

var SvgFileAudio$1 = function SvgFileAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3v({
    width: 16,
    height: 16
  }, props), _path$3u || (_path$3u = /*#__PURE__*/React.createElement("path", {
    d: "M4 12l5 4V-.08l-5 4V12zM0 4h3v8H0zM13.08 2.17l-.29.41a.3.3 0 000 .38 6.94 6.94 0 010 10.08.3.3 0 000 .38l.29.41a.21.21 0 00.33 0 7.95 7.95 0 000-11.74.21.21 0 00-.33.08z"
  })), _path2$1D || (_path2$1D = /*#__PURE__*/React.createElement("path", {
    d: "M11.07 10.53a.33.33 0 000 .39l.3.43a.19.19 0 00.31 0 4.93 4.93 0 000-6.76.19.19 0 00-.31 0l-.3.43a.33.33 0 000 .39 3.91 3.91 0 010 5.06z"
  })));
};

var _path$3t, _path2$1C;

function _extends$3u() { _extends$3u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3u.apply(this, arguments); }

var SvgFileAssembly$1 = function SvgFileAssembly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3u({
    width: 16,
    height: 16
  }, props), _path$3t || (_path$3t = /*#__PURE__*/React.createElement("path", {
    fill: "#ec4a41",
    d: "M12 3h4v4h-4z"
  })), _path2$1C || (_path2$1C = /*#__PURE__*/React.createElement("path", {
    fill: "#ec4a41",
    d: "M11 8V3H5v5H0v5h16V8h-5z"
  })));
};

var _path$3s, _path2$1B;

function _extends$3t() { _extends$3t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3t.apply(this, arguments); }

var SvgField$1 = function SvgField(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3t({
    width: 16,
    height: 16
  }, props), _path$3s || (_path$3s = /*#__PURE__*/React.createElement("path", {
    d: "M7.48 11c-1.88 0-4.29.51-5.48 2l.75 1h9.5l.75-1c-1.19-1.49-3.62-2-5.52-2zM8 2.5a.5.5 0 00-1 0V3h1z"
  })), _path2$1B || (_path2$1B = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.07a7.22 7.22 0 00-3-5.95V6h-1V4h1v-.5a.5.5 0 00-1 0A6.14 6.14 0 008 3v3H7V3a6.14 6.14 0 00-2 .51.5.5 0 00-1 0V4h1v2H4V4.13a7.24 7.24 0 00-3 5.94c0 .29-1 .93-1 .93v1h1.55c1.84-1.85 5-2 5.93-2s4.17.15 6 2H15v-1s-1-.64-1-.93z"
  })));
};

var _path$3r;

function _extends$3s() { _extends$3s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3s.apply(this, arguments); }

var SvgFeedback$1 = function SvgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3s({
    width: 16,
    height: 16
  }, props), _path$3r || (_path$3r = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.58l1.42 3.58 4.83 3.38 1-1.14-3.7-3.1.24-.09-1.37-3.58zM6.91 11s.92-.46 1.23-.57c2.95-1.13 5.32-.78 7 1.77l.65-.25L11.29.31c-.21.09-.43.18-.65.25.47 3-1.05 4.85-4 6-.3.12-1.23.57-1.23.57zM.12 9.78l1 2.58 1-.36-1-2.6z"
  })));
};

var _path$3q;

function _extends$3r() { _extends$3r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3r.apply(this, arguments); }

var SvgFeatured$1 = function SvgFeatured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3r({
    width: 16,
    height: 16
  }, props), _path$3q || (_path$3q = /*#__PURE__*/React.createElement("path", {
    d: "M7 10h2v2H7zm0-6h2v5H7zm1-4L6.46 2.77l-2.79-1.5.2 3.16-3.15.25L2.6 7.22.08 9.14l3 1.13L2 13.24l3.1-.65.69 3.09L8 13.45l2.25 2.22.69-3.09 3.1.65-1.09-3L16 9.1l-2.6-1.88 1.88-2.55-3.16-.25.2-3.16-2.78 1.51z"
  })));
};

var _path$3p;

function _extends$3q() { _extends$3q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3q.apply(this, arguments); }

var SvgFavorite$1 = function SvgFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3q({
    width: 16,
    height: 16
  }, props), _path$3p || (_path$3p = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H9.89L8 .19 6.11 6H0l4.94 3.59-1.88 5.82L8 11.81l4.94 3.6-1.88-5.82z"
  })));
};

var _path$3o, _path2$1A;

function _extends$3p() { _extends$3p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3p.apply(this, arguments); }

var SvgExternal$1 = function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3p({
    width: 16,
    height: 16
  }, props), _path$3o || (_path$3o = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 5.47L10.17 3H0v13h13V5.83L10.53 8.3 7.7 5.47z"
  })), _path2$1A || (_path2$1A = /*#__PURE__*/React.createElement("path", {
    d: "M10.04 1.01l1.77 1.77-2.69 2.69 1.41 1.41 2.69-2.69 1.77 1.77 1-5.96-5.95 1.01z"
  })));
};

var _path$3n, _path2$1z;

function _extends$3o() { _extends$3o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3o.apply(this, arguments); }

var SvgExternalLink$1 = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3o({
    width: 16,
    height: 16
  }, props), _path$3n || (_path$3n = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 11H4V5h2V3H2v10h10V9h-2v2z"
  })), _path2$1z || (_path2$1z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.23 2.96l1.59 1.58-3.47 3.47 1.64 1.64 3.47-3.47 1.58 1.59.98-5.79-5.79.98z"
  })));
};

var _path$3m, _path2$1y, _path3$i;

function _extends$3n() { _extends$3n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3n.apply(this, arguments); }

var SvgExportMove$1 = function SvgExportMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3n({
    width: 16,
    height: 16
  }, props), _path$3m || (_path$3m = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.18V5h-1.66L13 6.18zM9 0v4h4L9 0z"
  })), _path2$1y || (_path2$1y = /*#__PURE__*/React.createElement("path", {
    d: "M10.02 14.94v-3.09H7v-4.7h3.02V5H8V0H0v15h13v-2.18l-2.98 2.12z"
  })), _path3$i || (_path3$i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.02 8.15V6l4.92 3.5-4.92 3.5v-2.15H8v-2.7h3.02z"
  })));
};

var _path$3l, _path2$1x;

function _extends$3m() { _extends$3m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3m.apply(this, arguments); }

var SvgExpandPanel$1 = function SvgExpandPanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3m({
    width: 16,
    height: 16
  }, props), _path$3l || (_path$3l = /*#__PURE__*/React.createElement("path", {
    d: "M7 15H0V1h7z"
  })), _path2$1x || (_path2$1x = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.02 6.15V4l4.92 3.5-4.92 3.5V8.85H8v-2.7h3.02z"
  })));
};

var _path$3k;

function _extends$3l() { _extends$3l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3l.apply(this, arguments); }

var SvgError$1 = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3l({
    width: 16,
    height: 16
  }, props), _path$3k || (_path$3k = /*#__PURE__*/React.createElement("path", {
    d: "M8 0L0 8l8 8 8-8zm0 4a.93.93 0 011 .83l-.34 3.75a.53.53 0 01-.54.42h-.24a.53.53 0 01-.54-.42L7 4.83A.93.93 0 018 4zm0 8a1 1 0 111-1 1 1 0 01-1 1z"
  })));
};

var _path$3j, _path2$1w;

function _extends$3k() { _extends$3k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3k.apply(this, arguments); }

var SvgEducation$1 = function SvgEducation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3k({
    width: 16,
    height: 16
  }, props), _path$3j || (_path$3j = /*#__PURE__*/React.createElement("path", {
    d: "M8.58 10.38a.55.55 0 01-.17-.05L4 8.54v2.05a.84.84 0 00.14.41 7.68 7.68 0 004.36 2 7.64 7.64 0 004.36-2 .84.84 0 00.14-.41V8.33l-4.24 2a.41.41 0 01-.18.05zM3 15V6.44l-1-.41V15h1z"
  })), _path2$1w || (_path2$1w = /*#__PURE__*/React.createElement("path", {
    d: "M15.76 4.63l-7-3.49h-.14a.27.27 0 00-.13 0L.27 4.62A.39.39 0 000 5a.39.39 0 00.21.38L2 6l5.54-2.46L9 4 3.46 6.65l5 2a.53.53 0 00.17 0 .39.39 0 00.18 0l4.24-2 2.78-1.29A.39.39 0 0016 5a.41.41 0 00-.24-.37z"
  })));
};

var _path$3i;

function _extends$3j() { _extends$3j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3j.apply(this, arguments); }

var SvgEdit$1 = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3j({
    width: 16,
    height: 16
  }, props), _path$3i || (_path$3i = /*#__PURE__*/React.createElement("path", {
    d: "M0 16l4.92-1.38-3.54-3.54L0 16zM2.236 10.23l7-7 3.543 3.542-7 7zM13 0h-.31a1 1 0 00-.52.27l-2.09 2.11 3.54 3.54 2.09-2.09a1 1 0 00.29-.52 1.94 1.94 0 000-.24V3a3 3 0 00-3-3z"
  })));
};

var _path$3h, _ellipse;

function _extends$3i() { _extends$3i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3i.apply(this, arguments); }

var SvgEditProfile$1 = function SvgEditProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3i({
    width: 16,
    height: 16
  }, props), _path$3h || (_path$3h = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.29A3.91 3.91 0 000 11v4h5.24L6 12.4l1.94-1.94A3.94 3.94 0 004 7.29zM6.86 12.93L6 16l3.07-.86h.01l-2.22-2.22v.01zM7.573 12.22l4.1-4.102 2.214 2.213-4.101 4.102zM14.12 6h-.19a.62.62 0 00-.32.17l-1.23 1.24 2.21 2.21 1.23-1.23a.62.62 0 00.18-.32v-.15A1.88 1.88 0 0014.12 6z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 3.51,
    rx: 2.63,
    ry: 3
  })));
};

var _path$3g, _path2$1v;

function _extends$3h() { _extends$3h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3h.apply(this, arguments); }

var SvgDownload$1 = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3h({
    width: 16,
    height: 16
  }, props), _path$3g || (_path$3g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.2 5.25H3.24L8.04 12l4.8-6.75H9.89V0H6.2v5.25z"
  })), _path2$1v || (_path2$1v = /*#__PURE__*/React.createElement("path", {
    d: "M14 11v3H2v-3H0v5h16v-5h-2z"
  })));
};

var _path$3f;

function _extends$3g() { _extends$3g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3g.apply(this, arguments); }

var SvgDown$1 = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3g({
    width: 16,
    height: 16
  }, props), _path$3f || (_path$3f = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8V0h-5v8H2l6 8 6-8z",
    fillRule: "evenodd"
  })));
};

var _path$3e, _path2$1u, _path3$h;

function _extends$3f() { _extends$3f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3f.apply(this, arguments); }

var SvgDocumentManagement$1 = function SvgDocumentManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3f({
    width: 16,
    height: 16
  }, props), _path$3e || (_path$3e = /*#__PURE__*/React.createElement("path", {
    d: "M10 8h4l-4-4v4z"
  })), _path2$1u || (_path2$1u = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H9v-2h1v1h1V9H9V7H6v2H5V7H3v6h3v-1h1v2H2V6h7V4H0v12h14V9h-2v5z"
  })), _path3$h || (_path3$h = /*#__PURE__*/React.createElement("path", {
    d: "M2 0v3h8.41L15 7.59V12a1 1 0 001-1V0z"
  })));
};

var _path$3d, _path2$1t, _path3$g;

function _extends$3e() { _extends$3e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3e.apply(this, arguments); }

var SvgDevices$1 = function SvgDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3e({
    width: 16,
    height: 16
  }, props), _path$3d || (_path$3d = /*#__PURE__*/React.createElement("path", {
    d: "M2 0v5h1V1h12v10H8v2h8V0H2z"
  })), _path2$1t || (_path2$1t = /*#__PURE__*/React.createElement("path", {
    d: "M0 16h7V6H0zm1-9h5v7H1z"
  })), _path3$g || (_path3$g = /*#__PURE__*/React.createElement("path", {
    d: "M2 8h3v5H2zM14 10V2H4v3h4v5h6z"
  })));
};

var _path$3c, _path2$1s;

function _extends$3d() { _extends$3d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3d.apply(this, arguments); }

var SvgDeviceTablet$1 = function SvgDeviceTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3d({
    width: 16,
    height: 16
  }, props), _path$3c || (_path$3c = /*#__PURE__*/React.createElement("path", {
    d: "M0 2v12h16V2zm13 11H1V3h12zm2-4h-1V7h1z"
  })), _path2$1s || (_path2$1s = /*#__PURE__*/React.createElement("path", {
    d: "M2 4h10v8H2z"
  })));
};

var _path$3b, _path2$1r;

function _extends$3c() { _extends$3c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3c.apply(this, arguments); }

var SvgDeviceMobile$1 = function SvgDeviceMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3c({
    width: 16,
    height: 16
  }, props), _path$3b || (_path$3b = /*#__PURE__*/React.createElement("path", {
    d: "M5 2h6v10H5z"
  })), _path2$1r || (_path2$1r = /*#__PURE__*/React.createElement("path", {
    d: "M3 0v16h10V0zm6 15H7v-1h2zm3-2H4V1h8z"
  })));
};

var _path$3a, _path2$1q;

function _extends$3b() { _extends$3b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3b.apply(this, arguments); }

var SvgDeviceDesktop$1 = function SvgDeviceDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3b({
    width: 16,
    height: 16
  }, props), _path$3a || (_path$3a = /*#__PURE__*/React.createElement("path", {
    d: "M16 12V1H0v11h6v2H2v1h12v-1h-4v-2zM1 11V2h14v9z"
  })), _path2$1q || (_path2$1q = /*#__PURE__*/React.createElement("path", {
    d: "M2 3h12v7H2z"
  })));
};

var _g, _defs$1;

function _extends$3a() { _extends$3a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3a.apply(this, arguments); }

var SvgDataRefresh$1 = function SvgDataRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3a({
    width: 17,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#data-refresh_svg__clip0_3078_327318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5.793v3.58l.003.083 2.249 1.582",
    stroke: "gray",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.667 4.555a7.958 7.958 0 00-5.096-3.412 7.97 7.97 0 00-6.017 1.19A7.961 7.961 0 00.142 7.428l1.961.393a5.973 5.973 0 012.561-3.824 5.983 5.983 0 014.515-.893 5.972 5.972 0 013.824 2.561 5.974 5.974 0 01.893 4.515 6.02 6.02 0 01-7.076 4.718 6.005 6.005 0 01-3.163-1.769l2.082-1.456-5.736-2.09L0 15.685l1.992-1.393a8.022 8.022 0 004.436 2.565 8.058 8.058 0 001.573.156c3.74 0 7.095-2.638 7.855-6.442a7.963 7.963 0 00-1.189-6.017z",
    fill: "gray"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "data-refresh_svg__clip0_3078_327318"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .985)",
    d: "M0 0h16.015v16.029H0z"
  })))));
};

var _path$39;

function _extends$39() { _extends$39 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$39.apply(this, arguments); }

var SvgDashboard$1 = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$39({
    width: 16,
    height: 16
  }, props), _path$39 || (_path$39 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.15A7.51 7.51 0 00.15 11 7.29 7.29 0 001 13.25a1 1 0 001.25.42l3-1.22A2.47 2.47 0 007 13.94a2.6 2.6 0 00.56.06 2.52 2.52 0 002.28-1.55l3 1.23a1 1 0 001.16-.43 7.51 7.51 0 00-8-11.1zM4 11H1v-1h3zm.65-3.65l-2-2 .71-.71 2 2zm7-2.71l.71.71-.9.9a1.33 1.33 0 00-1-.46zM7 3h1v3H7zm2 8.86A1.5 1.5 0 017.23 13h-.07a1.46 1.46 0 01-1.07-1 1.51 1.51 0 01.42-1.64l3.77-3.5a.29.29 0 01.42 0 .3.3 0 01.06.3S9.4 10.67 9 11.86zm2-.86v-1h3v1z"
  })));
};

var _path$38;

function _extends$38() { _extends$38 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$38.apply(this, arguments); }

var SvgCtaArrowRight$1 = function SvgCtaArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$38({
    width: 16,
    height: 16
  }, props), _path$38 || (_path$38 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 108 8 8 8 0 00-8-8zm.38 12V9.54H3V6.46h5.38V4L14 8z",
    fillRule: "evenodd"
  })));
};

var _path$37, _path2$1p;

function _extends$37() { _extends$37 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$37.apply(this, arguments); }

var SvgCopy$1 = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$37({
    width: 16,
    height: 16
  }, props), _path$37 || (_path$37 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3H7V0l3 3zM5 4h1V0H0v11h5V4zM16 8h-3V5l3 3z"
  })), _path2$1p || (_path2$1p = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V5H6v11h10V9h-4z"
  })));
};

var _path$36;

function _extends$36() { _extends$36 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$36.apply(this, arguments); }

var SvgComplete$1 = function SvgComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$36({
    width: 16,
    height: 16
  }, props), _path$36 || (_path$36 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1a7 7 0 107 7 7 7 0 00-7-7zm-.87 10.9L3.86 9.15l.92-1.1 2.13 1.8L11 4.56l1.13.87z"
  })));
};

var _path$35;

function _extends$35() { _extends$35 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$35.apply(this, arguments); }

var SvgCompare$1 = function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$35({
    width: 16,
    height: 16
  }, props), _path$35 || (_path$35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.38 8L11 4 5.38 0v2.46H0v3.08h5.38V8zM10.63 10.46V8L5 12l5.63 4v-2.46H16v-3.08h-5.37z"
  })));
};

var _path$34;

function _extends$34() { _extends$34 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$34.apply(this, arguments); }

var SvgComment$1 = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$34({
    width: 16,
    height: 16
  }, props), _path$34 || (_path$34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1v10h3v5l5-5h8V1zm9 7H3V7h6zm4-3H3V4h10z"
  })));
};

var _path$33, _path2$1o;

function _extends$33() { _extends$33 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$33.apply(this, arguments); }

var SvgCollapsePanel$1 = function SvgCollapsePanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$33({
    width: 16,
    height: 16
  }, props), _path$33 || (_path$33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1h7v14H0z"
  })), _path2$1o || (_path2$1o = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 6V4L8.06 7.5 13 11V9h3V6h-3z"
  })));
};

var _path$32, _path2$1n, _path3$f;

function _extends$32() { _extends$32 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$32.apply(this, arguments); }

var SvgCollaboration$1 = function SvgCollaboration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$32({
    width: 16,
    height: 16
  }, props), _path$32 || (_path$32 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H0v12h12v-4H4V4z"
  })), _path2$1n || (_path2$1n = /*#__PURE__*/React.createElement("path", {
    d: "M4 0v4h8v8h4V0H4z"
  })), _path3$f || (_path3$f = /*#__PURE__*/React.createElement("path", {
    d: "M5 5h6v6H5z"
  })));
};

var _path$31;

function _extends$31() { _extends$31 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$31.apply(this, arguments); }

var SvgCloud$1 = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$31({
    width: 16,
    height: 16
  }, props), _path$31 || (_path$31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8h-.05a4 4 0 10-7.31-3H6a3 3 0 00-3 3h-.5a2.5 2.5 0 000 5h11a2.5 2.5 0 000-5z"
  })));
};

var _path$30;

function _extends$30() { _extends$30 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$30.apply(this, arguments); }

var SvgClosedCaptioning$1 = function SvgClosedCaptioning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$30({
    width: 16,
    height: 16
  }, props), _path$30 || (_path$30 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69 11.8c-.88 0-1.53-1-1.53-3.4S2.83 5 3.65 5 4.78 5.59 5 6.9l1.88-.55c-.35-2.08-1.34-3.12-3.2-3.12C1.41 3.23.11 5.1.11 8.42s1.36 5.16 3.57 5.16c1.9 0 2.89-1.2 3.3-3.33l-1.86-.58c-.26 1.38-.71 2.13-1.43 2.13zM13.09 9.67c-.25 1.38-.7 2.13-1.42 2.13-.88 0-1.53-1-1.53-3.4S10.8 5 11.63 5s1.12.59 1.37 1.9l1.89-.55c-.35-2.07-1.34-3.12-3.21-3.12-2.29 0-3.59 1.87-3.59 5.19s1.35 5.16 3.57 5.16c1.9 0 2.89-1.2 3.3-3.33z"
  })));
};

var _path$2$;

function _extends$2$() { _extends$2$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2$.apply(this, arguments); }

var SvgClock$1 = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2$({
    width: 16,
    height: 16
  }, props), _path$2$ || (_path$2$ = /*#__PURE__*/React.createElement("path", {
    d: "M8 1a7 7 0 107 7 7 7 0 00-7-7zm4 8H7V3h1v5h4z"
  })));
};

var _path$2_;

function _extends$2_() { _extends$2_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2_.apply(this, arguments); }

var SvgCheckmark$1 = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2_({
    width: 16,
    height: 16
  }, props), _path$2_ || (_path$2_ = /*#__PURE__*/React.createElement("path", {
    d: "M.52 8.77L2.28 7l3.54 3.53 7.9-7.9 1.76 1.77-9.66 9.67-5.3-5.3z"
  })));
};

var _path$2Z, _path2$1m;

function _extends$2Z() { _extends$2Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Z.apply(this, arguments); }

var SvgChecklist$1 = function SvgChecklist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Z({
    width: 16,
    height: 16
  }, props), _path$2Z || (_path$2Z = /*#__PURE__*/React.createElement("path", {
    d: "M4 3h1v1H4zM4 7h1v1H4zM4 11h1v1H4z"
  })), _path2$1m || (_path2$1m = /*#__PURE__*/React.createElement("path", {
    d: "M1 0v15h14V0zm5 13H3v-3h3zm0-4H3V6h3zm0-4H3V2h3zm7 7H8v-1h5zm0-4H8V7h5zm0-4H8V3h5z"
  })));
};

var _path$2Y, _path2$1l;

function _extends$2Y() { _extends$2Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Y.apply(this, arguments); }

var SvgChat$1 = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Y({
    width: 16,
    height: 16
  }, props), _path$2Y || (_path$2Y = /*#__PURE__*/React.createElement("path", {
    d: "M12 5v4H5.41L5 9.41V13h6l3 3v-3h2V5h-4z"
  })), _path2$1l || (_path2$1l = /*#__PURE__*/React.createElement("path", {
    d: "M5 8h6V0H0v8h2v3l3-3z"
  })));
};

var _path$2X, _circle$9, _circle2$3;

function _extends$2X() { _extends$2X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2X.apply(this, arguments); }

var SvgCartFull$1 = function SvgCartFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2X({
    width: 16,
    height: 16
  }, props), _path$2X || (_path$2X = /*#__PURE__*/React.createElement("path", {
    d: "M4.07 4l-.29-1.17-2.76-1.68-1.04 1.7L2.03 4.1 4 12h10l2-8H4.07z"
  })), _circle$9 || (_circle$9 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 14.5,
    r: 1.5
  })), _circle2$3 || (_circle2$3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 14.5,
    r: 1.5
  })));
};

var _path$2W, _circle$8, _circle2$2;

function _extends$2W() { _extends$2W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2W.apply(this, arguments); }

var SvgCartEmpty$1 = function SvgCartEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2W({
    width: 16,
    height: 16
  }, props), _path$2W || (_path$2W = /*#__PURE__*/React.createElement("path", {
    d: "M4.07 4l-.29-1.17L1 1.15 0 2.86 2 4.1 4 12h10l2-8zm8.37 6H5.56l-1-4h8.88z"
  })), _circle$8 || (_circle$8 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 14.5,
    r: 1.5
  })), _circle2$2 || (_circle2$2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 14.5,
    r: 1.5
  })));
};

var _path$2V;

function _extends$2V() { _extends$2V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2V.apply(this, arguments); }

var SvgCaretUp$1 = function SvgCaretUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2V({
    width: 16,
    height: 16
  }, props), _path$2V || (_path$2V = /*#__PURE__*/React.createElement("path", {
    d: "M1.71 10.03l6.3-6.3 6.3 6.3-1.77 1.77-4.53-4.54-4.54 4.54-1.76-1.77z"
  })));
};

var _path$2U;

function _extends$2U() { _extends$2U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2U.apply(this, arguments); }

var SvgCaretRight$1 = function SvgCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2U({
    width: 16,
    height: 16
  }, props), _path$2U || (_path$2U = /*#__PURE__*/React.createElement("path", {
    d: "M4.28 12.63l4.54-4.54-4.54-4.53 1.77-1.77 6.3 6.3-6.3 6.31-1.77-1.77z"
  })));
};

var _path$2T;

function _extends$2T() { _extends$2T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2T.apply(this, arguments); }

var SvgCaretLeft$1 = function SvgCaretLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2T({
    width: 16,
    height: 16
  }, props), _path$2T || (_path$2T = /*#__PURE__*/React.createElement("path", {
    d: "M3.65 8.09l6.3-6.3 1.77 1.77-4.54 4.53 4.54 4.54-1.77 1.77-6.3-6.31z"
  })));
};

var _path$2S;

function _extends$2S() { _extends$2S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2S.apply(this, arguments); }

var SvgCaretDown$1 = function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2S({
    width: 16,
    height: 16
  }, props), _path$2S || (_path$2S = /*#__PURE__*/React.createElement("path", {
    d: "M1.69 6.13l1.77-1.76L7.99 8.9l4.54-4.53 1.76 1.76-6.3 6.31-6.3-6.31z"
  })));
};

var _path$2R;

function _extends$2R() { _extends$2R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2R.apply(this, arguments); }

var SvgCalendar$1 = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2R({
    width: 16,
    height: 16
  }, props), _path$2R || (_path$2R = /*#__PURE__*/React.createElement("path", {
    d: "M1 2v12h13V2zm4 11H2v-2h3zm0-3H2V8h3zm0-3H2V5h3zm4 6H6v-2h3zm0-3H6V8h3zm0-3H6V5h3zm4 6h-3v-2h3zm0-3h-3V8h3zm0-3h-3V5h3z"
  })));
};

var _path$2Q;

function _extends$2Q() { _extends$2Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Q.apply(this, arguments); }

var SvgBuilding$1 = function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Q({
    width: 16,
    height: 16
  }, props), _path$2Q || (_path$2Q = /*#__PURE__*/React.createElement("path", {
    d: "M14 8V2h-1v14h2V8h-1zM3 16h3v-3h3v3h3V0H3zM8 2h2v2H8zm0 3h2v2H8zm0 3h2v2H8zM5 2h2v2H5zm0 3h2v2H5zm0 3h2v2H5zM1 8H0v8h2V2H1v6z"
  })));
};

var _path$2P;

function _extends$2P() { _extends$2P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2P.apply(this, arguments); }

var SvgBookmark$1 = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2P({
    width: 16,
    height: 16
  }, props), _path$2P || (_path$2P = /*#__PURE__*/React.createElement("path", {
    d: "M12 16l-4.49-4L3 16V0h9v16z"
  })));
};

var _path$2O, _path2$1k;

function _extends$2O() { _extends$2O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2O.apply(this, arguments); }

var SvgBilling$1 = function SvgBilling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2O({
    width: 16,
    height: 16
  }, props), _path$2O || (_path$2O = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H1v16h13zm-2 14H7v-1h5zm0-2H3V2h9z"
  })), _path2$1k || (_path2$1k = /*#__PURE__*/React.createElement("path", {
    d: "M7 9h4v2H7zM7 6h4v2H7zM4 6h2v2H4zM4 3h2v2H4zM7 3h4v2H7zM4 9h2v2H4z"
  })));
};

var _path$2N, _path2$1j;

function _extends$2N() { _extends$2N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2N.apply(this, arguments); }

var SvgBillStack$1 = function SvgBillStack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2N({
    width: 16,
    height: 16
  }, props), _path$2N || (_path$2N = /*#__PURE__*/React.createElement("path", {
    d: "M6 2h4v12H6zM0 11h5v1H0zM11 11h5v1h-5zM0 10h5V8H2V4h3V2H0v8zM11 2v2h3v4h-3v2h5V2h-5z"
  })), _path2$1j || (_path2$1j = /*#__PURE__*/React.createElement("path", {
    d: "M3 5h2v2H3zM11 5h2v2h-2zM11 13h5v1h-5zM0 13h5v1H0z"
  })));
};

var _path$2M;

function _extends$2M() { _extends$2M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2M.apply(this, arguments); }

var SvgBack$1 = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2M({
    width: 16,
    height: 16
  }, props), _path$2M || (_path$2M = /*#__PURE__*/React.createElement("path", {
    d: "M8 2L0 8l8 6v-3.5h8v-5H8z",
    fillRule: "evenodd"
  })));
};

var _path$2L, _path2$1i;

function _extends$2L() { _extends$2L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2L.apply(this, arguments); }

var SvgAttachment$1 = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2L({
    width: 16,
    height: 16
  }, props), _path$2L || (_path$2L = /*#__PURE__*/React.createElement("path", {
    d: "M10 3v3h3l-3-3zM14 6v9H2v1h13V6h-1z"
  })), _path2$1i || (_path2$1i = /*#__PURE__*/React.createElement("path", {
    d: "M13 7H9V3H6v4.5a1.5 1.5 0 01-3 0V5h1v2.5a.5.5 0 001 0V3H3V2a1 1 0 012 0v1h1V2a2 2 0 00-4 0v1H0v11h13z"
  })));
};

var _path$2K, _path2$1h;

function _extends$2K() { _extends$2K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2K.apply(this, arguments); }

var SvgAttach$1 = function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2K({
    width: 16,
    height: 16
  }, props), _path$2K || (_path$2K = /*#__PURE__*/React.createElement("path", {
    d: "M12 3v4h4l-4-4z"
  })), _path2$1h || (_path2$1h = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H7v4.5a1.5 1.5 0 01-3 0V5h1v2.5a.5.5 0 001 0V3H4V2a1 1 0 012 0v1h1V2a2 2 0 00-4 0v1H0v12h16V8h-5z"
  })));
};

var _path$2J;

function _extends$2J() { _extends$2J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2J.apply(this, arguments); }

var SvgAreaPost$1 = function SvgAreaPost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2J({
    width: 16,
    height: 16
  }, props), _path$2J || (_path$2J = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2v2H0zM4 0h2v2H4zM8 0h2v2H8zM4 12h2v2H4zM12 0h2v2h-2zM12 4h2v2h-2zM16 11h-3V8h-2v3H8v2h3v3h2v-3h3v-2zM0 4h2v2H0zM0 8h2v2H0zM0 12h2v2H0z"
  })));
};

var _path$2I;

function _extends$2I() { _extends$2I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2I.apply(this, arguments); }

var SvgArchive$1 = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2I({
    width: 16,
    height: 16
  }, props), _path$2I || (_path$2I = /*#__PURE__*/React.createElement("path", {
    d: "M0 1h16v3H0zM1 15h14V5H1zm3-7h8v1H4z"
  })));
};

var _path$2H;

function _extends$2H() { _extends$2H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2H.apply(this, arguments); }

var SvgAlert$1 = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2H({
    width: 16,
    height: 16
  }, props), _path$2H || (_path$2H = /*#__PURE__*/React.createElement("path", {
    d: "M15.63 14.35L8.37 1.66a.42.42 0 00-.74 0L.37 14.35a.43.43 0 00.37.65h14.52a.43.43 0 00.37-.65zM8 13a1 1 0 111-1 1 1 0 01-1 1zm.66-3.42a.53.53 0 01-.54.42h-.24a.53.53 0 01-.54-.42L7 5.83A.93.93 0 018 5a.93.93 0 011 .83z"
  })));
};

var _path$2G;

function _extends$2G() { _extends$2G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2G.apply(this, arguments); }

var SvgAdd$1 = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2G({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2G || (_path$2G = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2v5H2v2h5v5h2V9h5V7H9V2H7z",
    fill: "gray"
  })));
};

var _path$2F, _path2$1g, _path3$e;

function _extends$2F() { _extends$2F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2F.apply(this, arguments); }

var SvgAddPage$1 = function SvgAddPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2F({
    width: 16,
    height: 16
  }, props), _path$2F || (_path$2F = /*#__PURE__*/React.createElement("path", {
    d: "M9 0v4h4L9 0z"
  })), _path2$1g || (_path2$1g = /*#__PURE__*/React.createElement("path", {
    d: "M10 11V9h3V5H8V0H0v15h8v-4h2z"
  })), _path3$e || (_path3$e = /*#__PURE__*/React.createElement("path", {
    d: "M11 10v2H9v2h2v2h2v-2h2v-2h-2v-2h-2z"
  })));
};

var _path$2E, _path2$1f;

function _extends$2E() { _extends$2E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2E.apply(this, arguments); }

var SvgAddMember$1 = function SvgAddMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2E({
    width: 16,
    height: 16
  }, props), _path$2E || (_path$2E = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.63c1.51 0 2.66-1.63 2.66-3.18A2.87 2.87 0 006 .5a2.72 2.72 0 00-2.66 3c0 1.79 1.15 3.13 2.66 3.13zM6 7.12a4.12 4.12 0 00-4 4.33V15h6v-4h2a4.1 4.1 0 00-4-3.88z"
  })), _path2$1f || (_path2$1f = /*#__PURE__*/React.createElement("path", {
    d: "M13 12v-2h-2v2H9v2h2v2h2v-2h2v-2h-2z"
  })));
};

var _path$2D, _path2$1e, _path3$d;

function _extends$2D() { _extends$2D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2D.apply(this, arguments); }

var SvgAddFolder$1 = function SvgAddFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2D({
    width: 16,
    height: 16
  }, props), _path$2D || (_path$2D = /*#__PURE__*/React.createElement("path", {
    d: "M6.34 3l-1-1H0v2h5.34l1-1z"
  })), _path2$1e || (_path2$1e = /*#__PURE__*/React.createElement("path", {
    d: "M9 11h2V9h3V3H8L6 5H0v9h9v-3z"
  })), _path3$d || (_path3$d = /*#__PURE__*/React.createElement("path", {
    d: "M12 10v2h-2v2h2v2h2v-2h2v-2h-2v-2h-2z"
  })));
};

var _path$2C, _path2$1d;

function _extends$2C() { _extends$2C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2C.apply(this, arguments); }

var SvgZoomOut = function SvgZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2C({
    width: 24,
    height: 24
  }, props), _path$2C || (_path$2C = /*#__PURE__*/React.createElement("path", {
    d: "M16.44 14.32l-.56.56-.46-.46A6.92 6.92 0 0017 10a7 7 0 10-7 7 6.92 6.92 0 004.42-1.58l.46.46-.56.56 5.33 5.32 2.11-2.11zM10 16a6 6 0 116-6 6 6 0 01-6 6zm5.74.44l.7-.7 3.91 3.91-.7.7z"
  })), _path2$1d || (_path2$1d = /*#__PURE__*/React.createElement("path", {
    d: "M13 9H7v2h6V9z"
  })));
};

var _path$2B, _path2$1c;

function _extends$2B() { _extends$2B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2B.apply(this, arguments); }

var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2B({
    width: 24,
    height: 24
  }, props), _path$2B || (_path$2B = /*#__PURE__*/React.createElement("path", {
    d: "M16.44 14.32l-.56.56-.46-.46A6.92 6.92 0 0017 10a7 7 0 10-7 7 6.92 6.92 0 004.42-1.58l.46.46-.56.56 5.33 5.32 2.11-2.11zM10 16a6 6 0 116-6 6 6 0 01-6 6zm5.74.44l.7-.7 3.91 3.91-.7.7z"
  })), _path2$1c || (_path2$1c = /*#__PURE__*/React.createElement("path", {
    d: "M13 9h-2V7H9v2H7v2h2v2h2v-2h2V9z"
  })));
};

var _path$2A, _path2$1b, _path3$c;

function _extends$2A() { _extends$2A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2A.apply(this, arguments); }

var SvgVolume = function SvgVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2A({
    width: 24,
    height: 24
  }, props), _path$2A || (_path$2A = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H2v7h3l7 5V4zm0 6H3v-5h2zm6 4.06l-5-3.57v-6l5-3.57zM21 12.5a9.45 9.45 0 01-3.5 7.35l.62.8a10.5 10.5 0 000-16.3l-.62.8A9.45 9.45 0 0121 12.5z"
  })), _path2$1b || (_path2$1b = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.5a6.5 6.5 0 01-2.33 5l.61.79a7.48 7.48 0 000-11.54l-.61.79A6.5 6.5 0 0118 12.5z"
  })), _path3$c || (_path3$c = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5a3.48 3.48 0 01-1.16 2.59l.6.79a4.44 4.44 0 000-6.76l-.6.79A3.48 3.48 0 0115 12.5z"
  })));
};

var _path$2z, _path2$1a;

function _extends$2z() { _extends$2z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2z.apply(this, arguments); }

var SvgVisible = function SvgVisible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2z({
    width: 24,
    height: 24
  }, props), _path$2z || (_path$2z = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.42C5.38 5.42 2 12 2 12s3.17 6.6 10 6.6A10.9 10.9 0 0022 12s-3.65-6.58-10-6.58zm0 12.18c-5.13 0-8-4.19-8.85-5.58C4 10.62 7 6.42 12 6.42s8 4.3 8.87 5.67A9.75 9.75 0 0112 17.6z"
  })), _path2$1a || (_path2$1a = /*#__PURE__*/React.createElement("path", {
    d: "M12 8a4 4 0 104 4 4 4 0 00-4-4zm0 7a3 3 0 113-3 3 3 0 01-3 3z"
  })));
};

var _path$2y, _path2$19;

function _extends$2y() { _extends$2y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2y.apply(this, arguments); }

var SvgUserInactive = function SvgUserInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2y({
    width: 24,
    height: 24
  }, props), _path$2y || (_path$2y = /*#__PURE__*/React.createElement("path", {
    d: "M12.21 19H5v-4.5a4.49 4.49 0 018.85-1.1 5.58 5.58 0 01.87-.64 5.49 5.49 0 00-3.31-3.41A4.2 4.2 0 0013 6a3.78 3.78 0 00-3.5-4A3.78 3.78 0 006 6a4.2 4.2 0 001.59 3.35A5.49 5.49 0 004 14.5V20h8.61a5.09 5.09 0 01-.4-1zM7 6a2.79 2.79 0 012.5-3A2.79 2.79 0 0112 6a2.79 2.79 0 01-2.5 3A2.79 2.79 0 017 6z"
  })), _path2$19 || (_path2$19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13a4.5 4.5 0 104.5 4.5 4.49 4.49 0 00-4.5-4.5zM15 18v-1h5v1z"
  })));
};

var _path$2x, _path2$18;

function _extends$2x() { _extends$2x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2x.apply(this, arguments); }

var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2x({
    width: 24,
    height: 24
  }, props), _path$2x || (_path$2x = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 2L6 10h3v6h6v-6h3zM14 9v6h-4V9H8l4.06-5.33L16 9z",
    fillRule: "evenodd"
  })), _path2$18 || (_path2$18 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16v2H7v-2H3v6h18v-6zm3 5H4v-4h2v2h12v-2h2z"
  })));
};

var _path$2w;

function _extends$2w() { _extends$2w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2w.apply(this, arguments); }

var SvgUp = function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2w({
    width: 24,
    height: 24
  }, props), _path$2w || (_path$2w = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2L4 12h4v10h7V12h4zm2.5 9v10H9V11H6l5.5-7.33L17 11z",
    fillRule: "evenodd"
  })));
};

var _path$2v;

function _extends$2v() { _extends$2v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2v.apply(this, arguments); }

var SvgUnpin = function SvgUnpin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2v({
    width: 24,
    height: 24
  }, props), _path$2v || (_path$2v = /*#__PURE__*/React.createElement("path", {
    d: "M10.35 8.23l.7.7 2.1-2.1 4 4L15.07 13l.7.7 1.89-1.88 1.08 1.09L22 9.6 14.4 2l-3.26 3.26 1.09 1.08zm4.05-4.82l6.19 6.19-1.85 1.84-.52-.52-5-5-.61-.61zM13.4 15.52v3.44l-.09.08-8.35-8.35.08-.09h3.44l-1-1H4.63l-1.09 1.09 4.42 4.42-4.67 5.58 5.58-4.68 4.44 4.45 1.09-1.09v-2.85l-1-1zM4.413 5.12l.707-.707L19.588 18.88l-.707.707z"
  })));
};

var _path$2u, _path2$17;

function _extends$2u() { _extends$2u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2u.apply(this, arguments); }

var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2u({
    width: 24,
    height: 24
  }, props), _path$2u || (_path$2u = /*#__PURE__*/React.createElement("path", {
    d: "M19 2a5 5 0 00-5 5v3H5v11h14V10h-2V7a2 2 0 014 0v2h3V7a5 5 0 00-5-5zm-1 9v9H6v-9zm5-3h-1V7a3 3 0 00-6 0v3h-1V7a4 4 0 018 0z"
  })), _path2$17 || (_path2$17 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13h2v5h-2z"
  })));
};

var _path$2t;

function _extends$2t() { _extends$2t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2t.apply(this, arguments); }

var SvgUnlink = function SvgUnlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2t({
    width: 24,
    height: 24
  }, props), _path$2t || (_path$2t = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 16.08l-3.69 3.69a4 4 0 01-5.68-5.67L7.34 11a5.42 5.42 0 00.55 2.7l-2 2a1.72 1.72 0 002.44 2.43L12 14.46l-1-1-1 1a2 2 0 01-.23-.18A4 4 0 018.57 11L7.22 9.7l-.58.58-3.11 3.11a5 5 0 107.08 7.09l3.7-3.7zm-5.06-1.63A4 4 0 009 15a2.75 2.75 0 00.26.22h.05l.25.19-2 2a.72.72 0 11-1-1zM10.4 7.93L14 4.38a4 4 0 015.67 0 4 4 0 010 5.67l-3.11 3.11a5.42 5.42 0 00-.55-2.7l2-2a1.72 1.72 0 00-1.22-2.96 1.67 1.67 0 00-1.21.5L12 9.55l1 1 .9-.89c.07.06.15.11.22.18a4 4 0 011.16 3l1.46 1.47.44-.44 3.12-3.11a5 5 0 00-3.51-8.56 5 5 0 00-3.54 1.47L9.7 7.22zm4.92 1.77a4 4 0 00-.46-.56 2.75 2.75 0 00-.26-.22l-.25-.2 2-2a.74.74 0 01.51-.2.73.73 0 01.51.2.71.71 0 01.21.51.68.68 0 01-.21.51zM3.296 4.003l.707-.707 16.71 16.708-.708.708z"
  })));
};

var _path$2s;

function _extends$2s() { _extends$2s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2s.apply(this, arguments); }

var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2s({
    width: 24,
    height: 24
  }, props), _path$2s || (_path$2s = /*#__PURE__*/React.createElement("path", {
    d: "M22 17.17C22 12.36 18.73 8 13.57 8H12V4L2 11.5 12 19v-4h2.5c3.84 0 5.5 1 7.5 3.78v-1.61zM14.5 14H11v3l-7.33-5.5L11 6v3h2.57c4.36 0 6.9 3.45 7.34 7-1.53-1.33-3.35-2-6.41-2z"
  })));
};

var _path$2r, _path2$16;

function _extends$2r() { _extends$2r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2r.apply(this, arguments); }

var SvgUnavailable = function SvgUnavailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2r({
    width: 24,
    height: 24
  }, props), _path$2r || (_path$2r = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2a9.5 9.5 0 109.5 9.5A9.5 9.5 0 0011.5 2zm0 18a8.5 8.5 0 118.5-8.5 8.51 8.51 0 01-8.5 8.5z"
  })), _path2$16 || (_path2$16 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9v5h13V9zm12 4H6v-3h11z"
  })));
};

var _path$2q;

function _extends$2q() { _extends$2q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2q.apply(this, arguments); }

var SvgTreeView = function SvgTreeView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2q({
    width: 24,
    height: 24
  }, props), _path$2q || (_path$2q = /*#__PURE__*/React.createElement("path", {
    d: "M22 15v-5H12v2H7V8h5V3H2v5h4v12h6v2h10v-5H12v2H7v-6h5v2zM3 7V4h8v3H3zm10 11h8v3h-8v-3zm0-7h8v3h-8v-3z"
  })));
};

var _path$2p;

function _extends$2p() { _extends$2p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2p.apply(this, arguments); }

var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2p({
    width: 24,
    height: 24
  }, props), _path$2p || (_path$2p = /*#__PURE__*/React.createElement("path", {
    d: "M19 5h-3V3.13A1.08 1.08 0 0015 2H8a1.11 1.11 0 00-1 1.13V5H4v4h1v13h13V9h1zm-4-2v2h-1V4H9v1H8V3zm2 18H6V9h11zm1-13H5V6h13z"
  })));
};

var _path$2o, _path2$15;

function _extends$2o() { _extends$2o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2o.apply(this, arguments); }

var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2o({
    width: 24,
    height: 24
  }, props), _path$2o || (_path$2o = /*#__PURE__*/React.createElement("path", {
    d: "M12 3H3v9l10 10 9-9zm-8 8.59V4h7.59l9 9L13 20.59z"
  })), _path2$15 || (_path2$15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6A1.5 1.5 0 109 7.5 1.5 1.5 0 007.5 6zm0 2a.5.5 0 11.5-.5.5.5 0 01-.5.5zM10.981 9.05l.708-.707 4.66 4.66-.708.707zM9.835 13.176l.707-.707 3.168 3.168-.708.707z"
  })));
};

var _path$2n;

function _extends$2n() { _extends$2n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2n.apply(this, arguments); }

var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2n({
    width: 24,
    height: 24
  }, props), _path$2n || (_path$2n = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.81l-.22-9.6-2.87 2.07A9 9 0 003.67 8.61l3.8 1.3A5 5 0 0112 7a4.94 4.94 0 013.68 1.65l-2.82 2.06zM16.42 8A5.94 5.94 0 007 8.7L5.06 8a8 8 0 0113.08-1.08l.6.72 2-1.48.15 6.24-5.92-2 2.2-1.6zM16.53 14.08a5 5 0 01-8.23 1.27l2.84-2.08-9.09-3.1.22 9.6 2.79-2a9 9 0 0015.28-2.35zM12 20a8 8 0 01-6.17-2.91l-.6-.73-2 1.47-.15-6.25L9 13.6l-2.18 1.6.74.82a6 6 0 009.44-.73l2 .71a8 8 0 01-7 4z"
  })));
};

var _path$2m, _path2$14;

function _extends$2m() { _extends$2m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2m.apply(this, arguments); }

var SvgSurveyEquipment = function SvgSurveyEquipment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2m({
    width: 24,
    height: 24
  }, props), _path$2m || (_path$2m = /*#__PURE__*/React.createElement("path", {
    d: "M12 6a3 3 0 103 3 3 3 0 00-3-3zm0 5a2 2 0 112-2 2 2 0 01-2 2z"
  })), _path2$14 || (_path2$14 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13v-1l-.82-5.74A1.47 1.47 0 0017.72 5H17V3a1 1 0 00-1-1H8a1 1 0 00-1 1v2h-.72a1.47 1.47 0 00-1.46 1.26L4 12v1H3v4h1v2a1 1 0 001 1h1v1h2v1h8v-1h2v-1h1a1 1 0 001-1v-2h1v-4zM8 3h2v1a1 1 0 001 1h2a1 1 0 001-1V3h2v11H8zm0 12h8v1H8zm-2 4H5v-6.93l.81-5.66A.47.47 0 016.28 6H7v10H6zm11 1H7v-3h10zm2-1h-1v-3h-1V6h.72a.47.47 0 01.47.41l.81 5.66z"
  })));
};

var _path$2l, _path2$13;

function _extends$2l() { _extends$2l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2l.apply(this, arguments); }

var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2l({
    width: 24,
    height: 24
  }, props), _path$2l || (_path$2l = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 109 9 9 9 0 00-9-9zm0 17a8 8 0 118-8 8 8 0 01-8 8z"
  })), _path2$13 || (_path2$13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.81 16.62c-.33.43-1.32 1.56-2.37 1.28-3.91-1-7.32-6.81-6.26-10.79.27-1.05 1.74-1.35 2.28-1.42a.28.28 0 01.28.16l1.11 2.74a.25.25 0 01-.1.29 4.59 4.59 0 01-2.13.72c-.52 2 1.49 5.31 3.38 5.81.12-.53 1.22-1.25 1.66-1.52A.25.25 0 0115 14l1.85 2.35a.27.27 0 01-.04.27z"
  })));
};

var _path$2k, _path2$12, _path3$b;

function _extends$2k() { _extends$2k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2k.apply(this, arguments); }

var SvgSubscription = function SvgSubscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2k({
    width: 24,
    height: 24
  }, props), _path$2k || (_path$2k = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.46V17H8v-2h4.58a5.44 5.44 0 01.63-1H8v-2h7v.53a5.8 5.8 0 011-.4V5H4v13h8a4.89 4.89 0 010-.54zM8 6h7v2H8zm0 3h7v2H8zm-1 8H5v-2h2zm0-3H5v-2h2zm0-3H5V9h2zm0-3H5V6h2z",
    fillRule: "evenodd"
  })), _path2$12 || (_path2$12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.94 16.82l-1.4.13a2.84 2.84 0 01.05.51 3.09 3.09 0 11-3.09-3.12 3.05 3.05 0 011.21.26l-.84 1.46 4-.37L20.21 12l-.79 1.37a4.27 4.27 0 00-1.92-.45 4.66 4.66 0 104.44 3.9z",
    fillRule: "evenodd"
  })), _path3$b || (_path3$b = /*#__PURE__*/React.createElement("path", {
    d: "M12.62 20H3V3h14v8.94h1V2H2v19h11.27a5.53 5.53 0 01-.65-1z",
    fillRule: "evenodd"
  })));
};

var _path$2j, _path2$11;

function _extends$2j() { _extends$2j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2j.apply(this, arguments); }

var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2j({
    width: 24,
    height: 24
  }, props), _path$2j || (_path$2j = /*#__PURE__*/React.createElement("path", {
    d: "M19 14V5h-5v9h-3l5.5 7.68L22 14zm-6 1h2V6h3v9h2.05l-3.55 5z",
    fillRule: "evenodd"
  })), _path2$11 || (_path2$11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.32L2 10h3v9h5v-9h3zM9 9v9H6V9H4l3.5-5 3.55 5z",
    fillRule: "evenodd"
  })));
};

var _path$2i;

function _extends$2i() { _extends$2i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2i.apply(this, arguments); }

var SvgSocialYoutube = function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2i({
    width: 24,
    height: 24
  }, props), _path$2i || (_path$2i = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 6.75A2.5 2.5 0 0019.81 5C18.25 4.56 12 4.56 12 4.56s-6.25 0-7.81.42a2.51 2.51 0 00-1.77 1.77A25.91 25.91 0 002 11.56a25.91 25.91 0 00.42 4.81 2.51 2.51 0 001.77 1.77c1.56.42 7.81.42 7.81.42s6.25 0 7.81-.42a2.51 2.51 0 001.77-1.77 25.91 25.91 0 00.42-4.81 25.91 25.91 0 00-.42-4.81zM10 14.56v-6l5.2 3z"
  })));
};

var _path$2h;

function _extends$2h() { _extends$2h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2h.apply(this, arguments); }

var SvgSocialTwitter = function SvgSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2h({
    width: 24,
    height: 24
  }, props), _path$2h || (_path$2h = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.93a8.41 8.41 0 01-2.36.63 4.06 4.06 0 001.8-2.23 8.21 8.21 0 01-2.61 1 4.12 4.12 0 00-7.1 2.73 4.06 4.06 0 00.11.92 11.71 11.71 0 01-8.45-4.2 4 4 0 00-.56 2 4 4 0 001.83 3.35 4.17 4.17 0 01-1.86-.5v.07a4.05 4.05 0 003.29 4 4.28 4.28 0 01-1.85.07 4.1 4.1 0 003.83 2.8A8.35 8.35 0 013 18.25a8.39 8.39 0 01-1-.06A11.75 11.75 0 008.29 20 11.48 11.48 0 0020 8.75V8a8.28 8.28 0 002-2.07z"
  })));
};

var _path$2g;

function _extends$2g() { _extends$2g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2g.apply(this, arguments); }

var SvgSocialLinkedin = function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2g({
    width: 24,
    height: 24
  }, props), _path$2g || (_path$2g = /*#__PURE__*/React.createElement("path", {
    d: "M19.67 3H4.33A1.31 1.31 0 003 4.29V19.7A1.31 1.31 0 004.32 21h15.35A1.31 1.31 0 0021 19.7V4.3A1.31 1.31 0 0019.67 3zM8.34 18.34H5.67V9.75h2.67zM7 8.57A1.55 1.55 0 118.55 7 1.54 1.54 0 017 8.57zm11.33 9.76h-2.66v-4.17c0-1 0-2.28-1.39-2.28s-1.6 1.09-1.6 2.21v4.25H10V9.75h2.56v1.17a2.79 2.79 0 012.53-1.39c2.7 0 3.2 1.78 3.2 4.09z"
  })));
};

var _path$2f, _path2$10, _circle$7;

function _extends$2f() { _extends$2f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2f.apply(this, arguments); }

var SvgSocialInstagram = function SvgSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2f({
    width: 24,
    height: 24
  }, props), _path$2f || (_path$2f = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.8c2.67 0 3 0 4 .06a5.66 5.66 0 011.86.34 3.35 3.35 0 011.9 1.9 5.41 5.41 0 01.38 1.9c0 1.05.06 1.37.06 4s0 3-.06 4a5.66 5.66 0 01-.34 1.86 3.35 3.35 0 01-1.9 1.9 5.66 5.66 0 01-1.9.34c-1 0-1.37.06-4 .06s-3 0-4-.06a5.55 5.55 0 01-1.94-.3 3.35 3.35 0 01-1.9-1.9 5.6 5.6 0 01-.3-1.9c0-1.05-.06-1.37-.06-4s0-3 .06-4a5.6 5.6 0 01.34-1.9 3.35 3.35 0 011.9-1.9A5.6 5.6 0 018 3.86c1.05 0 1.37-.06 4-.06M12 2c-2.72 0-3.06 0-4.12.06a7.22 7.22 0 00-2.43.46 5.1 5.1 0 00-2.93 2.93 7.22 7.22 0 00-.46 2.43C2 8.94 2 9.28 2 12s0 3.06.06 4.12a7.22 7.22 0 00.46 2.43 5.12 5.12 0 002.92 2.92 7.22 7.22 0 002.43.46C8.94 22 9.28 22 12 22s3.06 0 4.12-.06a7.22 7.22 0 002.43-.46 5.12 5.12 0 002.92-2.92 7.22 7.22 0 00.46-2.43c0-1.07.06-1.41.06-4.12S22 9 21.93 7.89a7.22 7.22 0 00-.46-2.43 5.12 5.12 0 00-2.92-2.92 7.22 7.22 0 00-2.43-.46C15.06 2 14.72 2 12 2z"
  })), _path2$10 || (_path2$10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.86A5.14 5.14 0 1017.14 12 5.14 5.14 0 0012 6.86zm0 8.47A3.33 3.33 0 1115.33 12 3.33 3.33 0 0112 15.33z"
  })), _circle$7 || (_circle$7 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.34,
    cy: 6.66,
    r: 1.2
  })));
};

var _path$2e;

function _extends$2e() { _extends$2e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2e.apply(this, arguments); }

var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2e({
    width: 24,
    height: 24
  }, props), _path$2e || (_path$2e = /*#__PURE__*/React.createElement("path", {
    d: "M19.37 3H4.63A1.63 1.63 0 003 4.63v14.74A1.63 1.63 0 004.63 21h8.27v-7.2h-2.7v-2.7h2.7v-2c0-2.32 1.37-3.59 3.38-3.59a19 19 0 012 .11V8.4h-1.37c-1.09 0-1.31.54-1.31 1.32v1.38h2.67l-.35 2.7H15.6V21h3.77A1.63 1.63 0 0021 19.37V4.63A1.63 1.63 0 0019.37 3z"
  })));
};

var _path$2d, _path2$$, _path3$a;

function _extends$2d() { _extends$2d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2d.apply(this, arguments); }

var SvgSocialBlog = function SvgSocialBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2d({
    width: 24,
    height: 24
  }, props), _path$2d || (_path$2d = /*#__PURE__*/React.createElement("path", {
    d: "M16.24 8C13 4.72 8.45 3 3 3H2v4h1c8.16 0 13.78 5.63 14 14.08l.07.92H21v-1c.06-5.32-1.59-9.83-4.76-13zM18 21c-.23-9-6.26-15-15-15V4c10.43 0 17.11 6.57 17 17z"
  })), _path2$$ || (_path2$$ = /*#__PURE__*/React.createElement("path", {
    d: "M3 9H2v4h1c4.88 0 7.8 2.91 8 8v.14l.23.82H15V21c0-5.78-3.77-12-12-12zm9 12c-.22-5.66-3.58-9-9-9v-2c7.11 0 11 5.2 11 11z"
  })), _path3$a || (_path3$a = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16A2.5 2.5 0 108 18.5 2.5 2.5 0 005.5 16zm0 4A1.5 1.5 0 117 18.5 1.5 1.5 0 015.5 20z"
  })));
};

var _defs, _path$2c, _path2$_, _path3$9;

function _extends$2c() { _extends$2c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2c.apply(this, arguments); }

var SvgSignOut = function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2c({
    id: "sign-out_svg__assets",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sign-out_svg__cls-1{fill-rule:evenodd}"))), _path$2c || (_path$2c = /*#__PURE__*/React.createElement("path", {
    className: "sign-out_svg__cls-1",
    d: "M2 3v16l8 3V6zm1 1.44v13.87l6 2.25V6.69z"
  })), _path2$_ || (_path2$_ = /*#__PURE__*/React.createElement("path", {
    d: "M7 12h1v2H7zM13 4v4h1V3H2v1zM11 19v1h3v-6h-1v5z"
  })), _path3$9 || (_path3$9 = /*#__PURE__*/React.createElement("path", {
    className: "sign-out_svg__cls-1",
    d: "M16 9h-4v4h4v3l6-5-6-5zm1-.86V10h-4v2h4v1.86L20.44 11z"
  })));
};

var _path$2b;

function _extends$2b() { _extends$2b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2b.apply(this, arguments); }

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2b({
    width: 24,
    height: 24
  }, props), _path$2b || (_path$2b = /*#__PURE__*/React.createElement("path", {
    d: "M16 16a3 3 0 00-2.14.9L8.7 13.29a2.9 2.9 0 000-2.59l5.16-3.61a3.08 3.08 0 10-.56-.82L8.12 9.88a3 3 0 100 4.23l5.16 3.61A3 3 0 0013 19a3 3 0 103-3zm0-13a2 2 0 11-2 2 2 2 0 012-2zM6 14a2 2 0 112-2 2 2 0 01-2 2zm10 7a2 2 0 112-2 2 2 0 01-2 2z"
  })));
};

var _path$2a, _path2$Z;

function _extends$2a() { _extends$2a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2a.apply(this, arguments); }

var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2a({
    width: 24,
    height: 24
  }, props), _path$2a || (_path$2a = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.67A4.33 4.33 0 1016.33 12 4.34 4.34 0 0012 7.67zm0 7.66A3.33 3.33 0 1115.33 12 3.33 3.33 0 0112 15.33z"
  })), _path2$Z || (_path2$Z = /*#__PURE__*/React.createElement("path", {
    d: "M22 14v-4h-2.95a7.22 7.22 0 00-.65-1.57l2.09-2.09-2.83-2.83-2.09 2.09A7.22 7.22 0 0014 5V2h-4v3a7.22 7.22 0 00-1.57.65L6.34 3.51 3.51 6.34 5.6 8.43A7.22 7.22 0 005 10H2v4h3a7.22 7.22 0 00.65 1.57l-2.14 2.09 2.83 2.83 2.09-2.09a7.22 7.22 0 001.57.65V22h4v-2.95a7.22 7.22 0 001.57-.65l2.09 2.09 2.83-2.83-2.09-2.09a7.22 7.22 0 00.65-1.57zm-2.93 3.66l-1.41 1.41-1.91-1.91-.66.37a7.07 7.07 0 01-1.36.56l-.73.2V21h-2v-2.71l-.73-.2a7.07 7.07 0 01-1.36-.56l-.66-.37-1.91 1.91-1.41-1.41 1.91-1.92-.37-.66a6.73 6.73 0 01-.56-1.35l-.2-.73H3v-2h2.71l.2-.73a6.73 6.73 0 01.56-1.35l.37-.66-1.91-1.92 1.41-1.41 1.91 1.91.66-.37a7.07 7.07 0 011.36-.56l.73-.2V3h2v2.71l.73.2a7.07 7.07 0 011.36.56l.66.37 1.91-1.91 1.41 1.41-1.91 1.92.37.66a6.73 6.73 0 01.56 1.35l.2.73H21v2h-2.71l-.2.73a6.73 6.73 0 01-.56 1.35l-.37.66z"
  })));
};

var _path$29;

function _extends$29() { _extends$29 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$29.apply(this, arguments); }

var SvgService = function SvgService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$29({
    width: 24,
    height: 24
  }, props), _path$29 || (_path$29 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2A10 10 0 002 12a9.88 9.88 0 001.62 5.43v.05c.18.26.36.53.56.78l4.92-4.92-.23-.61a4.11 4.11 0 01.93-4.37 4.07 4.07 0 012.89-1.2 4.19 4.19 0 011.31.2l-2.86 2.86.14 2.4 2.44.22L16.64 10a4.11 4.11 0 01-5.36 5.14l-.61-.23-4.21 4.17-.72.72c.25.2.52.38.78.56h.05A9.88 9.88 0 0012 22a10 10 0 000-20zm0 19a9 9 0 01-4.7-1.34L10.92 16a5.1 5.1 0 006-7.74l-3.5 3.51-1.12-.1-.07-1.09 3.51-3.5a5.1 5.1 0 00-7.74 6L4.34 16.7A9 9 0 1112 21z"
  })));
};

var _path$28, _path2$Y;

function _extends$28() { _extends$28 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$28.apply(this, arguments); }

var SvgSelectNone = function SvgSelectNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$28({
    width: 24,
    height: 24
  }, props), _path$28 || (_path$28 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7v1h2v12H8v-2H7v3h14V7h-3z"
  })), _path2$Y || (_path2$Y = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H3v14h14zm-1 13H4V4h12z"
  })));
};

var _path$27, _path2$X, _path3$8;

function _extends$27() { _extends$27 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$27.apply(this, arguments); }

var SvgSelectAll = function SvgSelectAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$27({
    width: 24,
    height: 24
  }, props), _path$27 || (_path$27 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7v1h2v12H8v-2H7v3h14V7z"
  })), _path2$X || (_path2$X = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H3v14h14zm-1 13H4V4h12z"
  })), _path3$8 || (_path3$8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.45 7.79l-.71-.71-4.24 4.25-1.92-1.91-.7.7 2.62 2.63 4.95-4.96z"
  })));
};

var _path$26;

function _extends$26() { _extends$26 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$26.apply(this, arguments); }

var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$26({
    width: 24,
    height: 24
  }, props), _path$26 || (_path$26 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6a9.84 9.84 0 01-7-3 9.84 9.84 0 01-7 3H4c0 11.39 7.14 15 8 15s8-3.61 8-15.06c-.2.06-.64.06-1 .06zm-7 14c-.78-.33-6.59-3.2-7-13a10.83 10.83 0 007-2.61A10.83 10.83 0 0019 7c-.41 9.77-6.22 12.64-7 13z"
  })));
};

var _path$25;

function _extends$25() { _extends$25 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$25.apply(this, arguments); }

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$25({
    width: 24,
    height: 24
  }, props), _path$25 || (_path$25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.44 13.32l-.56.56-.46-.46A6.92 6.92 0 0017 9a7 7 0 10-7 7 6.92 6.92 0 004.42-1.58l.46.46-.56.56 5.33 5.32 2.11-2.11zM10 15a6 6 0 116-6 6 6 0 01-6 6zm5.74.44l.7-.7 3.91 3.91-.7.7z"
  })));
};

var _path$24, _path2$W;

function _extends$24() { _extends$24 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$24.apply(this, arguments); }

var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$24({
    width: 24,
    height: 24
  }, props), _path$24 || (_path$24 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3H3v15l3 3h15V3zm-1 1v7H7V4zM7 20v-5h10v5zm13 0h-2v-6H6v5.59l-2-2V4h2v8h12V4h2z",
    fillRule: "evenodd"
  })), _path2$W || (_path2$W = /*#__PURE__*/React.createElement("path", {
    d: "M8 16h2v3H8z"
  })));
};

var _path$23, _path2$V, _path3$7, _path4$1;

function _extends$23() { _extends$23 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$23.apply(this, arguments); }

var SvgSaveAs = function SvgSaveAs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$23({
    width: 24,
    height: 24
  }, props), _path$23 || (_path$23 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14h10v.37l1-1V13H5v5.59l-2-2V3h2v8h12V3h2v8.4a1.64 1.64 0 01.73-.37L20 11V2H2v15l3 3h6.52l.28-1H6zM6 3h10v7H6zM12.86 18.93L12 22l3.07-.86h.01l-2.22-2.22v.01z",
    fillRule: "evenodd"
  })), _path2$V || (_path2$V = /*#__PURE__*/React.createElement("path", {
    d: "M13.578 18.22l4.101-4.102 2.213 2.213-4.1 4.102z"
  })), _path3$7 || (_path3$7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.12 12h-.19a.62.62 0 00-.32.17l-1.23 1.23 2.21 2.21 1.23-1.23a.62.62 0 00.17-.32v-.15A1.88 1.88 0 0020.12 12z",
    fillRule: "evenodd"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15h2v3H7z"
  })));
};

var _path$22, _path2$U;

function _extends$22() { _extends$22 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$22.apply(this, arguments); }

var SvgReport = function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$22({
    width: 24,
    height: 24
  }, props), _path$22 || (_path$22 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2v20h17V2zm16 19H4V3h15z"
  })), _path2$U || (_path2$U = /*#__PURE__*/React.createElement("path", {
    d: "M18 19h-1v-7h-3v7h-1v-5h-3v5H9v-9H6v9H5v1h13zM8 19H7v-8h1zm4 0h-1v-4h1zm4 0h-1v-6h1zM5 5h13v1H5zM5 7h6v1H5z"
  })));
};

var _path$21, _path2$T;

function _extends$21() { _extends$21 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$21.apply(this, arguments); }

var SvgRename = function SvgRename(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$21({
    viewBox: "0 0 24 24"
  }, props), _path$21 || (_path$21 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4h1V3h-3v1h1v15h-1v1h3v-1h-1V4zM15 17H3V6h12V5H2v13h13v-1z"
  })), _path2$T || (_path2$T = /*#__PURE__*/React.createElement("path", {
    d: "M15 8V7H4v9h11v-1H5V8h10zM18 5v1h3v11h-3v1h4V5h-4z"
  })));
};

var _path$20;

function _extends$20() { _extends$20 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$20.apply(this, arguments); }

var SvgRemove = function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$20({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$20 || (_path$20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10H3v4h18v-4zm-1 3H4v-2h16v2z",
    fill: "gray"
  })));
};

var _path$1$;

function _extends$1$() { _extends$1$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$.apply(this, arguments); }

var SvgRedo = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1$({
    width: 24,
    height: 24
  }, props), _path$1$ || (_path$1$ = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.5L12 4v4h-1.57C5.27 8 2 12.36 2 17.17v1.61C4 16 5.66 15 9.5 15H12v4zM9.5 14c-3.06 0-4.88.7-6.41 2.07.44-3.59 3-7 7.34-7H13V6l7.33 5.5L13 17v-3z"
  })));
};

var _path$1_;

function _extends$1_() { _extends$1_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1_.apply(this, arguments); }

var SvgRecommend = function SvgRecommend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1_({
    width: 24,
    height: 24
  }, props), _path$1_ || (_path$1_ = /*#__PURE__*/React.createElement("path", {
    d: "M20.68 11.35A2.4 2.4 0 0018.26 9h-4.6c.06-.2.13-.42.21-.65a12.11 12.11 0 00.8-4.12.89.89 0 000-.23 2.09 2.09 0 00-2.08-2h-.17a2.14 2.14 0 00-2.09 2.16c0 1.19-1.56 3.22-2.69 4.7a11.86 11.86 0 00-1.84 2.78 2.27 2.27 0 01-.66.41A2 2 0 004 13.81V18a2 2 0 001.6 2 2.15 2.15 0 01.54.39q.18.16.36.3A6.24 6.24 0 0010.24 22h4.53A3.37 3.37 0 0018 19.67a2.34 2.34 0 001.59-2.24 2.31 2.31 0 00-.11-.69 2.39 2.39 0 00.52-3.69 2.39 2.39 0 00.68-1.7zm-2.43 1.94a1.38 1.38 0 010 2.76.25.25 0 00-.23.21c0 .17.07.16.22.35a1.4 1.4 0 01.28.82 1.37 1.37 0 01-1.27 1.37.16.16 0 00-.12.05.22.22 0 00-.06.13 2.35 2.35 0 01-2.35 2h-4.48a5.19 5.19 0 01-3.14-1.04c-.38-.29-.78-.78-1.33-.87a1 1 0 01-.77-1v-4.26a1 1 0 01.57-.81c.45-.22 1-.54 1.14-.93.57-1.63 4.62-5.42 4.62-7.87A1.14 1.14 0 0112.44 3h.08a1.09 1.09 0 011.15 1 .28.28 0 010 .13c0 2.79-1.21 4.37-1.21 5.82h5.8a1.39 1.39 0 011.42 1.37 1.41 1.41 0 01-1.43 1.42.26.26 0 000 .52z"
  })));
};

var _path$1Z, _path2$S, _path3$6;

function _extends$1Z() { _extends$1Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Z.apply(this, arguments); }

var SvgRecentFile = function SvgRecentFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Z({
    width: 24,
    height: 24
  }, props), _path$1Z || (_path$1Z = /*#__PURE__*/React.createElement("path", {
    d: "M3 19V7h4V3h10v5.15c.34.07.68.17 1 .29V2H7L2 7v13h7.51c-.24-.32-.46-.65-.64-1H3zM6 4.41V6H4.41L6 4.41z"
  })), _path2$S || (_path2$S = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm0 12c-3.04 0-5.5-2.46-5.5-5.5s2.46-5.5 5.5-5.5 5.5 2.46 5.5 5.5-2.46 5.5-5.5 5.5z"
  })), _path3$6 || (_path3$6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15v-4h-1v5h5v-1h-4z"
  })));
};

var _path$1Y, _path2$R;

function _extends$1Y() { _extends$1Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Y.apply(this, arguments); }

var SvgQuantities = function SvgQuantities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Y({
    width: 24,
    height: 24
  }, props), _path$1Y || (_path$1Y = /*#__PURE__*/React.createElement("path", {
    d: "M22 15h-5v-4h4V2H10v9h4v4H2v5h2v2h16v-2h2zm-11-5V3h9v7zm4 1h1v4h-1zm4 10H5v-1h14zm2-2H3v-3h18z"
  })), _path2$R || (_path2$R = /*#__PURE__*/React.createElement("path", {
    d: "M18 5v1h-5V5h5m1-1h-7v3h7zM17 8h2v1h-2z"
  })));
};

var _path$1X, _path2$Q, _path3$5;

function _extends$1X() { _extends$1X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1X.apply(this, arguments); }

var SvgPublish = function SvgPublish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1X({
    width: 24,
    height: 24
  }, props), _path$1X || (_path$1X = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.32L7 10h3v6h5v-6h3zM14 9v6h-3V9H9l3.5-5 3.55 5z",
    fillRule: "evenodd"
  })), _path2$Q || (_path2$Q = /*#__PURE__*/React.createElement("path", {
    d: "M3 17v5h18v-5zm17 4H4v-3h16z"
  })), _path3$5 || (_path3$5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19h12v1H6z"
  })));
};

var _path$1W, _path2$P, _path3$4;

function _extends$1W() { _extends$1W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1W.apply(this, arguments); }

var SvgProperties = function SvgProperties(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1W({
    width: 24,
    height: 24
  }, props), _path$1W || (_path$1W = /*#__PURE__*/React.createElement("path", {
    d: "M20 2H3v20h17zm-1 19H4V3h15z"
  })), _path2$P || (_path2$P = /*#__PURE__*/React.createElement("path", {
    d: "M5 10h13V4H5zm1-5h11v4H6zM13 14v2h3v-2h2v-1h-2v-2h-3v2H5v1zm1-2h1v3h-1z"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18v2h3v-2h8v-1h-8v-2H7v2H5v1zm1-2h1v3H8z"
  })));
};

var _path$1V, _path2$O, _path3$3, _path4, _path5, _path6;

function _extends$1V() { _extends$1V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1V.apply(this, arguments); }

var SvgProjectManagement = function SvgProjectManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1V({
    width: 24,
    height: 24
  }, props), _path$1V || (_path$1V = /*#__PURE__*/React.createElement("path", {
    d: "M5 6h10v1H5z"
  })), _path2$O || (_path2$O = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H5v1h10V6zM5 9h10v1H5z"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9H5v1h10V9zM16.5 11a5.5 5.5 0 105.5 5.5 5.5 5.5 0 00-5.5-5.5zm0 10a4.5 4.5 0 114.5-4.5 4.49 4.49 0 01-4.5 4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16v-3h-1v4h4v-1h-3zM10.18 18H3V3h14v7a6.72 6.72 0 011 .16V2H2v17h8.5a6.85 6.85 0 01-.32-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.82 12H5v1h6a6.51 6.51 0 01.82-1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.82 12H5v1h6a6.32 6.32 0 01.79-1z"
  })));
};

var _path$1U;

function _extends$1U() { _extends$1U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1U.apply(this, arguments); }

var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1U({
    width: 24,
    height: 24
  }, props), _path$1U || (_path$1U = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zM8.12 20.11a.4.4 0 01-.12-.23v-2.3c0-3.63 2.51-4.17 4-4.17s4 .54 4 4.17v2.47a8.88 8.88 0 01-7.88.06zM12 12c-1.2 0-2-1.29-2-2.5S10.8 7 12 7s2 1.29 2 2.5-.8 2.5-2 2.5zm4 8.05a8.91 8.91 0 001-.57v-1.9c0-2.71-1.32-4.49-3.59-5A3.7 3.7 0 0015 9.5C15 7.82 13.85 6 12 6S9 7.82 9 9.5a3.7 3.7 0 001.59 3.08c-2.26.51-3.59 2.29-3.59 5v1.89a8.23 8.23 0 001.12.63 9 9 0 117.88-.05z"
  })));
};

var _path$1T, _path2$N;

function _extends$1T() { _extends$1T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1T.apply(this, arguments); }

var SvgProductsAndServices = function SvgProductsAndServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1T({
    width: 24,
    height: 24
  }, props), _path$1T || (_path$1T = /*#__PURE__*/React.createElement("path", {
    d: "M20.42 5.89l-8-3.7a1 1 0 00-.84 0l-8 3.7a1 1 0 00-.58.9v8.91a1 1 0 00.47.84l8 5a1 1 0 001.06 0l8-5a1 1 0 00.47-.84V6.79a1 1 0 00-.58-.9zM20 15.56a.24.24 0 01-.12.21l-7.75 4.82a.24.24 0 01-.26 0l-7.75-4.82a.24.24 0 01-.12-.21V7a.24.24 0 01.15-.22l7.75-3.63a.23.23 0 01.2 0l7.75 3.58A.24.24 0 0120 7z"
  })), _path2$N || (_path2$N = /*#__PURE__*/React.createElement("path", {
    d: "M18.93 7.4l-.39-.18a.08.08 0 00-.09 0l-6.45 4-6.45-4a.07.07 0 00-.09 0l-.39.18a.12.12 0 00-.07.11V8a.11.11 0 000 .08l6.46 4v7a.11.11 0 000 .08l.4.24a.09.09 0 00.12 0l.4-.24a.11.11 0 000-.08v-7l6.46-4A.14.14 0 0019 8v-.5a.12.12 0 00-.07-.1z"
  })));
};

var _path$1S;

function _extends$1S() { _extends$1S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1S.apply(this, arguments); }

var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1S({
    width: 24,
    height: 24
  }, props), _path$1S || (_path$1S = /*#__PURE__*/React.createElement("path", {
    d: "M18 6V2H6v4H2v12h4v4h12v-4h4V6zM7 3h10v6H7zm10 18H7v-5h1v4h8v-4h1zm-8-5h6v3H9zm12 1h-3v-2H6v2H3V7h3v3h12V7h3z"
  })));
};

var _path$1R;

function _extends$1R() { _extends$1R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1R.apply(this, arguments); }

var SvgPlaybackStop = function SvgPlaybackStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1R({
    width: 24,
    height: 24
  }, props), _path$1R || (_path$1R = /*#__PURE__*/React.createElement("path", {
    d: "M4 4v16h16V4zm15 15H5V5h14z"
  })));
};

var _path$1Q;

function _extends$1Q() { _extends$1Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Q.apply(this, arguments); }

var SvgPlaybackShuffle = function SvgPlaybackShuffle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Q({
    width: 24,
    height: 24
  }, props), _path$1Q || (_path$1Q = /*#__PURE__*/React.createElement("path", {
    d: "M15 15l-2.14-3L15 9v3l7-5-7-5v3a4.41 4.41 0 00-3.44 1.73l-1.23 1.72-.51-.72A4.36 4.36 0 006.35 6H2v4h4.35l1.43 2-1.43 2H2v4h4.35a4.36 4.36 0 003.47-1.73l.51-.72 1.23 1.72A4.41 4.41 0 0015 19v3l7-5-7-5zM7.16 9.42A1 1 0 006.35 9H3V7h3.35A3.35 3.35 0 019 8.31l.71 1-1.31 1.83zM9 15.69A3.35 3.35 0 016.35 17H3v-2h3.35a1 1 0 00.81-.42l5.22-7.26A3.33 3.33 0 0115 6h1V3.94L20.28 7 16 10.06V8h-1a1 1 0 00-.81.42zm7-1.75L20.28 17 16 20.06V18h-1a3.33 3.33 0 01-2.66-1.32l-1.43-2 1.3-1.83 1.94 2.72A1 1 0 0015 16h1z"
  })));
};

var _path$1P;

function _extends$1P() { _extends$1P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1P.apply(this, arguments); }

var SvgPlaybackRewind = function SvgPlaybackRewind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1P({
    width: 24,
    height: 24
  }, props), _path$1P || (_path$1P = /*#__PURE__*/React.createElement("path", {
    d: "M12 12l10 7V5zm9 5.08L13.74 12 21 6.92zM2 12l10 7V5zm9 5.08L3.74 12 11 6.92z"
  })));
};

var _path$1O;

function _extends$1O() { _extends$1O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1O.apply(this, arguments); }

var SvgPlaybackRecord = function SvgPlaybackRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1O({
    width: 24,
    height: 24
  }, props), _path$1O || (_path$1O = /*#__PURE__*/React.createElement("path", {
    d: "M12 4a8 8 0 108 8 8 8 0 00-8-8zm0 15a7 7 0 117-7 7 7 0 01-7 7z"
  })));
};

var _path$1N;

function _extends$1N() { _extends$1N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1N.apply(this, arguments); }

var SvgPlaybackPrevious = function SvgPlaybackPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1N({
    width: 24,
    height: 24
  }, props), _path$1N || (_path$1N = /*#__PURE__*/React.createElement("path", {
    d: "M7 12l11 7V5zm10 5.18L8.86 12 17 6.82zM6 4v16h1V4H6z"
  })));
};

var _path$1M;

function _extends$1M() { _extends$1M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1M.apply(this, arguments); }

var SvgPlaybackPlay = function SvgPlaybackPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1M({
    width: 24,
    height: 24
  }, props), _path$1M || (_path$1M = /*#__PURE__*/React.createElement("path", {
    d: "M6 3v18l14-9zm1 1.83L18.15 12 7 19.17z"
  })));
};

var _path$1L;

function _extends$1L() { _extends$1L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1L.apply(this, arguments); }

var SvgPlaybackPause = function SvgPlaybackPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1L({
    width: 24,
    height: 24
  }, props), _path$1L || (_path$1L = /*#__PURE__*/React.createElement("path", {
    d: "M4 20h7V4H4zM5 5h5v14H5zM13 4v16h7V4zm6 15h-5V5h5z"
  })));
};

var _path$1K;

function _extends$1K() { _extends$1K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1K.apply(this, arguments); }

var SvgPlaybackNext = function SvgPlaybackNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1K({
    width: 24,
    height: 24
  }, props), _path$1K || (_path$1K = /*#__PURE__*/React.createElement("path", {
    d: "M6 19l11-7L6 5zM7 6.82L15.14 12 7 17.18zM17 4v16h1V4h-1z"
  })));
};

var _path$1J;

function _extends$1J() { _extends$1J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1J.apply(this, arguments); }

var SvgPlaybackLoop = function SvgPlaybackLoop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1J({
    width: 24,
    height: 24
  }, props), _path$1J || (_path$1J = /*#__PURE__*/React.createElement("path", {
    d: "M15 7L8 2v3H6a4 4 0 00-4 4v6a4 4 0 004 4h1v-4H6V9h2v3zM6 8a1 1 0 00-1 1v6a1 1 0 001 1v2a3 3 0 01-3-3V9a3 3 0 013-3h3V3.94L13.28 7 9 10.06V8H6zM18 5h-1v4h1v6h-2v-3l-7 5 7 5v-3h2a4 4 0 004-4V9a4 4 0 00-4-4zm3 10a3 3 0 01-3 3h-3v2.06L10.72 17 15 13.94V16h3a1 1 0 001-1V9a1 1 0 00-1-1V6a3 3 0 013 3z"
  })));
};

var _path$1I;

function _extends$1I() { _extends$1I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }

var SvgPlaybackGoToStart = function SvgPlaybackGoToStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1I({
    width: 24,
    height: 24
  }, props), _path$1I || (_path$1I = /*#__PURE__*/React.createElement("path", {
    d: "M22 6l-9 5.4V6L3 12l10 6v-5.4l9 5.4zM12 16.23L4.94 12 12 7.77zm9 0L13.94 12 21 7.77zM2 4v16h1V4H2z"
  })));
};

var _path$1H;

function _extends$1H() { _extends$1H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }

var SvgPlaybackGoToEnd = function SvgPlaybackGoToEnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1H({
    width: 24,
    height: 24
  }, props), _path$1H || (_path$1H = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.4L2 6v12l9-5.4V18l10-6-10-6zm-8 4.83V7.77L10.06 12zm9-8.46L19.06 12 12 16.23zM21 4v16h1V4h-1z"
  })));
};

var _path$1G;

function _extends$1G() { _extends$1G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }

var SvgPlaybackFastForward = function SvgPlaybackFastForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1G({
    width: 24,
    height: 24
  }, props), _path$1G || (_path$1G = /*#__PURE__*/React.createElement("path", {
    d: "M2 19l10-7L2 5zM3 6.92L10.26 12 3 17.08zM22 12L12 5v14zm-9-5.08L20.26 12 13 17.08z"
  })));
};

var _path$1F;

function _extends$1F() { _extends$1F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }

var SvgPlaceholder = function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1F({
    width: 24,
    height: 24
  }, props), _path$1F || (_path$1F = /*#__PURE__*/React.createElement("path", {
    d: "M20.11 6.17l-.81.59a9.07 9.07 0 011.33 2.7l1-.28a9.81 9.81 0 00-1.52-3.01zM15.45 3.69A9 9 0 0118 5.3l.66-.75a9.84 9.84 0 00-2.81-1.78zM19.94 16.24a9.08 9.08 0 01-1.85 2.37l.68.74a10.13 10.13 0 002.05-2.64zM2.09 10.75l1 .13A8.81 8.81 0 014 8l-.9-.45a10 10 0 00-1.01 3.2zM21 12a8.63 8.63 0 01-.34 2.42l1 .26A10.1 10.1 0 0022 12v-.68l-1 .08zM9 3.52a8.6 8.6 0 014.55-.37l.17-1a9.75 9.75 0 00-5.05.41zM5 6.34a8.77 8.77 0 012.25-2l-.53-.86a9.92 9.92 0 00-2.5 2.2zM7.06 19.51a9.15 9.15 0 01-2.22-2.08L4 18a10 10 0 002.47 2.31zM16.51 19.77a8.81 8.81 0 01-2.8 1.06l.19 1a9.91 9.91 0 003.1-1.19zM3.83 15.76A9 9 0 013 12.83l-1 .09a10 10 0 00.87 3.26zM11.74 22v-1a9 9 0 01-3-.59l-.36.94a9.88 9.88 0 003.36.65z"
  })));
};

var _path$1E;

function _extends$1E() { _extends$1E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }

var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1E({
    width: 24,
    height: 24
  }, props), _path$1E || (_path$1E = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 2l-3.26 3.26 1.09 1.08L9 9.6H4.63l-1.09 1.09L8 15.11l-4.71 5.58L8.87 16l4.44 4.45 1.09-1.09V15l3.26-3.26 1.08 1.09L22 9.6zm-1 17l-.09.08L5 10.69v-.09h4.39l4 4zm.5-4.84l-4-4 3.27-3.27 4 4zm4.32-3.2l-5-5-.61-.61 1.79-1.94 6.19 6.19-1.85 1.84z"
  })));
};

var _path$1D, _path2$M, _path3$2;

function _extends$1D() { _extends$1D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }

var SvgPhotos = function SvgPhotos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1D({
    width: 24,
    height: 24
  }, props), _path$1D || (_path$1D = /*#__PURE__*/React.createElement("path", {
    d: "M5 3v2h1V4h14v14h-1v1h2V3H5z"
  })), _path2$M || (_path2$M = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8a2.5 2.5 0 102.5 2.5A2.5 2.5 0 0013.5 8zm0 4a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5z",
    fillRule: "evenodd"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6v16h16V6zm15 15H3v-3.38l2.43-3.09a1.63 1.63 0 012.63 0l.3.41 3 3.89a1.34 1.34 0 001.08.54 1.35 1.35 0 001-.48l1-1.22.18-.21a.66.66 0 01.49-.22.63.63 0 01.55.32L17 19.71zm-.43-3.93a1.63 1.63 0 00-1.43-.85 1.61 1.61 0 00-1.24.57l-1.21 1.43a.37.37 0 01-.57 0l-3.25-4.3a2.63 2.63 0 00-4.23 0L3 16V7h14v10.78z"
  })));
};

var _path$1C;

function _extends$1C() { _extends$1C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }

var SvgPermissionIndividual = function SvgPermissionIndividual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1C({
    width: 24,
    height: 24
  }, props), _path$1C || (_path$1C = /*#__PURE__*/React.createElement("path", {
    d: "M13.33 10.54A3.9 3.9 0 0015 7c0-2.43-1.29-4-3.35-4A3.69 3.69 0 008 6.72V7a3.94 3.94 0 001.87 3.54C7.35 11.17 6 13.33 6 17v4h11v-4c0-3.71-1.14-5.83-3.67-6.46zM9 7a2.72 2.72 0 012.42-3h.18C13.39 4 14 5.55 14 7s-.59 3-2.35 3A2.72 2.72 0 019 7.22 1.64 1.64 0 019 7zm7.08 13.08H7V17c0-5.11 2.67-5.71 4.63-5.71 3.12 0 4.47 1.76 4.47 5.71z"
  })));
};

var _path$1B;

function _extends$1B() { _extends$1B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }

var SvgPermissionGroup = function SvgPermissionGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1B({
    width: 24,
    height: 24
  }, props), _path$1B || (_path$1B = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 11.67a4.34 4.34 0 002-3.74 3.65 3.65 0 00-3.39-3.84A3.62 3.62 0 005 7.83v.09a4 4 0 002 3.72c-2.08.46-3 2.11-3 5.36v4h9v-3.7c0-3.3-.92-5.12-3.1-5.63zM6 7.92A2.61 2.61 0 018.4 5.1h.15a2.66 2.66 0 012.39 2.84c0 1.46-1 3.09-2.39 3.09A2.86 2.86 0 016 7.92zM5 20v-3c.08-3.6 1.22-4.37 3.1-4.45h.65c2 .09 3.25.94 3.25 4.84V20zM17.5 13.16a3.66 3.66 0 001.5-3.07 3 3 0 00-2.71-3.26h-.11a3.15 3.15 0 00-3.1 3.2v.07a3.52 3.52 0 001.63 3.05 3 3 0 00-1.07.52l.62.78a2.59 2.59 0 011.55-.45h.54C18 14 19 14.72 19 17.89V20h-5v1h6v-3.11c0-2.75-.79-4.24-2.5-4.73zm-3.42-3.07a2.15 2.15 0 012-2.27h.09A2.06 2.06 0 0118 10.09c0 1.17-.74 2.47-1.82 2.47a2.27 2.27 0 01-2.1-2.45z"
  })));
};

var _path$1A, _path2$L;

function _extends$1A() { _extends$1A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }

var SvgPaste = function SvgPaste(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1A({
    width: 24,
    height: 24
  }, props), _path$1A || (_path$1A = /*#__PURE__*/React.createElement("path", {
    d: "M10 19H3V5h1v2h9V5h1v3h1V4h-2a1 1 0 00-1-1h-1V2H6v1H5a1 1 0 00-1 1H2v16h8zM5 4h2V3h3v1h2v2H5z"
  })), _path2$L || (_path2$L = /*#__PURE__*/React.createElement("path", {
    d: "M19 9h-8v13h11V12zm2 12h-9V10h7v2h2z"
  })));
};

var _path$1z, _path2$K, _circle$6;

function _extends$1z() { _extends$1z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }

var SvgOnlineViewers = function SvgOnlineViewers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1z({
    width: 24,
    height: 24
  }, props), _path$1z || (_path$1z = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 18.67A15.37 15.37 0 017.63 16h1.74c.24-.26.57-.61 1-1h-3A17 17 0 017 12h3.62v2.75c.3-.27.63-.55 1-.83V12h3.62v.19a3.84 3.84 0 01.76-.08h.22V12h3a8.75 8.75 0 01-.22 1 7.17 7.17 0 01.75.46 8 8 0 00.25-2A8.76 8.76 0 0011 3a8.76 8.76 0 00-9 8.5 8.76 8.76 0 009 8.5c-.43-.37-.81-.73-1.12-1.05a10 10 0 01-1.13-.28zM19.18 11h-3a16.78 16.78 0 00-.33-3h2.36a8.22 8.22 0 01.97 3zm-1.64-4h-1.89a14.44 14.44 0 00-.79-2.12A7.72 7.72 0 0117.54 7zm-5.91-3a5.53 5.53 0 011.87.33A15.37 15.37 0 0114.62 7h-3zm3.23 4a16.14 16.14 0 01.39 3h-3.62V8zm-4.24 3H7a17 17 0 01.39-3h3.24zM8.75 4.33A5.53 5.53 0 0110.62 4v3h-3a15.37 15.37 0 011.13-2.67zm-1.36.55A14.44 14.44 0 006.6 7H4.71a7.72 7.72 0 012.68-2.12zM4 8h2.36A16.78 16.78 0 006 11H3a8.22 8.22 0 011-3zm0 7a8.22 8.22 0 01-.93-3H6a16.78 16.78 0 00.33 3zm.71 1H6.6a14.44 14.44 0 00.79 2.12A7.72 7.72 0 014.71 16z"
  })), _path2$K || (_path2$K = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.36c-2.82 0-6 3.82-6 3.82S13.05 21 16 21s6-3.81 6-3.81-3.11-3.83-6-3.83zm0 5.82a2 2 0 112-2 2 2 0 01-2 2z"
  })), _circle$6 || (_circle$6 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 17.18,
    r: 1
  })));
};

var _path$1y;

function _extends$1y() { _extends$1y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }

var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1y({
    width: 24,
    height: 24
  }, props), _path$1y || (_path$1y = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.54V10a6 6 0 00-4-5.65V2h-4v2.35A6 6 0 006 10v4.54A5.4 5.4 0 003 19h6a3 3 0 006 0h6a5.4 5.4 0 00-3-4.46zM12 21a2 2 0 01-2-2h4a2 2 0 01-2 2zm-7.83-3a5.1 5.1 0 012.34-2.6l.49-.3V10a5 5 0 013.33-4.71l.67-.23V3h2v2.06l.67.23A5 5 0 0117 10v5.1l.49.3a5.1 5.1 0 012.34 2.6z"
  })));
};

var _path$1x;

function _extends$1x() { _extends$1x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }

var SvgNotificationOff = function SvgNotificationOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1x({
    width: 24,
    height: 24
  }, props), _path$1x || (_path$1x = /*#__PURE__*/React.createElement("path", {
    d: "M10.33 5.29l.67-.23V3h2v2.06l.67.23A5 5 0 0117 10v4.88l.58.58a5.48 5.48 0 012 2L21 18.87a5.47 5.47 0 00-3-4.33V10a6 6 0 00-4-5.65V2h-4v2.35a5.91 5.91 0 00-2.17 1.36l.71.71a5 5 0 011.79-1.13zM4.17 18a5.1 5.1 0 012.34-2.6l.49-.3V10a4.43 4.43 0 01.07-.81l-.83-.83A5.91 5.91 0 006 10v4.54A5.4 5.4 0 003 19h6a3 3 0 006 0h1.88l-1-1zM12 21a2 2 0 01-2-2h4a2 2 0 01-2 2zM21 18.89l-.11.11H21v-.11zM4.413 5.12l.707-.707L19.588 18.88l-.707.707z"
  })));
};

var _path$1w;

function _extends$1w() { _extends$1w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }

var SvgNotEditable = function SvgNotEditable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1w({
    width: 24,
    height: 24
  }, props), _path$1w || (_path$1w = /*#__PURE__*/React.createElement("path", {
    d: "M17.62 3h-.34a1.16 1.16 0 00-.59.31L11.07 9l.71.71L15 6.47 17.53 9l-3.19 3.18.71.71 5.62-5.62a1.16 1.16 0 00.33-.55 2.45 2.45 0 000-.27v-.07A3.38 3.38 0 0017.62 3zM20 6.58l-1.77 1.76-2.56-2.57L17.4 4h.15A2.4 2.4 0 0120 6.38v.2zM8.75 17.82l-2.57-2.57 3.48-3.47-.66-.71-4.4 4.39L3 21l5.54-1.55 4.39-4.4-.71-.71zm-.75.73l-3.57 1 1-3.57L8 18.53zM4.413 5.12l.707-.707L19.588 18.88l-.707.707z"
  })));
};

var _path$1v;

function _extends$1v() { _extends$1v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }

var SvgMute = function SvgMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1v({
    width: 24,
    height: 24
  }, props), _path$1v || (_path$1v = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H2v7h3l7 5V4zm0 6H3v-5h2zm6 4.06l-5-3.57v-6l5-3.57zM20.33 10.38l-.71-.71-2.12 2.12-2.12-2.12-.71.71 2.12 2.12-2.12 2.12.71.71 2.12-2.12 2.12 2.12.71-.71-2.12-2.12 2.12-2.12z"
  })));
};

var _path$1u;

function _extends$1u() { _extends$1u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }

var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1u({
    width: 24,
    height: 24
  }, props), _path$1u || (_path$1u = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10a2.5 2.5 0 102.5 2.5 2.5 2.5 0 00-2.5-2.5zm0 4a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zM11.5 10a2.5 2.5 0 102.5 2.5 2.5 2.5 0 00-2.5-2.5zm0 4a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zM4.5 10A2.5 2.5 0 107 12.5 2.5 2.5 0 004.5 10zm0 4A1.5 1.5 0 116 12.5 1.5 1.5 0 014.5 14z"
  })));
};

var _path$1t;

function _extends$1t() { _extends$1t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }

var SvgMoreVertical = function SvgMoreVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1t({
    width: 24,
    height: 24
  }, props), _path$1t || (_path$1t = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16a2.5 2.5 0 102.5 2.5 2.5 2.5 0 00-2.5-2.5zm0 4a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zM11.5 9a2.5 2.5 0 102.5 2.5A2.5 2.5 0 0011.5 9zm0 4a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zM11.5 7A2.5 2.5 0 109 4.5 2.5 2.5 0 0011.5 7zm0-4A1.5 1.5 0 1110 4.5 1.5 1.5 0 0111.5 3z"
  })));
};

var _path$1s;

function _extends$1s() { _extends$1s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }

var SvgMinimize = function SvgMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1s({
    width: 24,
    height: 24
  }, props), _path$1s || (_path$1s = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 13.89V21H3v-8h7.13l.17-1H2v10h10v-8.28l-1 .17zM21.78 5.06L19 2.24l-4.29 4.24-2.12-2.12-1.42 8.48 8.49-1.41-2.12-2.12zm-4.2 5.7l-5.19.87.87-5.19 1.45 1.45L19 3.65l1.42 1.41-4.3 4.25z"
  })));
};

var _path$1r;

function _extends$1r() { _extends$1r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }

var SvgMaximize = function SvgMaximize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1r({
    width: 24,
    height: 24
  }, props), _path$1r || (_path$1r = /*#__PURE__*/React.createElement("path", {
    d: "M12.53 4.41l2.12 2.12L11.18 10H2v12h12v-9.16l3.48-3.48 2.12 2.12L21 3zm6.4 5L17.48 8 13 12.42V21H3V11h8.59l4.47-4.47-1.45-1.45 5.18-.87z",
    fillRule: "evenodd"
  })));
};

var _path$1q, _path2$J;

function _extends$1q() { _extends$1q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }

var SvgManageAccess = function SvgManageAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1q({
    width: 24,
    height: 24
  }, props), _path$1q || (_path$1q = /*#__PURE__*/React.createElement("path", {
    d: "M20.43 18.33l.05-.18H22v-1.3h-1.52l-.05-.18a2.7 2.7 0 00-.27-.66l-.09-.16 1.07-1.07-.92-.92-1.07 1.07-.15-.09a2.7 2.7 0 00-.66-.27l-.18-.05V13h-1.3v1.52l-.18.05a2.7 2.7 0 00-.66.27l-.16.09-1.07-1.07-.92.92 1.07 1.07-.09.16a2.7 2.7 0 00-.27.66l-.05.18H13v1.3h1.52l.05.18a2.7 2.7 0 00.27.66l.09.16-1.07 1.07.92.92 1.07-1.07.16.09a2.7 2.7 0 00.66.27l.18.05V22h1.3v-1.52l.18-.05a2.7 2.7 0 00.66-.27l.16-.09 1.07 1.07.92-.92-1.07-1.07.09-.16a2.7 2.7 0 00.27-.66zm-2.93 1a1.79 1.79 0 111.79-1.79 1.79 1.79 0 01-1.79 1.75z"
  })), _path2$J || (_path2$J = /*#__PURE__*/React.createElement("path", {
    d: "M12.21 19H5v-4.5a4.49 4.49 0 018.85-1.1 5.58 5.58 0 01.87-.64 5.49 5.49 0 00-3.31-3.41A4.2 4.2 0 0013 6a3.78 3.78 0 00-3.5-4A3.78 3.78 0 006 6a4.2 4.2 0 001.59 3.35A5.49 5.49 0 004 14.5V20h8.61a5.09 5.09 0 01-.4-1zM7 6a2.79 2.79 0 012.5-3A2.79 2.79 0 0112 6a2.79 2.79 0 01-2.5 3A2.79 2.79 0 017 6z"
  })));
};

var _path$1p;

function _extends$1p() { _extends$1p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1p({
    width: 24,
    height: 24
  }, props), _path$1p || (_path$1p = /*#__PURE__*/React.createElement("path", {
    d: "M22 5H2v14h20zm-10 8L3.94 6H20zM3 6.46l5.79 5.05L3 17.29zm6.55 5.71l1.83 1.6a1 1 0 001.24 0l1.83-1.6L20.29 18H3.71zm5.66-.66l5.79-5v10.78z"
  })));
};

var _path$1o, _path2$I;

function _extends$1o() { _extends$1o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }

var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1o({
    width: 24,
    height: 24
  }, props), _path$1o || (_path$1o = /*#__PURE__*/React.createElement("path", {
    d: "M17 10V9A5 5 0 007 9v1H5v11h14V10zM8 9a4 4 0 018 0v1h-1V9a3 3 0 00-6 0v1H8zm6 0v1h-4V9a2 2 0 014 0zm4 11H6v-9h12z"
  })), _path2$I || (_path2$I = /*#__PURE__*/React.createElement("path", {
    d: "M11 13h2v5h-2z"
  })));
};

var _path$1n, _path2$H;

function _extends$1n() { _extends$1n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }

var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1n({
    width: 24,
    height: 24
  }, props), _path$1n || (_path$1n = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a6.86 6.86 0 00-7 6.67 7.15 7.15 0 00.4 2.42 81.08 81.08 0 004.82 8.07l1.34 2.13.44.71.42-.71c.69-1.16 1.66-2.7 2.62-4.24a64.33 64.33 0 003.53-5.93A6.8 6.8 0 0019 8.67 6.86 6.86 0 0012 2zm5.63 8.76c-.24.66-1.93 3.35-3.42 5.71-.8 1.28-1.6 2.54-2.24 3.59l-.88-1.4c-1.78-2.8-4.42-7-4.75-7.91A6.13 6.13 0 016 8.67 5.85 5.85 0 0112 3a5.85 5.85 0 016 5.67 6 6 0 01-.37 2.09z"
  })), _path2$H || (_path2$H = /*#__PURE__*/React.createElement("path", {
    d: "M12 6a3 3 0 103 3 3 3 0 00-3-3zm0 5a2 2 0 112-2 2 2 0 01-2 2z"
  })));
};

var _path$1m;

function _extends$1m() { _extends$1m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }

var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1m({
    width: 24,
    height: 24
  }, props), _path$1m || (_path$1m = /*#__PURE__*/React.createElement("path", {
    d: "M2 3v4h4V3zm3 3H3V4h2zM7 3v4h15V3zm14 3H8V4h13zM2 10v4h4v-4zm3 3H3v-2h2zM7 10v4h15v-4zm14 3H8v-2h13zM2 17v4h4v-4zm3 3H3v-2h2zM7 17v4h15v-4zm14 3H8v-2h13z"
  })));
};

var _path$1l;

function _extends$1l() { _extends$1l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1l({
    width: 24,
    height: 24
  }, props), _path$1l || (_path$1l = /*#__PURE__*/React.createElement("path", {
    d: "M20.34 3.67a5 5 0 00-7.09 0L9 7.92a5.11 5.11 0 00-.52.63v-.12l-1.84 1.85-3.11 3.11a5 5 0 107.08 7.09l4.25-4.25a5.11 5.11 0 00.52-.63v.12l1.85-1.85 3.12-3.11a5 5 0 00-.01-7.09zm-5.48 5.47a2.75 2.75 0 00-.26-.22l-.25-.2 2-2a.74.74 0 01.51-.2.73.73 0 01.51.2.71.71 0 01.21.51.68.68 0 01-.21.51l-2 2a4 4 0 00-.51-.6zM9 15a2.75 2.75 0 00.26.22h.05l.25.19-2 2a.72.72 0 11-1-1l2-2A4 4 0 009 15zm5.16.51l-4.25 4.26a4 4 0 01-5.68-5.67L7.34 11a5.42 5.42 0 00.55 2.7l-2 2a1.72 1.72 0 002.44 2.43l4.25-4.25a1.72 1.72 0 000-2.43.28.28 0 010-.4l1.41-1.4c.07.06.15.11.22.18a4 4 0 01-.05 5.69zm5.47-5.47l-3.11 3.11a5.42 5.42 0 00-.55-2.7l2-2a1.72 1.72 0 00-1.18-2.95 1.67 1.67 0 00-1.21.5l-4.26 4.25a1.72 1.72 0 000 2.43.28.28 0 010 .4l-1.4 1.4a2 2 0 01-.23-.18 4 4 0 010-5.67L14 4.38a4 4 0 015.67 0 4 4 0 01-.04 5.67z"
  })));
};

var _path$1k;

function _extends$1k() { _extends$1k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

var SvgLibrary = function SvgLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1k({
    viewBox: "0 0 24 24"
  }, props), _path$1k || (_path$1k = /*#__PURE__*/React.createElement("path", {
    d: "M2 5v16h5V5zm4 1v2H3V6zm0 3v8H3V9zM3 20v-2h3v2zM17.72 5.6L13 7.25l5 14.15 4.71-1.65zm2.7 10.7l-2.83 1-2.32-6.6 2.83-1zm-3.31-9.43l.66 1.89-2.83 1-.66-1.88zm1.48 13.26l-.67-1.89 2.83-1 .67 1.88zM8 3v18h5V3zm4 1v2H9V4zm0 3v10H9V7zM9 20v-2h3v2z"
  })));
};

var _path$1j, _path2$G;

function _extends$1j() { _extends$1j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

var SvgItem = function SvgItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1j({
    width: 24,
    height: 24
  }, props), _path$1j || (_path$1j = /*#__PURE__*/React.createElement("path", {
    d: "M20 21H4V3h16zM5 4v16h14V4z"
  })), _path2$G || (_path2$G = /*#__PURE__*/React.createElement("path", {
    d: "M7 7h10v1H7zM7 10h10v1H7zM7 13h10v1H7zM7 16h10v1H7z"
  })));
};

var _path$1i, _path2$F, _circle$5;

function _extends$1i() { _extends$1i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    width: 24,
    height: 24
  }, props), _path$1i || (_path$1i = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 109 9 9 9 0 00-9-9zm0 17a8 8 0 118-8 8 8 0 01-8 8z"
  })), _path2$F || (_path2$F = /*#__PURE__*/React.createElement("path", {
    d: "M13 12v-1h-3v1h1v4h-1v1h4v-1h-1v-4z"
  })), _circle$5 || (_circle$5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 1.25
  })));
};

var _path$1h;

function _extends$1h() { _extends$1h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

var SvgInbox = function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    width: 24,
    height: 24
  }, props), _path$1h || (_path$1h = /*#__PURE__*/React.createElement("path", {
    d: "M3 2v20h18V2zm17 19H4v-5h5.18a3 3 0 005.64 0H20zM6 15V6h12v9h-4a2 2 0 01-4 0zm14 0h-1V5H5v10H4V3h16z"
  })));
};

var _path$1g, _path2$E;

function _extends$1g() { _extends$1g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

var SvgImport = function SvgImport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    width: 24,
    height: 24
  }, props), _path$1g || (_path$1g = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H6v5h1V4h10v4h4v12H6v1h16V8zm1 4V5.41L19.59 7z"
  })), _path2$E || (_path2$E = /*#__PURE__*/React.createElement("path", {
    d: "M14 14L7 9v3H2v4h5v3zM3 15v-2h5v-2l4.28 3L8 17v-2z",
    fillRule: "evenodd"
  })));
};

var _path$1f;

function _extends$1f() { _extends$1f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    width: 24,
    height: 24
  }, props), _path$1f || (_path$1f = /*#__PURE__*/React.createElement("path", {
    d: "M19 9V4h-3v2l-4-4L2 12l1 2h1v7h16v-7h1l1-2zm-2-4h1v3h-1zm-3 15h-4v-2h1v-1h-1v-2h4zm5 0h-4v-6H9v6H5v-5.59l7-7 7 7zm1.38-7H19l-7-7-7 7H3.62l-.4-.8L12 3.41l8.78 8.79z"
  })));
};

var _path$1e;

function _extends$1e() { _extends$1e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

var SvgHierarchy = function SvgHierarchy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    width: 24,
    height: 24
  }, props), _path$1e || (_path$1e = /*#__PURE__*/React.createElement("path", {
    d: "M21 16h-3v-3h-6v-2h6V2H5v9h6v2H5v3H2v6h7v-6H6v-2h11v2h-3v6h7zM6 3h11v7H6zm2 18H3v-4h5zm12 0h-5v-4h5z"
  })));
};

var _path$1d, _path2$D;

function _extends$1d() { _extends$1d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

var SvgHidden = function SvgHidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    width: 24,
    height: 24
  }, props), _path$1d || (_path$1d = /*#__PURE__*/React.createElement("path", {
    d: "M11.23 9.11A3.25 3.25 0 0112 9a3 3 0 013 3 3.25 3.25 0 01-.11.77l.79.79A3.89 3.89 0 0016 12a4 4 0 00-4-4 3.89 3.89 0 00-1.56.32zM12.77 14.89A3.25 3.25 0 0112 15a3 3 0 01-3-3 3.25 3.25 0 01.11-.77l-.79-.79A3.89 3.89 0 008 12a4 4 0 004 4 3.89 3.89 0 001.56-.32zM3.296 4.003l.707-.707 16.71 16.708-.708.708z"
  })), _path2$D || (_path2$D = /*#__PURE__*/React.createElement("path", {
    d: "M9.06 6.94A8.63 8.63 0 0112 6.42c4.82 0 8 4.3 8.87 5.67a10.37 10.37 0 01-3 3.63l.7.71A11.52 11.52 0 0022 12s-3.65-6.6-10-6.6a9.51 9.51 0 00-3.71.75zM15 17.16a10.34 10.34 0 01-3 .44c-5.13 0-8-4.19-8.85-5.58a13.91 13.91 0 013.19-3.56l-.72-.72A14.74 14.74 0 002 12s3.17 6.6 10 6.6a10.82 10.82 0 003.82-.66z"
  })));
};

var _path$1c, _path2$C, _circle$4;

function _extends$1c() { _extends$1c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    width: 24,
    height: 24
  }, props), _path$1c || (_path$1c = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 109 9 9 9 0 00-9-9zm0 17a8 8 0 118-8 8 8 0 01-8 8z"
  })), _path2$C || (_path2$C = /*#__PURE__*/React.createElement("path", {
    d: "M12.35 6.33A3.15 3.15 0 009 9.23v.24l1.49.32v-.25c.23-1.19.83-1.77 1.83-1.77a1.77 1.77 0 011.15.38 1.18 1.18 0 01.46 1 1.45 1.45 0 01-.48 1.08 6 6 0 01-.8.51 3.91 3.91 0 00-.77.5 1.55 1.55 0 00-.32.48 1.79 1.79 0 00-.17.6c0 .19-.08 1.44-.08 2.15v.25h1.5v-1.83a.89.89 0 01.12-.55 2.73 2.73 0 01.83-.55 2.91 2.91 0 001.85-2.61 2.66 2.66 0 00-.91-2.06 3.41 3.41 0 00-2.35-.79z"
  })), _circle$4 || (_circle$4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1
  })));
};

var _path$1b;

function _extends$1b() { _extends$1b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    width: 24,
    height: 24
  }, props), _path$1b || (_path$1b = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H3V3h8zM4 4v6h6V4zM21 11h-8V3h8zm-7-7v6h6V4zM11 21H3v-8h8zm-7-7v6h6v-6zM21 21h-8v-8h8zm-7-7v6h6v-6z"
  })));
};

var _path$1a, _path2$B;

function _extends$1a() { _extends$1a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

var SvgGraph = function SvgGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    width: 24,
    height: 24
  }, props), _path$1a || (_path$1a = /*#__PURE__*/React.createElement("path", {
    d: "M2.88 14.83l-.76-.66 7.32-8.36 5 4 6.68-7.64.76.66-7.32 8.36-5-4-6.68 7.64zM18 9v13h4V9zm3 12h-2V10h2zM13 14v8h4v-8zm3 7h-2v-6h2z"
  })), _path2$B || (_path2$B = /*#__PURE__*/React.createElement("path", {
    d: "M8 12v10h4V12zm3 9H9v-8h2zM3 17v5h4v-5zm3 4H4v-3h2z"
  })));
};

var _path$19;

function _extends$19() { _extends$19 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    width: 24,
    height: 24
  }, props), _path$19 || (_path$19 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm8.94 9H18a16 16 0 00-.47-3h2.55a9 9 0 01.86 3zm-1.46-4h-2.29a9.59 9.59 0 00-1.94-3.38A9.07 9.07 0 0119.48 7zm-7 0V3.1C14 3.38 15.3 4.87 16.12 7zm3.95 1a13.94 13.94 0 01.57 3h-4.5V8zM11.5 3.1V7H7.88C8.7 4.87 10 3.38 11.5 3.1zm0 4.9v3H7a13.85 13.85 0 01.51-3zm0 4v3H7.31A14.41 14.41 0 017 12zm0 4v4.9c-1.71-.32-3.18-2.25-3.95-4.9zm1 4.9V16h3.95c-.77 2.65-2.24 4.58-3.95 4.9zm0-5.9v-3H17a14.41 14.41 0 01-.31 3zM8.75 3.62A9.59 9.59 0 006.81 7H4.52a9.07 9.07 0 014.23-3.38zM6.5 8a16.07 16.07 0 00-.5 3H3a8.86 8.86 0 011-3zM6 12a15.88 15.88 0 00.28 3H3.53A8.78 8.78 0 013 12zm-2 4h2.5a10.38 10.38 0 002.22 4.37A9 9 0 014 16zm11.33 4.37A10.4 10.4 0 0017.5 16h2.55a9 9 0 01-4.77 4.37zM20.47 15h-2.75a15.88 15.88 0 00.28-3h3a8.78 8.78 0 01-.53 3z"
  })));
};

var _path$18;

function _extends$18() { _extends$18 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

var SvgForward = function SvgForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    width: 24,
    height: 24
  }, props), _path$18 || (_path$18 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.5L12 4v4H2v7h10v4zM3 14V9h10V6l7.33 5.5L13 17v-3z",
    fillRule: "evenodd"
  })));
};

var _path$17;

function _extends$17() { _extends$17 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

var SvgForums = function SvgForums(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    width: 24,
    height: 24
  }, props), _path$17 || (_path$17 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.36A3.23 3.23 0 0021 9a2.78 2.78 0 00-2.5-3A2.78 2.78 0 0016 9a3.23 3.23 0 001 2.36 4 4 0 00-.56.35 5.08 5.08 0 01.39 1A2.49 2.49 0 0121 14.5V18h-4v1h5v-4.5a3.5 3.5 0 00-2-3.14zM18.5 11c-.81 0-1.5-.92-1.5-2s.69-2 1.5-2 1.5.92 1.5 2-.69 2-1.5 2zM13.69 10.39A3.69 3.69 0 0015 7.5 3.28 3.28 0 0012 4a3.28 3.28 0 00-3 3.5 3.69 3.69 0 001.31 2.89A4 4 0 008 14v5h8v-5a4 4 0 00-2.31-3.61zM10 7.5A2.3 2.3 0 0112 5a2.3 2.3 0 012 2.5 2.3 2.3 0 01-2 2.5 2.3 2.3 0 01-2-2.5zM15 18H9v-4a3 3 0 016 0zM7 18H3v-3.5a2.49 2.49 0 014.19-1.83 5.08 5.08 0 01.39-1 4 4 0 00-.58-.31A3.23 3.23 0 008 9a2.78 2.78 0 00-2.5-3A2.78 2.78 0 003 9a3.23 3.23 0 001 2.36 3.5 3.5 0 00-2 3.14V19h5zM5.5 7C6.31 7 7 7.92 7 9s-.69 2-1.5 2S4 10.08 4 9s.69-2 1.5-2z"
  })));
};

var _path$16;

function _extends$16() { _extends$16 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    width: 24,
    height: 24
  }, props), _path$16 || (_path$16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.79 6L9 4H2v16h19V6zM3 5h6l1.8 1.42L10 7H3zm17 14H3V8h7.26l1.52-1H20z"
  })));
};

var _path$15;

function _extends$15() { _extends$15 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

var SvgFolderOpen = function SvgFolderOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    width: 24,
    height: 24
  }, props), _path$15 || (_path$15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.36 20H2V4h6.65l3 2H20v3h1.69zM4.19 19h13.45l2.67-9H6.86zM3 5v14h.14l3-10H19V7h-7.65l-3-2z"
  })));
};

var _path$14;

function _extends$14() { _extends$14 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    width: 24,
    height: 24
  }, props), _path$14 || (_path$14 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.81a9.73 9.73 0 004-.88l-5.37-8.34a9.71 9.71 0 01-4.2 1 9.82 9.82 0 01-4.13-.9 4.72 4.72 0 00-2.12-.44A4.72 4.72 0 003.69 5l-.59-.92-.83.56L13.11 20.7l.83-.56-4.7-7a4.89 4.89 0 012.53-.72c2.03.03 3.23 1.4 6.23 1.39zm-9.81-2.18L4.25 5.78a3.72 3.72 0 011.93-.54 4 4 0 011.69.35 10.78 10.78 0 004.51 1 10.89 10.89 0 003.86-.73l4.24 6.59a8.9 8.9 0 01-2.47.37H18a8.81 8.81 0 01-3.38-.71 7.78 7.78 0 00-2.8-.64 5.78 5.78 0 00-3.11.89z"
  })));
};

var _path$13;

function _extends$13() { _extends$13 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    width: 24,
    height: 24
  }, props), _path$13 || (_path$13 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4v2.33L10 12v8l4-2v-6l7-5.54V4zm17 2l-7 5.54v5.86l-2 1v-6.88L4 5.85V5h16z"
  })));
};

var _path$12, _path2$A;

function _extends$12() { _extends$12 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

var SvgFilterTokens = function SvgFilterTokens(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    width: 24,
    height: 24
  }, props), _path$12 || (_path$12 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11H3V4h18zM4 5v5h16V5zM21 13H3v7h18zm-1 6H4v-5h16z"
  })), _path2$A || (_path2$A = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H5v3h3zM7 8H6V7h1zM8 15H5v3h3zm-1 2H6v-1h1z"
  })));
};

var _path$11, _path2$z;

function _extends$11() { _extends$11 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

var SvgFileZip = function SvgFileZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    width: 24,
    height: 24
  }, props), _path$11 || (_path$11 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H4v18h16V8zm1 2.41L17.59 7H16zM11 4h1v1h-1zm2 2v5h-3V6zm-2 7h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1H5V4h5v1H9v7h2zm8 7h-7v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h1V5h-1V4h2v4h4z"
  })), _path2$z || (_path2$z = /*#__PURE__*/React.createElement("path", {
    d: "M11 8h1v2h-1z"
  })));
};

var _path$10;

function _extends$10() { _extends$10 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

var SvgFileVideo = function SvgFileVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    width: 24,
    height: 24
  }, props), _path$10 || (_path$10 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7V4H2v3h1v10H2v3h19v-3h-1V7zm-2-2h1v1h-1zm-2 0h1v1h-1zm-2 0h1v1h-1zm-2 0h1v1h-1zm-2 0h1v1h-1zM9 5h1v1H9zM7 5h1v1H7zM5 5h1v1H5zM3 5h1v1H3zm1 14H3v-1h1zM4 7h7v10H4zm2 12H5v-1h1zm2 0H7v-1h1zm2 0H9v-1h1zm2 0h-1v-1h1zm2 0h-1v-1h1zm2 0h-1v-1h1zm2 0h-1v-1h1zm2 0h-1v-1h1zm-1-2h-7V7h7z"
  })));
};

var _path$$;

function _extends$$() { _extends$$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

var SvgFileSpreadsheet = function SvgFileSpreadsheet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    width: 24,
    height: 24
  }, props), _path$$ || (_path$$ = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4v16h16zM8 5h5v2H8zm0 3h5v2H8zm0 3h5v2H8zm0 3h5v2H8zm0 5v-2h5v2zm11 0h-5v-2h5zm0-3h-5v-2h5zm0-3h-5v-2h5zm0-3h-5V8h5zm0-3h-5V5h5z",
    fill: "#87bc40"
  })));
};

var _path$_, _path2$y;

function _extends$_() { _extends$_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

var SvgFilePresentation = function SvgFilePresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    width: 24,
    height: 24
  }, props), _path$_ || (_path$_ = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4h-16a.5.5 0 000 1H4v12h5.33l-2.11 2.92a.49.49 0 000 .7.51.51 0 00.78-.05v-.07l2.56-3.5H11v3.38a.57.57 0 00.5.63.57.57 0 00.5-.62V17h.44L15 20.51a.5.5 0 00.81-.58L13.67 17H19V5h.5a.5.5 0 000-1zM18 16H5V5h13z",
    fill: "#faa21b"
  })), _path2$y || (_path2$y = /*#__PURE__*/React.createElement("path", {
    fill: "#faa21b",
    d: "M12 8h5v1h-5zM12 10h5v1h-5zM12 12h4v1h-4zM8.5 8a2.5 2.5 0 102.5 2.5A2.5 2.5 0 008.5 8zm0 4a1.5 1.5 0 111.5-1.5A1.5 1.5 0 018.5 12z"
  })));
};

var _path$Z, _path2$x;

function _extends$Z() { _extends$Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

var SvgFilePdf = function SvgFilePdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    width: 24,
    height: 24
  }, props), _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H4v18h16V8zm1 2.41L17.59 7H16zM19 20H5V4h10v4h4z",
    fill: "#ec4a41"
  })), _path2$x || (_path2$x = /*#__PURE__*/React.createElement("path", {
    fill: "#ec4a41",
    d: "M7 13h10v1H7zM7 15h7v1H7zM12 11h5v1h-5zM12 9h5v1h-5zM7 9h4v3H7z"
  })));
};

var _path$Y;

function _extends$Y() { _extends$Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

var SvgFilePart = function SvgFilePart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    width: 24,
    height: 24
  }, props), _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
    d: "M20 11h-5V6H9v5H4v6h16zm-1 5H5v-4h5V7h4v5h5z",
    fill: "#ec4a41"
  })));
};

var _path$X, _path2$w;

function _extends$X() { _extends$X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

var SvgFileImage = function SvgFileImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    width: 24,
    height: 24
  }, props), _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
    d: "M3 3v18h18V3zm17 17H4v-3.82l2.75-3.39A2 2 0 018.34 12a2 2 0 011.59.76l.3.4 3.35 4.31a1.41 1.41 0 002.17.06L17.13 16a.84.84 0 01.65-.29.83.83 0 01.73.41L20 18.48zm0-3.41l-.61-1a1.85 1.85 0 00-1.61-.92 1.89 1.89 0 00-1.4.62L15 16.87a.42.42 0 01-.63 0l-3.65-4.7a3 3 0 00-4.76 0L4 14.59V4h16z"
  })), _path2$w || (_path2$w = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11A2.5 2.5 0 1013 8.5a2.5 2.5 0 002.5 2.5zm0-4A1.5 1.5 0 1114 8.5 1.5 1.5 0 0115.5 7z"
  })));
};

var _path$W;

function _extends$W() { _extends$W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

var SvgFileGeneric = function SvgFileGeneric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    width: 24,
    height: 24
  }, props), _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H4v18h16V8zm1 2.41L17.59 7H16zM19 20H5V4h10v4h4z"
  })));
};

var _path$V, _path2$v;

function _extends$V() { _extends$V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

var SvgFileDocument = function SvgFileDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    width: 24,
    height: 24
  }, props), _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
    d: "M15 3H4v18h16V8zm1 2.41L17.59 7H16zM19 20H5V4h10v4h4z",
    fill: "#0696d7"
  })), _path2$v || (_path2$v = /*#__PURE__*/React.createElement("path", {
    fill: "#0696d7",
    d: "M7 13h10v1H7zM7 15h7v1H7zM7 11h10v1H7zM7 9h10v1H7z"
  })));
};

var _path$U, _path2$u, _path3$1;

function _extends$U() { _extends$U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

var SvgFileAudio = function SvgFileAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    width: 24,
    height: 24
  }, props), _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H2v7h3l7 5V4zm0 6H3v-5h2zm6 4.06l-5-3.57v-6l5-3.57zM21 12.5a9.45 9.45 0 01-3.5 7.35l.62.8a10.5 10.5 0 000-16.3l-.62.8A9.45 9.45 0 0121 12.5z"
  })), _path2$u || (_path2$u = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.5a6.5 6.5 0 01-2.33 5l.61.79a7.48 7.48 0 000-11.54l-.61.79A6.5 6.5 0 0118 12.5z"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5a3.48 3.48 0 01-1.16 2.59l.6.79a4.44 4.44 0 000-6.76l-.6.79A3.48 3.48 0 0115 12.5z"
  })));
};

var _path$T;

function _extends$T() { _extends$T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

var SvgFileAssembly = function SvgFileAssembly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    width: 24,
    height: 24
  }, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H9v5H4v6h16zm-1 10H5v-4h5V7h4v5h5zm0-5h-4V7h4z",
    fill: "#ec4a41"
  })));
};

var _path$S;

function _extends$S() { _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

var SvgField = function SvgField(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    width: 24,
    height: 24
  }, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
    d: "M20.83 15.82a4.42 4.42 0 01-1.25-2c0-4.7-3.36-8.54-7.58-8.83h-1c-4.22.29-7.58 4.13-7.58 8.83a4.42 4.42 0 01-1.25 2 .74.74 0 00-.17.43v.25a.5.5 0 00.5.5H3l1.62 1.7a1 1 0 00.72.31h12.29a1 1 0 00.72-.31L20 17h.53a.5.5 0 00.5-.5v-.25a.78.78 0 00-.2-.43zM17.63 18H5.37l-1-1v-.05C5.9 15.52 9 15 11.42 15s5.58.51 7.06 2l.05.05zM19 16c-2.2-1.85-6.26-2-7.49-2s-5.28.15-7.51 2h-.66a4.17 4.17 0 001.08-2.14A8 8 0 018 7v2.5a.5.5 0 001 0v-3a6.6 6.6 0 012-.5v2.5a.5.5 0 001 0V6a6.31 6.31 0 012 .49v3a.5.5 0 101 0V7a8 8 0 013.58 6.82A4.1 4.1 0 0019.66 16z"
  })));
};

var _path$R;

function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

var SvgFeedback = function SvgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    width: 24,
    height: 24
  }, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 14.53c-.89-2.28-4.22-10-5-11.9a1 1 0 00-.58-.56.87.87 0 00-.45-.07 1 1 0 00-1 .79c-.55 3.38-1.75 4.47-2.88 5.2a7.34 7.34 0 01-1.46.64c-2.76.68-4.64 1.53-5.57 2.53a1.32 1.32 0 00-.49.93L3 13c-.73.59-.67 1.13-.49 1.47l1.11 2.33a1.16 1.16 0 001.08.74 1.78 1.78 0 00.47-.07l1.45-.34c1 1.07 3.6 4.38 3.67 4.46.36.66 1.31.33 1.44.26l1.85-.64a1.15 1.15 0 00.65-.86.84.84 0 00-.28-.74l-2.17-2.58a3.81 3.81 0 00.52-.85.73.73 0 00-.06-.72.94.94 0 00-.81-.33l-1.27.2-.23-.33 1.78-.56a11.28 11.28 0 012.7-.3 8.93 8.93 0 015.59 1.6.82.82 0 00.2.12 1 1 0 001.35-1.33zM5 16.52c-.3.08-.31.05-.41-.14l-1.15-2.33s0-.08.23-.25l.9-.73 1.14 2.67a4.62 4.62 0 00.27.54zm6.46-3l-2 .64a1.18 1.18 0 00-.62.67.64.64 0 00.09.54 7.88 7.88 0 00.71.88.49.49 0 00.44.16l1.12-.18a6.58 6.58 0 01-.41.53.5.5 0 000 .65l2.43 2.89-1.84.7a.41.41 0 01-.32 0c-.12-.16-3.05-3.84-3.85-4.66a3 3 0 01-.57-.91l-1.42-3.37.19-.21C6 11.26 7.3 10.39 10.5 9.6l.2-.06c.2.51.42 1.1.65 1.71s.54 1.45.8 2.09c-.45.08-.72.15-.73.15zm3-.34c-.45 0-.87 0-1.24.06-.27-.68-.58-1.51-.89-2.31-.23-.62-.46-1.22-.66-1.74a6 6 0 00.64-.33C13.57 8 15 6.71 15.63 3c.81 1.92 4.1 9.55 4.94 11.89a9.9 9.9 0 00-6.16-1.74z"
  })));
};

var _path$Q, _path2$t;

function _extends$Q() { _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

var SvgFeatured = function SvgFeatured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    width: 24,
    height: 24
  }, props), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.66l-3.18-2.44L21.19 8l-4-.32.26-4-3.51 1.85L12 2l-1.94 3.53-3.52-1.91.26 4L2.81 8l2.37 3.25L2 13.66l3.74 1.44-1.38 3.79 3.91-.83.88 3.94L12 19.16 14.85 22l.88-3.94 3.91.83-1.38-3.79zm-7 3.22L14.27 20 12 17.75 9.73 20 9 16.88l-3.12.66 1.09-3L4 13.37l2.54-2-1.87-2.55 3.18-.25-.2-3.21 2.81 1.52L12 4.08l1.54 2.81 2.81-1.52-.21 3.21 3.18.25-1.89 2.59 2.54 2-3 1.15 1.09 3z"
  })), _path2$t || (_path2$t = /*#__PURE__*/React.createElement("path", {
    d: "M11 8h2v5h-2zM11 14h2v2h-2z"
  })));
};

var _path$P;

function _extends$P() { _extends$P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

var SvgFavorite = function SvgFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    width: 24,
    height: 24
  }, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.5h-7.64L12 2.24 9.64 9.5H2L8.18 14l-2.36 7.26L12 16.77l6.18 4.49L15.82 14zm-5.72 9.14L12 15.53l-4.28 3.11 1.64-5-4.28-3.14h5.29l1.63-5 1.63 5h5.29l-4.28 3.11z"
  })));
};

var _path$O, _path2$s;

function _extends$O() { _extends$O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

var SvgExternal = function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    width: 24,
    height: 24
  }, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 20H4V6h9.76l.46-.46-.54-.54H3v16h15V10.24l-1 1V20z"
  })), _path2$s || (_path2$s = /*#__PURE__*/React.createElement("path", {
    d: "M13.51 3.42l2.12 2.12L12.17 9 15 11.83l3.46-3.46 2.12 2.12L22 2zm6.37 4.95l-1.43-1.43L15 10.4 13.59 9l3.46-3.46-1.42-1.41 5.15-.91z",
    fillRule: "evenodd"
  })));
};

var _path$N, _path2$r;

function _extends$N() { _extends$N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    width: 24,
    height: 24
  }, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 18H6V6h4V5H5v14h14v-5h-1v4z"
  })), _path2$r || (_path2$r = /*#__PURE__*/React.createElement("path", {
    d: "M11.88 5.05L14 7.17l-3.54 3.54 2.83 2.83L16.83 10 19 12.12l1.41-8.48zm6.36 5l-1.43-1.48-3.53 3.54-1.4-1.4 3.53-3.54L14 5.76l5.15-.91z",
    fillRule: "evenodd"
  })));
};

var _path$M, _path2$q;

function _extends$M() { _extends$M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

var SvgExportMove = function SvgExportMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    width: 24,
    height: 24
  }, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.06V8l-5-5H2v18h16v-3.06l-1 .68V20H3V4h10v4h4v1.38zM14 7V5.41L15.59 7z"
  })), _path2$q || (_path2$q = /*#__PURE__*/React.createElement("path", {
    d: "M22 14l-7-5v3h-5v4h5v3zm-11 1v-2h5v-2l4.28 3L16 17v-2z",
    fillRule: "evenodd"
  })));
};

var _path$L, _path2$p;

function _extends$L() { _extends$L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

var SvgExpandPanel = function SvgExpandPanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    width: 24,
    height: 24
  }, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
    d: "M22 12l-7-5v3h-4v4h4v3zm-10 1v-2h4V9l4.28 3L16 15v-2z",
    fillRule: "evenodd"
  })), _path2$p || (_path2$p = /*#__PURE__*/React.createElement("path", {
    d: "M2 3v18h8V3zm7 17H3V4h6z"
  })));
};

var _path$K, _circle$3, _path2$o;

function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    width: 24,
    height: 24
  }, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
    d: "M12 2L2 12l10 10 10-10zM3.41 12L12 3.41 20.59 12 12 20.59z"
  })), _circle$3 || (_circle$3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 1
  })), _path2$o || (_path2$o = /*#__PURE__*/React.createElement("path", {
    d: "M11.88 13h.24a.55.55 0 00.54-.5L13 8a1 1 0 00-2 0l.34 4.5a.55.55 0 00.54.5z"
  })));
};

var _path$J;

function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

var SvgEducation = function SvgEducation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    width: 24,
    height: 24
  }, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L2 9l3 1.5V20h3v-3.9a8.69 8.69 0 004 .9c3.31 0 6-1.57 6-3.5V11l4-2zM7 19H6v-8.5a.5.5 0 011 0zm10-5.5c0 1.18-2 2.5-5 2.5a7.15 7.15 0 01-4-1.06V12l4 2 5-2.5zm-5-.62l-4-2v-.38a1.62 1.62 0 00-.07-.44L12 9.49a.51.51 0 00.43-.57.51.51 0 00-.57-.42l-4.7.66A1.46 1.46 0 006.5 9a1.48 1.48 0 00-1.16.56L4.21 9 12 5.12 19.74 9z"
  })));
};

var _path$I;

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    width: 24,
    height: 24
  }, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
    d: "M17.63 3H17.28a1.16 1.16 0 00-.59.31L4.55 15.46 3 21l5.54-1.55L20.67 7.31a1.16 1.16 0 00.33-.59 2.45 2.45 0 000-.27v-.08A3.37 3.37 0 0017.63 3zM15 6.47L17.53 9l-8.78 8.82-2.57-2.57zM4.44 19.56l1-3.57L8 18.53zM20 6.58l-1.77 1.76-2.56-2.57L17.4 4h.15A2.4 2.4 0 0120 6.37v.21z"
  })));
};

var _path$H;

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

var SvgEditProfile = function SvgEditProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    width: 24,
    height: 24
  }, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
    d: "M12.86 18.93L12 22l3.07-.86h.01l-2.22-2.22v.01zM13.578 18.22l4.101-4.102 2.213 2.213-4.1 4.102zM20.12 12h-.19a.62.62 0 00-.32.17l-1.23 1.23 2.21 2.21 1.23-1.23a.62.62 0 00.17-.32v-.15A1.88 1.88 0 0020.12 12zM5 14.5a4.5 4.5 0 019 0v1.87l1-1v-.87a5.49 5.49 0 00-3.59-5.15A4.2 4.2 0 0013 6a3.78 3.78 0 00-3.5-4A3.78 3.78 0 006 6a4.2 4.2 0 001.59 3.35A5.49 5.49 0 004 14.5V20h7.52l.28-1H5zM7 6a2.79 2.79 0 012.5-3A2.79 2.79 0 0112 6a2.79 2.79 0 01-2.5 3A2.79 2.79 0 017 6z"
  })));
};

var _path$G, _path2$n;

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    width: 24,
    height: 24
  }, props), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
    d: "M15 8V2H9v6H6l6.1 8L18 8zm-2.92 6.33L8 9h2V3h4v6h2z",
    fillRule: "evenodd"
  })), _path2$n || (_path2$n = /*#__PURE__*/React.createElement("path", {
    d: "M17 16v2H7v-2H3v6h18v-6zm3 5H4v-4h2v2h12v-2h2z"
  })));
};

var _path$F;

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    width: 24,
    height: 24
  }, props), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
    d: "M15 12V2H8v10H4l7.5 10L19 12zm-9 1h3V3h5v10h3l-5.5 7.33z",
    fillRule: "evenodd"
  })));
};

var _path$E, _path2$m, _path3;

function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

var SvgDocumentManagement = function SvgDocumentManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    width: 24,
    height: 24
  }, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
    d: "M5 3v3h1V4h15v12h-1v1h2V3H5z"
  })), _path2$m || (_path2$m = /*#__PURE__*/React.createElement("path", {
    d: "M14 7H2v14h17v-9zm1 2.41L16.59 11H15zM18 20H3V8h11v4h4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13v-2h4v-1H4v8h7v-2h-1v1H5v-6h3v2h1zM17 13h-1v4h-2v-1h-1v2h4v-5z"
  })));
};

var _path$D, _path2$l;

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

var SvgDevices = function SvgDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    width: 24,
    height: 24
  }, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
    d: "M15 16h7V3H4v4h1V4h16v11h-9v1h2v2h-2v1h7v-1h-4v-2z"
  })), _path2$l || (_path2$l = /*#__PURE__*/React.createElement("path", {
    d: "M2 8v14h9V8zm8 13H3v-2h7zm-7-3V9h7v9z"
  })));
};

var _path$C, _path2$k;

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

var SvgDeviceTablet = function SvgDeviceTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    width: 24,
    height: 24
  }, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
    d: "M19 11h1v2h-1z"
  })), _path2$k || (_path2$k = /*#__PURE__*/React.createElement("path", {
    d: "M2 4v16h20V4zm1 15V5h14v14zm18 0h-3V5h3z"
  })));
};

var _path$B, _path2$j;

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var SvgDeviceMobile = function SvgDeviceMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    width: 24,
    height: 24
  }, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
    d: "M5 2v20h13V2zm12 19H6v-3h11zM6 17V3h11v14z"
  })), _path2$j || (_path2$j = /*#__PURE__*/React.createElement("path", {
    d: "M10 19h3v1h-3z"
  })));
};

var _path$A;

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var SvgDeviceDesktop = function SvgDeviceDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    width: 24,
    height: 24
  }, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
    d: "M14 18h8V3H2v15h8v2H6v1h12v-1h-4v-2zm-1 2h-2v-2h2zM3 17V4h18v13z"
  })));
};

var _path$z, _path2$i;

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var SvgDataRefresh = function SvgDataRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
    d: "M19.909 6.725a9.432 9.432 0 00-6.037-4.043c-4.792-.96-9.61 1.961-10.974 6.646l2.87.836c.935-3.208 4.234-5.206 7.518-4.55a6.46 6.46 0 014.135 2.769 6.467 6.467 0 01.966 4.883 6.46 6.46 0 01-2.769 4.135 6.471 6.471 0 01-4.882.966 6.496 6.496 0 01-3.54-2.035l2.277-1.592-6.968-2.539-.004 7.414 2.219-1.552a9.508 9.508 0 007.311 3.422 9.427 9.427 0 005.246-1.597 9.426 9.426 0 004.042-6.036 9.429 9.429 0 00-1.41-7.127z",
    stroke: "gray",
    strokeMiterlimit: 10
  })), _path2$i || (_path2$i = /*#__PURE__*/React.createElement("path", {
    d: "M12.003 8.484v3.514l2.675 2.297",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$y, _path2$h;

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    width: 24,
    height: 24
  }, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
    d: "M11.79 4A9.51 9.51 0 004.1 19.46L9.46 17a2.48 2.48 0 001.46 1 2.86 2.86 0 00.58.06 2.46 2.46 0 002-1.05l5.37 2.51A9.41 9.41 0 0021 13.55 9.61 9.61 0 0011.79 4zM13 15.8a1.49 1.49 0 01-1.5 1.2 1.48 1.48 0 01-1.41-1 1.51 1.51 0 01.42-1.64l4.11-3.49zm5.62 2.41L13.94 16l2.18-6.45 1-1-.71-.71-1.21 1.25-5.36 4.55A2.5 2.5 0 009.08 16l-4.66 2.21A8.5 8.5 0 0111.5 5h.26A8.67 8.67 0 0120 13.55a8.44 8.44 0 01-1.42 4.66z"
  })), _path2$h || (_path2$h = /*#__PURE__*/React.createElement("path", {
    d: "M4 13h3v1H4zM16 13h3v1h-3zM5.847 8.547l.707-.707 2.122 2.121-.707.707zM11 6h1v3h-1z"
  })));
};

var _path$x, _path2$g;

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var SvgCtaArrowRight = function SvgCtaArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    width: 24,
    height: 24
  }, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9z",
    fillRule: "evenodd"
  })), _path2$g || (_path2$g = /*#__PURE__*/React.createElement("path", {
    d: "M11 10H6v4h5v3l7-5-7-5zm1-1l4.28 3L12 15v-2H7v-2h5z",
    fillRule: "evenodd"
  })));
};

var _path$w, _path2$f;

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    width: 24,
    height: 24
  }, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
    d: "M7 17H4V4h7v1h2l-2-2H3v15h4v-1z"
  })), _path2$f || (_path2$f = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H8v15h13V11zm1 2.41L18.59 10H17zM20 20H9V7h7v4h4z"
  })));
};

var _path$v, _path2$e;

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var SvgComplete = function SvgComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    width: 24,
    height: 24
  }, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 109 9 9 9 0 00-9-9zm0 17a8 8 0 118-8 8 8 0 01-8 8z"
  })), _path2$e || (_path2$e = /*#__PURE__*/React.createElement("path", {
    d: "M16.29 8.73l-5.65 5.65-2.5-2.49-.71.71 3.21 3.2L17 9.43l-.71-.7z"
  })));
};

var _path$u;

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var SvgCompare = function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    width: 24,
    height: 24
  }, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
    d: "M15.68 7.5L8 2v3H2v5h6v3zM3 9V6h6V4l5 3.5-5 3.55V9zM16 14v-3l-7.68 5.5L16 22v-3h6v-5zm5 4h-6v2.05l-5-3.55 5-3.5v2h6z",
    fillRule: "evenodd"
  })));
};

var _path$t, _path2$d;

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    width: 24,
    height: 24
  }, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
    d: "M2 3v13h4v6l6-6h10V3zm19 12h-9.41L7 19.59V15H3V4h18z"
  })), _path2$d || (_path2$d = /*#__PURE__*/React.createElement("path", {
    d: "M6 7h13v1H6zM6 11h8v1H6z"
  })));
};

var _path$s, _path2$c;

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var SvgCollapsePanel = function SvgCollapsePanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    width: 24,
    height: 24
  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    d: "M18 10V7l-7 5 7 5v-3h4v-4zm3 3h-4v2l-4.28-3L17 9v2h4z",
    fillRule: "evenodd"
  })), _path2$c || (_path2$c = /*#__PURE__*/React.createElement("path", {
    d: "M2 3v18h8V3zm7 17H3V4h6z"
  })));
};

var _path$r, _path2$b;

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var SvgCollaboration = function SvgCollaboration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    width: 24,
    height: 24
  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    d: "M8 9v7h8V8H8zm1 0h6v6H9z"
  })), _path2$b || (_path2$b = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H8v4h1V4h11v11h-3v1h4zM15 17v3H4V9h3V8H3v13h13v-4z"
  })));
};

var _path$q;

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    width: 24,
    height: 24
  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    d: "M19.55 13.06A5.08 5.08 0 0020 11a5 5 0 00-9.67-1.76A4.18 4.18 0 009 9a4 4 0 00-4 4 3 3 0 000 6h14a3 3 0 00.55-5.94zM19 18H5a2 2 0 010-4h1v-1a3 3 0 013-3 2.89 2.89 0 011 .19l.92.33.35-.92A4 4 0 0119 11a4 4 0 01-.36 1.64l-.53 1.17 1.26.23A2 2 0 0119 18z"
  })));
};

var _path$p;

function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var SvgClosedCaptioning = function SvgClosedCaptioning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    width: 24,
    height: 24
  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    d: "M7.85 12.87c-.17 1-.52 2.07-1.16 2.07-.79 0-1.28-1.32-1.28-3.44 0-2.54.67-3.44 1.23-3.44.25 0 .77 0 1.1 1.78l.11.54 3.15-.9-.08-.48c-.46-2.72-1.84-4-4.21-4C3.74 5 2 7.38 2 11.52S3.77 18 6.68 18C9 18 10.45 16.6 11 13.74v-.44l-3-1zM9.92 14c-.5 2.08-1.51 3-3.24 3C4.36 17 3 15 3 11.52 3 9.46 3.51 6 6.71 6c1.72 0 2.71.86 3.14 2.77l-1.24.35c-.26-1-.76-2.06-2-2.06-.67 0-2.24.44-2.24 4.44s1.43 4.44 2.28 4.44c1.3 0 1.81-1.41 2-2.33zM18 12.32l-.11.55c-.17 1-.52 2.07-1.16 2.07-.79 0-1.28-1.32-1.28-3.44 0-2.54.66-3.44 1.23-3.44.25 0 .77 0 1.1 1.78l.11.54 3.11-.9-.08-.48c-.46-2.72-1.84-4-4.21-4C13.74 5 12 7.38 12 11.52S13.77 18 16.68 18c2.32 0 3.77-1.4 4.32-4.26v-.44zM16.68 17C14.36 17 13 15 13 11.52 13 9.46 13.51 6 16.71 6c1.72 0 2.71.86 3.14 2.77l-1.24.35c-.26-1-.76-2.12-2-2.12-.67 0-2.24.5-2.24 4.5s1.47 4.5 2.32 4.5c1.3 0 1.81-1.47 2-2.39l1.2.37c-.47 2.08-1.48 3.02-3.21 3.02z"
  })));
};

var _path$o, _path2$a;

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    width: 24,
    height: 24
  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3a8.5 8.5 0 108.5 8.5A8.51 8.51 0 0011.5 3zm0 16a7.5 7.5 0 117.5-7.5 7.5 7.5 0 01-7.5 7.5z"
  })), _path2$a || (_path2$a = /*#__PURE__*/React.createElement("path", {
    d: "M12 11V6h-1v6h6v-1h-5z"
  })));
};

var _path$n;

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    width: 24,
    height: 24
  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    d: "M17.23 5.55l-7.78 7.78-3.54-3.54-2.82 2.83 3.53 3.54L9.45 19l2.83-2.83 7.78-7.78zm-7.78 12l-4.95-5 1.41-1.41 3.54 3.53L17.23 7l1.41 1.42z"
  })));
};

var _path$m, _path2$9;

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var SvgChecklist = function SvgChecklist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    width: 24,
    height: 24
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    d: "M3 2v19h18V2zm17 18H4V3h16z"
  })), _path2$9 || (_path2$9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5v3h3V5zm2 2H7V6h1zM11 6h7v1h-7zM6 10v3h3v-3zm2 2H7v-1h1zM11 11h7v1h-7zM6 15v3h3v-3zm2 2H7v-1h1zM11 16h7v1h-7z"
  })));
};

var _path$l, _path2$8;

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    width: 24,
    height: 24
  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    d: "M17 8v1h4v8h-3v2.59L15.41 17H9v-2.59l-1 1V18h7l4 4v-4h3V8h-5z"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3v10h3v4l4-4h7V3zm13 9H8.59L6 14.59V12H3V4h12z"
  })));
};

var _circle$2, _circle2$1, _path$k;

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var SvgCartFull = function SvgCartFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    width: 24,
    height: 24
  }, props), _circle$2 || (_circle$2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 20.5,
    r: 1.5
  })), _circle2$1 || (_circle2$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 20.5,
    r: 1.5
  })), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    d: "M7.9 15H18l3-8H6.87l-.36-1.8-4.1-1.88-.41.91 3.63 1.66 1.63 8.23L5 18h14v-1H6.73z"
  })));
};

var _circle$1, _circle2, _path$j;

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var SvgCartEmpty = function SvgCartEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    width: 24,
    height: 24
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 20.5,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 20.5,
    r: 1.5
  })), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    d: "M7.9 15H18l3-8H6.87l-.36-1.8-4.1-1.88-.41.91 3.63 1.66 1.63 8.23L5 18h14v-1H6.73zm-.83-7h12.49l-2.23 6H8.25z"
  })));
};

var _path$i;

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var SvgCaretUp = function SvgCaretUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    width: 24,
    height: 24
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.1L2.1 14l3.54 3.54L12 11.17l6.36 6.37L21.9 14zm0 5.66l-6.36 6.36L3.51 14 12 5.51 20.49 14l-2.13 2.12z"
  })));
};

var _path$h;

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var SvgCaretRight = function SvgCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    width: 24,
    height: 24
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.1L6.46 5.64 12.83 12l-6.37 6.36L10 21.9l9.9-9.9zM7.88 18.36L14.24 12 7.88 5.64 10 3.51 18.49 12 10 20.49z"
  })));
};

var _path$g;

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var SvgCaretLeft = function SvgCaretLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    width: 24,
    height: 24
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    d: "M17.54 5.64L14 2.1 4.1 12l9.9 9.9 3.54-3.54L11.17 12zm-1.42 12.72L14 20.49 5.51 12 14 3.51l2.12 2.13L9.76 12z"
  })));
};

var _path$f;

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var SvgCaretDown = function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    width: 24,
    height: 24
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    d: "M18.36 6.46L12 12.83 5.64 6.46 2.1 10l9.9 9.9 9.9-9.9zM3.51 10l2.13-2.12L12 14.24l6.36-6.36L20.49 10 12 18.49z"
  })));
};

var _path$e;

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    width: 24,
    height: 24
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    d: "M4 4v16h16V4zm1 4h4v3H5zm0 4h4v3H5zm0 7v-3h4v3zm5 0v-3h4v3zm4-8h-4V8h4zm0 1v3h-4v-3zm5 7h-4v-3h4zm0-4h-4v-3h4zm0-4h-4V8h4zM5 7V5h14v2z"
  })));
};

var _path$d, _path2$7;

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    width: 24,
    height: 24
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    d: "M21 10h-2V3h-2V2H7v1H5v7H3v12h18zM5 21H4V11h1zm2 0H6V4h1zm3 0v-4h4v4zm6 0h-1v-5H9v5H8V3h8zm2 0h-1V4h1zm2 0h-1V11h1z"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5h2v2H9zM13 5h2v2h-2zM9 8h2v2H9zM13 8h2v2h-2zM9 11h2v2H9zM13 11h2v2h-2z"
  })));
};

var _path$c;

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: 24,
    height: 24
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H7v18l5-4 5 4zm-1 15.92l-4-3.2-4 3.2V4h8z"
  })));
};

var _path$b, _path2$6;

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var SvgBilling = function SvgBilling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    width: 24,
    height: 24
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H4v20h16V3a1 1 0 00-1-1zm0 19H5V3h14z"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19h7v1h-7zM18 5H6v13h12zM9 17H7v-2h2zm0-3H7v-2h2zm0-3H7V9h2zm0-3H7V6h2zm8 9h-7v-2h7zm0-3h-7v-2h7zm0-3h-7V9h7zm0-3h-7V6h7z"
  })));
};

var _path$a;

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var SvgBillStack = function SvgBillStack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    width: 24,
    height: 24
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    d: "M22 5H2v15h20zM9 19H3v-1h6zm0-2H3v-1h6zm0-4H5V8h4zm0-6H4v7h5v1H3V6h6zm5 3v9h-4V6h4zm1-2h4v5h-4zm6 11h-6v-1h6zm0-2h-6v-1h6zm0-2h-6v-1h5V7h-5V6h6z"
  })));
};

var _path$9;

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    width: 24,
    height: 24
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V4L2 11.5 12 19v-4h10V8zm9 6H11v3l-7.33-5.5L11 6v3h10z",
    fillRule: "evenodd"
  })));
};

var _path$8, _path2$5;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var SvgAttachment = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    width: 24,
    height: 24
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11v2h1v8H6v-1H5v2h17v-9l-2-2z"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5h-3v1h3v4h4v8H3V6h5V5H6v-.5a1.5 1.5 0 013 0V10a1 1 0 01-2 0V8H6v2a2 2 0 004 0V4.5a2.5 2.5 0 00-5 0V5H2v14h17v-9zm1 4V7.41L16.59 9z"
  })));
};

var _path$7;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var SvgAttach = function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: 24,
    height: 24
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6h-4v1h4v4h4v9H4V7h5V6H7v-.5a1.5 1.5 0 013 0V12a1 1 0 01-2 0V9H7v3a2 2 0 004 0V5.5a2.5 2.5 0 00-5 0V6H3v15h18V11zm1 4V8.41L18.59 10z"
  })));
};

var _path$6;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var SvgAreaPost = function SvgAreaPost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 24,
    height: 24
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9h1v4H3zM4 4h3V3H3v4h1V4zM9 3h4v1H9zM4 18v-3H3v4h4v-1H4zM15 3v1h3v3h1V3h-4zM9 18h3v1H9zM22 17h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2zM18 9h1v3h-1z"
  })));
};

var _path$5, _path2$4;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 24,
    height: 24
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5H3v4h1v11h16V9h1zm-2 14H5V9h14zm1-11H4V6h16z"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12h8v1H8z"
  })));
};

var _path$4, _circle, _path2$3;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 24,
    height: 24
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.84 18.1L13.07 3.75a1.25 1.25 0 00-2.14 0L2.16 18.1A1.25 1.25 0 003.23 20h17.54a1.25 1.25 0 001.07-1.9zm-.85.77a.24.24 0 01-.22.13H3.23a.24.24 0 01-.23-.13.23.23 0 010-.25l8.79-14.35a.24.24 0 01.42 0L21 18.62a.23.23 0 010 .25z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.48 13.68a.36.36 0 00.34.32h.36a.36.36 0 00.34-.32L13 9.19a1.68 1.68 0 000-.5.94.94 0 00-.94-.69h-.12a.94.94 0 00-.91.69 1.68 1.68 0 000 .5z"
  })));
};

var _path$3;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: 24,
    height: 24
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10h-7V3h-4v7H3v4h7.13v7H14v-7h7zm-1 3h-7v7h-2v-7H4v-2h7V4h2v7h7z"
  })));
};

var _path$2, _path2$2;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var SvgAddPage = function SvgAddPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: 24,
    height: 24
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3h9v4h4v6h1V7l-5-5H2v17h11v-1H3zm10 1.41L14.59 6H13z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
  })));
};

var _path$1, _path2$1;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var SvgAddMember = function SvgAddMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 24,
    height: 24
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.5a4.5 4.5 0 019 0V16h1v-1.5a5.49 5.49 0 00-3.59-5.15A4.2 4.2 0 0013 6a3.78 3.78 0 00-3.5-4A3.78 3.78 0 006 6a4.2 4.2 0 001.59 3.35A5.49 5.49 0 004 14.5V20h9v-1H5zM7 6a2.79 2.79 0 012.5-3A2.79 2.79 0 0112 6a2.79 2.79 0 01-2.5 3A2.79 2.79 0 017 6z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
  })));
};

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAddFolder = function SvgAddFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8h7.26l1.52-1H20v9h1V6h-9.21L9 4H2v16h11v-1H3zm0-3h6l1.8 1.42L10 7H3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
  })));
};

var ADD_FOLDER = "AddFolder";
var ADD_MEMBER = "AddMember";
var ADD_PAGE = "AddPage";
var ADD = "Add";
var ALERT = "Alert";
var ARCHIVE = "Archive";
var AREA_POST = "AreaPost";
var ATTACH = "Attach";
var ATTACHMENT = "Attachment";
var BACK = "Back";
var BILL_STACK = "BillStack";
var BILLING = "Billing";
var BOOKMARK = "Bookmark";
var BUILDING = "Building";
var CALENDAR = "Calendar";
var CARET_DOWN = "CaretDown";
var CARET_LEFT = "CaretLeft";
var CARET_RIGHT = "CaretRight";
var CARET_UP = "CaretUp";
var CART_EMPTY = "CartEmpty";
var CART_FULL = "CartFull";
var CHAT = "Chat";
var CHECKLIST = "Checklist";
var CHECKMARK = "Checkmark";
var CLOCK = "Clock";
var CLOSED_CAPTIONING = "ClosedCaptioning";
var CLOUD = "Cloud";
var COLLABORATION = "Collaboration";
var COLLAPSE_PANEL = "CollapsePanel";
var COMMENT = "Comment";
var COMPARE = "Compare";
var COMPLETE = "Complete";
var COPY = "Copy";
var CTA_ARROW_RIGHT = "CtaArrowRight";
var DASHBOARD = "Dashboard";
var DATA_REFRESH = "DataRefresh";
var DEVICE_DESKTOP = "DeviceDesktop";
var DEVICE_MOBILE = "DeviceMobile";
var DEVICE_TABLET = "DeviceTablet";
var DEVICES = "Devices";
var DOCUMENT_MANAGEMENT = "DocumentManagement";
var DOWN = "Down";
var DOWNLOAD = "Download";
var EDIT_PROFILE = "EditProfile";
var EDIT = "Edit";
var EDUCATION = "Education";
var ERROR = "Error";
var EXPAND_PANEL = "ExpandPanel";
var EXPORT_MOVE = "ExportMove";
var EXTERNAL_LINK = "ExternalLink";
var EXTERNAL = "External";
var FAVORITE = "Favorite";
var FEATURED = "Featured";
var FEEDBACK = "Feedback";
var FIELD = "Field";
var FILE_ASSEMBLY = "FileAssembly";
var FILE_AUDIO = "FileAudio";
var FILE_DOCUMENT = "FileDocument";
var FILE_GENERIC = "FileGeneric";
var FILE_IMAGE = "FileImage";
var FILE_PART = "FilePart";
var FILE_PDF = "FilePdf";
var FILE_PRESENTATION = "FilePresentation";
var FILE_SPREADSHEET = "FileSpreadsheet";
var FILE_VIDEO = "FileVideo";
var FILE_ZIP = "FileZip";
var FILTER_TOKENS = "FilterTokens";
var FILTER = "Filter";
var FLAG = "Flag";
var FOLDER_OPEN = "FolderOpen";
var FOLDER = "Folder";
var FORUMS = "Forums";
var FORWARD = "Forward";
var GLOBE = "Globe";
var GRAPH = "Graph";
var GRID = "Grid";
var HELP = "Help";
var HIDDEN = "Hidden";
var HIERARCHY = "Hierarchy";
var HOME = "Home";
var IMPORT = "Import";
var INBOX = "Inbox";
var INFO = "Info";
var ITEM = "Item";
var LIBRARY = "Library";
var LINK = "Link";
var LIST = "List";
var LOCATION = "Location";
var LOCK = "Lock";
var MAIL = "Mail";
var MANAGE_ACCESS = "ManageAccess";
var MAXIMIZE = "Maximize";
var MINIMIZE = "Minimize";
var MORE_VERTICAL = "MoreVertical";
var MORE = "More";
var MUTE = "Mute";
var NOT_EDITABLE = "NotEditable";
var NOTIFICATION_OFF = "NotificationOff";
var NOTIFICATION = "Notification";
var ONLINE_VIEWERS = "OnlineViewers";
var PASTE = "Paste";
var PERMISSION_GROUP = "PermissionGroup";
var PERMISSION_INDIVIDUAL = "PermissionIndividual";
var PHOTOS = "Photos";
var PIN = "Pin";
var PLACEHOLDER = "Placeholder";
var PLAYBACK_FAST_FORWARD = "PlaybackFastForward";
var PLAYBACK_GO_TO_END = "PlaybackGoToEnd";
var PLAYBACK_GO_TO_START = "PlaybackGoToStart";
var PLAYBACK_LOOP = "PlaybackLoop";
var PLAYBACK_NEXT = "PlaybackNext";
var PLAYBACK_PAUSE = "PlaybackPause";
var PLAYBACK_PLAY = "PlaybackPlay";
var PLAYBACK_PREVIOUS = "PlaybackPrevious";
var PLAYBACK_RECORD = "PlaybackRecord";
var PLAYBACK_REWIND = "PlaybackRewind";
var PLAYBACK_SHUFFLE = "PlaybackShuffle";
var PLAYBACK_STOP = "PlaybackStop";
var PRINT = "Print";
var PRODUCTS_AND_SERVICES = "ProductsAndServices";
var PROFILE = "Profile";
var PROJECT_MANAGEMENT = "ProjectManagement";
var PROPERTIES = "Properties";
var PUBLISH = "Publish";
var QUANTITIES = "Quantities";
var RECENT_FILE = "RecentFile";
var RECOMMEND = "Recommend";
var REDO = "Redo";
var REMOVE = "Remove";
var RENAME = "Rename";
var REPORT = "Report";
var SAVE_AS = "SaveAs";
var SAVE = "Save";
var SEARCH = "Search";
var SECURITY = "Security";
var SELECT_ALL = "SelectAll";
var SELECT_NONE = "SelectNone";
var SERVICE = "Service";
var SETTINGS = "Settings";
var SHARE = "Share";
var SIGN_OUT = "SignOut";
var SOCIAL_BLOG = "SocialBlog";
var SOCIAL_FACEBOOK = "SocialFacebook";
var SOCIAL_INSTAGRAM = "SocialInstagram";
var SOCIAL_LINKEDIN = "SocialLinkedin";
var SOCIAL_TWITTER = "SocialTwitter";
var SOCIAL_YOUTUBE = "SocialYoutube";
var SORT = "Sort";
var SUBSCRIPTION = "Subscription";
var SUPPORT = "Support";
var SURVEY_EQUIPMENT = "SurveyEquipment";
var SYNC = "Sync";
var TAG = "Tag";
var TRASH = "Trash";
var TREE_VIEW = "TreeView";
var UNAVAILABLE = "Unavailable";
var UNDO = "Undo";
var UNLINK = "Unlink";
var UNLOCK = "Unlock";
var UNPIN = "Unpin";
var UP = "Up";
var UPLOAD = "Upload";
var USER_INACTIVE = "UserInactive";
var VISIBLE = "Visible";
var VOLUME = "Volume";
var ZOOM_IN = "ZoomIn";
var ZOOM_OUT = "ZoomOut";
var CARET_DOWN_M = "CaretDownM";
var CARET_DOWN_S = "CaretDownS";
var CARET_DOWN_XS = "CaretDownXs";
var CARET_LEFT_M = "CaretLeftM";
var CARET_LEFT_S = "CaretLeftS";
var CARET_LEFT_XS = "CaretLeftXs";
var CARET_RIGHT_M = "CaretRightM";
var CARET_RIGHT_S = "CaretRightS";
var CARET_RIGHT_XS = "CaretRightXs";
var CARET_UP_M = "CaretUpM";
var CARET_UP_S = "CaretUpS";
var CARET_UP_XS = "CaretUpXs";
var CHECKMARK_S = "CheckmarkS";
var CHECKMARK_XS = "CheckmarkXs";
var CLOSE_L = "CloseL";
var CLOSE_M = "CloseM";
var CLOSE_S = "CloseS";
var CLOSE_XS = "CloseXs";
var ELLIPSIS_M = "EllipsisM";
var ELLIPSIS_S = "EllipsisS";
var ELLIPSIS_XS = "EllipsisXs";
var HAMBURGER_CLOSE = "HamburgerClose";
var HAMBURGER_DEFAULT = "HamburgerDefault";
var HOLD_S = "HoldS";
var HOLD_XS = "HoldXs";
var OPERATOR_MINUS_S = "OperatorMinusS";
var OPERATOR_MINUS_XS = "OperatorMinusXs";
var OPERATOR_PLUS_S = "OperatorPlusS";
var OPERATOR_PLUS_XS = "OperatorPlusXs";
var names = {
	ADD_FOLDER: ADD_FOLDER,
	ADD_MEMBER: ADD_MEMBER,
	ADD_PAGE: ADD_PAGE,
	ADD: ADD,
	ALERT: ALERT,
	ARCHIVE: ARCHIVE,
	AREA_POST: AREA_POST,
	ATTACH: ATTACH,
	ATTACHMENT: ATTACHMENT,
	BACK: BACK,
	BILL_STACK: BILL_STACK,
	BILLING: BILLING,
	BOOKMARK: BOOKMARK,
	BUILDING: BUILDING,
	CALENDAR: CALENDAR,
	CARET_DOWN: CARET_DOWN,
	CARET_LEFT: CARET_LEFT,
	CARET_RIGHT: CARET_RIGHT,
	CARET_UP: CARET_UP,
	CART_EMPTY: CART_EMPTY,
	CART_FULL: CART_FULL,
	CHAT: CHAT,
	CHECKLIST: CHECKLIST,
	CHECKMARK: CHECKMARK,
	CLOCK: CLOCK,
	CLOSED_CAPTIONING: CLOSED_CAPTIONING,
	CLOUD: CLOUD,
	COLLABORATION: COLLABORATION,
	COLLAPSE_PANEL: COLLAPSE_PANEL,
	COMMENT: COMMENT,
	COMPARE: COMPARE,
	COMPLETE: COMPLETE,
	COPY: COPY,
	CTA_ARROW_RIGHT: CTA_ARROW_RIGHT,
	DASHBOARD: DASHBOARD,
	DATA_REFRESH: DATA_REFRESH,
	DEVICE_DESKTOP: DEVICE_DESKTOP,
	DEVICE_MOBILE: DEVICE_MOBILE,
	DEVICE_TABLET: DEVICE_TABLET,
	DEVICES: DEVICES,
	DOCUMENT_MANAGEMENT: DOCUMENT_MANAGEMENT,
	DOWN: DOWN,
	DOWNLOAD: DOWNLOAD,
	EDIT_PROFILE: EDIT_PROFILE,
	EDIT: EDIT,
	EDUCATION: EDUCATION,
	ERROR: ERROR,
	EXPAND_PANEL: EXPAND_PANEL,
	EXPORT_MOVE: EXPORT_MOVE,
	EXTERNAL_LINK: EXTERNAL_LINK,
	EXTERNAL: EXTERNAL,
	FAVORITE: FAVORITE,
	FEATURED: FEATURED,
	FEEDBACK: FEEDBACK,
	FIELD: FIELD,
	FILE_ASSEMBLY: FILE_ASSEMBLY,
	FILE_AUDIO: FILE_AUDIO,
	FILE_DOCUMENT: FILE_DOCUMENT,
	FILE_GENERIC: FILE_GENERIC,
	FILE_IMAGE: FILE_IMAGE,
	FILE_PART: FILE_PART,
	FILE_PDF: FILE_PDF,
	FILE_PRESENTATION: FILE_PRESENTATION,
	FILE_SPREADSHEET: FILE_SPREADSHEET,
	FILE_VIDEO: FILE_VIDEO,
	FILE_ZIP: FILE_ZIP,
	FILTER_TOKENS: FILTER_TOKENS,
	FILTER: FILTER,
	FLAG: FLAG,
	FOLDER_OPEN: FOLDER_OPEN,
	FOLDER: FOLDER,
	FORUMS: FORUMS,
	FORWARD: FORWARD,
	GLOBE: GLOBE,
	GRAPH: GRAPH,
	GRID: GRID,
	HELP: HELP,
	HIDDEN: HIDDEN,
	HIERARCHY: HIERARCHY,
	HOME: HOME,
	IMPORT: IMPORT,
	INBOX: INBOX,
	INFO: INFO,
	ITEM: ITEM,
	LIBRARY: LIBRARY,
	LINK: LINK,
	LIST: LIST,
	LOCATION: LOCATION,
	LOCK: LOCK,
	MAIL: MAIL,
	MANAGE_ACCESS: MANAGE_ACCESS,
	MAXIMIZE: MAXIMIZE,
	MINIMIZE: MINIMIZE,
	MORE_VERTICAL: MORE_VERTICAL,
	MORE: MORE,
	MUTE: MUTE,
	NOT_EDITABLE: NOT_EDITABLE,
	NOTIFICATION_OFF: NOTIFICATION_OFF,
	NOTIFICATION: NOTIFICATION,
	ONLINE_VIEWERS: ONLINE_VIEWERS,
	PASTE: PASTE,
	PERMISSION_GROUP: PERMISSION_GROUP,
	PERMISSION_INDIVIDUAL: PERMISSION_INDIVIDUAL,
	PHOTOS: PHOTOS,
	PIN: PIN,
	PLACEHOLDER: PLACEHOLDER,
	PLAYBACK_FAST_FORWARD: PLAYBACK_FAST_FORWARD,
	PLAYBACK_GO_TO_END: PLAYBACK_GO_TO_END,
	PLAYBACK_GO_TO_START: PLAYBACK_GO_TO_START,
	PLAYBACK_LOOP: PLAYBACK_LOOP,
	PLAYBACK_NEXT: PLAYBACK_NEXT,
	PLAYBACK_PAUSE: PLAYBACK_PAUSE,
	PLAYBACK_PLAY: PLAYBACK_PLAY,
	PLAYBACK_PREVIOUS: PLAYBACK_PREVIOUS,
	PLAYBACK_RECORD: PLAYBACK_RECORD,
	PLAYBACK_REWIND: PLAYBACK_REWIND,
	PLAYBACK_SHUFFLE: PLAYBACK_SHUFFLE,
	PLAYBACK_STOP: PLAYBACK_STOP,
	PRINT: PRINT,
	PRODUCTS_AND_SERVICES: PRODUCTS_AND_SERVICES,
	PROFILE: PROFILE,
	PROJECT_MANAGEMENT: PROJECT_MANAGEMENT,
	PROPERTIES: PROPERTIES,
	PUBLISH: PUBLISH,
	QUANTITIES: QUANTITIES,
	RECENT_FILE: RECENT_FILE,
	RECOMMEND: RECOMMEND,
	REDO: REDO,
	REMOVE: REMOVE,
	RENAME: RENAME,
	REPORT: REPORT,
	SAVE_AS: SAVE_AS,
	SAVE: SAVE,
	SEARCH: SEARCH,
	SECURITY: SECURITY,
	SELECT_ALL: SELECT_ALL,
	SELECT_NONE: SELECT_NONE,
	SERVICE: SERVICE,
	SETTINGS: SETTINGS,
	SHARE: SHARE,
	SIGN_OUT: SIGN_OUT,
	SOCIAL_BLOG: SOCIAL_BLOG,
	SOCIAL_FACEBOOK: SOCIAL_FACEBOOK,
	SOCIAL_INSTAGRAM: SOCIAL_INSTAGRAM,
	SOCIAL_LINKEDIN: SOCIAL_LINKEDIN,
	SOCIAL_TWITTER: SOCIAL_TWITTER,
	SOCIAL_YOUTUBE: SOCIAL_YOUTUBE,
	SORT: SORT,
	SUBSCRIPTION: SUBSCRIPTION,
	SUPPORT: SUPPORT,
	SURVEY_EQUIPMENT: SURVEY_EQUIPMENT,
	SYNC: SYNC,
	TAG: TAG,
	TRASH: TRASH,
	TREE_VIEW: TREE_VIEW,
	UNAVAILABLE: UNAVAILABLE,
	UNDO: UNDO,
	UNLINK: UNLINK,
	UNLOCK: UNLOCK,
	UNPIN: UNPIN,
	UP: UP,
	UPLOAD: UPLOAD,
	USER_INACTIVE: USER_INACTIVE,
	VISIBLE: VISIBLE,
	VOLUME: VOLUME,
	ZOOM_IN: ZOOM_IN,
	ZOOM_OUT: ZOOM_OUT,
	CARET_DOWN_M: CARET_DOWN_M,
	CARET_DOWN_S: CARET_DOWN_S,
	CARET_DOWN_XS: CARET_DOWN_XS,
	CARET_LEFT_M: CARET_LEFT_M,
	CARET_LEFT_S: CARET_LEFT_S,
	CARET_LEFT_XS: CARET_LEFT_XS,
	CARET_RIGHT_M: CARET_RIGHT_M,
	CARET_RIGHT_S: CARET_RIGHT_S,
	CARET_RIGHT_XS: CARET_RIGHT_XS,
	CARET_UP_M: CARET_UP_M,
	CARET_UP_S: CARET_UP_S,
	CARET_UP_XS: CARET_UP_XS,
	CHECKMARK_S: CHECKMARK_S,
	CHECKMARK_XS: CHECKMARK_XS,
	CLOSE_L: CLOSE_L,
	CLOSE_M: CLOSE_M,
	CLOSE_S: CLOSE_S,
	CLOSE_XS: CLOSE_XS,
	ELLIPSIS_M: ELLIPSIS_M,
	ELLIPSIS_S: ELLIPSIS_S,
	ELLIPSIS_XS: ELLIPSIS_XS,
	HAMBURGER_CLOSE: HAMBURGER_CLOSE,
	HAMBURGER_DEFAULT: HAMBURGER_DEFAULT,
	HOLD_S: HOLD_S,
	HOLD_XS: HOLD_XS,
	OPERATOR_MINUS_S: OPERATOR_MINUS_S,
	OPERATOR_MINUS_XS: OPERATOR_MINUS_XS,
	OPERATOR_PLUS_S: OPERATOR_PLUS_S,
	OPERATOR_PLUS_XS: OPERATOR_PLUS_XS
};

var higIconSets = [
	{
		title: "Regular",
		dirName: "regular",
		size: "24",
		iconNames: [
			"AddFolder",
			"AddMember",
			"AddPage",
			"Add",
			"Alert",
			"Archive",
			"AreaPost",
			"Attach",
			"Attachment",
			"Back",
			"BillStack",
			"Billing",
			"Bookmark",
			"Building",
			"Calendar",
			"CaretDown",
			"CaretLeft",
			"CaretRight",
			"CaretUp",
			"CartEmpty",
			"CartFull",
			"Chat",
			"Checklist",
			"Checkmark",
			"Clock",
			"ClosedCaptioning",
			"Cloud",
			"Collaboration",
			"CollapsePanel",
			"Comment",
			"Compare",
			"Complete",
			"Copy",
			"CtaArrowRight",
			"Dashboard",
			"DataRefresh",
			"DeviceDesktop",
			"DeviceMobile",
			"DeviceTablet",
			"Devices",
			"DocumentManagement",
			"Down",
			"Download",
			"EditProfile",
			"Edit",
			"Education",
			"Error",
			"ExpandPanel",
			"ExportMove",
			"ExternalLink",
			"External",
			"Favorite",
			"Featured",
			"Feedback",
			"Field",
			"FileAssembly",
			"FileAudio",
			"FileDocument",
			"FileGeneric",
			"FileImage",
			"FilePart",
			"FilePdf",
			"FilePresentation",
			"FileSpreadsheet",
			"FileVideo",
			"FileZip",
			"FilterTokens",
			"Filter",
			"Flag",
			"FolderOpen",
			"Folder",
			"Forums",
			"Forward",
			"Globe",
			"Graph",
			"Grid",
			"Help",
			"Hidden",
			"Hierarchy",
			"Home",
			"Import",
			"Inbox",
			"Info",
			"Item",
			"Library",
			"Link",
			"List",
			"Location",
			"Lock",
			"Mail",
			"ManageAccess",
			"Maximize",
			"Minimize",
			"MoreVertical",
			"More",
			"Mute",
			"NotEditable",
			"NotificationOff",
			"Notification",
			"OnlineViewers",
			"Paste",
			"PermissionGroup",
			"PermissionIndividual",
			"Photos",
			"Pin",
			"Placeholder",
			"PlaybackFastForward",
			"PlaybackGoToEnd",
			"PlaybackGoToStart",
			"PlaybackLoop",
			"PlaybackNext",
			"PlaybackPause",
			"PlaybackPlay",
			"PlaybackPrevious",
			"PlaybackRecord",
			"PlaybackRewind",
			"PlaybackShuffle",
			"PlaybackStop",
			"Print",
			"ProductsAndServices",
			"Profile",
			"ProjectManagement",
			"Properties",
			"Publish",
			"Quantities",
			"RecentFile",
			"Recommend",
			"Redo",
			"Remove",
			"Rename",
			"Report",
			"SaveAs",
			"Save",
			"Search",
			"Security",
			"SelectAll",
			"SelectNone",
			"Service",
			"Settings",
			"Share",
			"SignOut",
			"SocialBlog",
			"SocialFacebook",
			"SocialInstagram",
			"SocialLinkedin",
			"SocialTwitter",
			"SocialYoutube",
			"Sort",
			"Subscription",
			"Support",
			"SurveyEquipment",
			"Sync",
			"Tag",
			"Trash",
			"TreeView",
			"Unavailable",
			"Undo",
			"Unlink",
			"Unlock",
			"Unpin",
			"Up",
			"Upload",
			"UserInactive",
			"Visible",
			"Volume",
			"ZoomIn",
			"ZoomOut"
		]
	},
	{
		title: "Information Dense",
		dirName: "information-dense",
		size: "16",
		iconNames: [
			"AddFolder",
			"AddMember",
			"AddPage",
			"Add",
			"Alert",
			"Archive",
			"AreaPost",
			"Attach",
			"Attachment",
			"Back",
			"BillStack",
			"Billing",
			"Bookmark",
			"Building",
			"Calendar",
			"CaretDown",
			"CaretLeft",
			"CaretRight",
			"CaretUp",
			"CartEmpty",
			"CartFull",
			"Chat",
			"Checklist",
			"Checkmark",
			"Clock",
			"ClosedCaptioning",
			"Cloud",
			"Collaboration",
			"CollapsePanel",
			"Comment",
			"Compare",
			"Complete",
			"Copy",
			"CtaArrowRight",
			"Dashboard",
			"DataRefresh",
			"DeviceDesktop",
			"DeviceMobile",
			"DeviceTablet",
			"Devices",
			"DocumentManagement",
			"Down",
			"Download",
			"EditProfile",
			"Edit",
			"Education",
			"Error",
			"ExpandPanel",
			"ExportMove",
			"ExternalLink",
			"External",
			"Favorite",
			"Featured",
			"Feedback",
			"Field",
			"FileAssembly",
			"FileAudio",
			"FileDocument",
			"FileGeneric",
			"FileImage",
			"FilePart",
			"FilePdf",
			"FilePresentation",
			"FileSpreadsheet",
			"FileVideo",
			"FileZip",
			"FilterTokens",
			"Filter",
			"Flag",
			"FolderOpen",
			"Folder",
			"Forums",
			"Forward",
			"Globe",
			"Graph",
			"Grid",
			"Help",
			"Hidden",
			"Hierarchy",
			"Home",
			"Import",
			"Inbox",
			"Info",
			"Item",
			"Library",
			"Link",
			"List",
			"Location",
			"Lock",
			"Mail",
			"ManageAccess",
			"Maximize",
			"Minimize",
			"MoreVertical",
			"More",
			"Mute",
			"NotEditable",
			"NotificationOff",
			"Notification",
			"OnlineViewers",
			"Paste",
			"PermissionGroup",
			"PermissionIndividual",
			"Photos",
			"Pin",
			"Placeholder",
			"PlaybackFastForward",
			"PlaybackGoToEnd",
			"PlaybackGoToStart",
			"PlaybackLoop",
			"PlaybackNext",
			"PlaybackPause",
			"PlaybackPlay",
			"PlaybackPrevious",
			"PlaybackRecord",
			"PlaybackRewind",
			"PlaybackShuffle",
			"PlaybackStop",
			"Print",
			"ProductsAndServices",
			"Profile",
			"ProjectManagement",
			"Properties",
			"Publish",
			"Quantities",
			"RecentFile",
			"Recommend",
			"Redo",
			"Remove",
			"Rename",
			"Report",
			"SaveAs",
			"Save",
			"Search",
			"Security",
			"SelectAll",
			"SelectNone",
			"Service",
			"Settings",
			"Share",
			"SignOut",
			"SocialBlog",
			"SocialFacebook",
			"SocialInstagram",
			"SocialLinkedin",
			"SocialTwitter",
			"SocialYoutube",
			"Sort",
			"Subscription",
			"Support",
			"SurveyEquipment",
			"Sync",
			"Tag",
			"Trash",
			"TreeView",
			"Unavailable",
			"Undo",
			"Unlink",
			"Unlock",
			"Unpin",
			"Up",
			"Upload",
			"UserInactive",
			"Visible",
			"Volume",
			"ZoomIn",
			"ZoomOut"
		]
	},
	{
		title: "UI Controls",
		dirName: "ui-controls",
		size: "UI",
		iconNames: [
			"CaretDownM",
			"CaretDownS",
			"CaretDownXs",
			"CaretLeftM",
			"CaretLeftS",
			"CaretLeftXs",
			"CaretRightM",
			"CaretRightS",
			"CaretRightXs",
			"CaretUpM",
			"CaretUpS",
			"CaretUpXs",
			"CheckmarkS",
			"CheckmarkXs",
			"CloseL",
			"CloseM",
			"CloseS",
			"CloseXs",
			"EllipsisM",
			"EllipsisS",
			"EllipsisXs",
			"HamburgerClose",
			"HamburgerDefault",
			"HoldS",
			"HoldXs",
			"OperatorMinusS",
			"OperatorMinusXs",
			"OperatorPlusS",
			"OperatorPlusXs"
		]
	},
	{
		title: "Size 12",
		dirName: "size12",
		size: "12",
		iconNames: [
			"Alert",
			"Complete",
			"Error",
			"Help"
		]
	}
];

const sizes = Object.freeze({
  PX_24: "24",
  PX_16: "16",
  PX_12: "12",
  PX_UI: "UI"
});
const AVAILABLE_SIZES = Object.freeze(Object.values(sizes));

/* eslint-disable */
const AVAILABLE_NAMES = Object.freeze(Object.values(names));
const AddFolder24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref => {
  let {
    resolvedRoles
  } = _ref;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAddFolder, propsClone);
});
const AddMember24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref2 => {
  let {
    resolvedRoles
  } = _ref2;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAddMember, propsClone);
});
const AddPage24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref3 => {
  let {
    resolvedRoles
  } = _ref3;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAddPage, propsClone);
});
const Add24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref4 => {
  let {
    resolvedRoles
  } = _ref4;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAdd, propsClone);
});
const Alert24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref5 => {
  let {
    resolvedRoles
  } = _ref5;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAlert, propsClone);
});
const Archive24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref6 => {
  let {
    resolvedRoles
  } = _ref6;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgArchive, propsClone);
});
const AreaPost24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref7 => {
  let {
    resolvedRoles
  } = _ref7;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAreaPost, propsClone);
});
const Attach24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref8 => {
  let {
    resolvedRoles
  } = _ref8;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAttach, propsClone);
});
const Attachment24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref9 => {
  let {
    resolvedRoles
  } = _ref9;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAttachment, propsClone);
});
const Back24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref10 => {
  let {
    resolvedRoles
  } = _ref10;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgBack, propsClone);
});
const BillStack24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref11 => {
  let {
    resolvedRoles
  } = _ref11;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgBillStack, propsClone);
});
const Billing24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref12 => {
  let {
    resolvedRoles
  } = _ref12;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgBilling, propsClone);
});
const Bookmark24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref13 => {
  let {
    resolvedRoles
  } = _ref13;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgBookmark, propsClone);
});
const Building24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref14 => {
  let {
    resolvedRoles
  } = _ref14;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgBuilding, propsClone);
});
const Calendar24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref15 => {
  let {
    resolvedRoles
  } = _ref15;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCalendar, propsClone);
});
const CaretDown24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref16 => {
  let {
    resolvedRoles
  } = _ref16;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretDown, propsClone);
});
const CaretLeft24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref17 => {
  let {
    resolvedRoles
  } = _ref17;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretLeft, propsClone);
});
const CaretRight24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref18 => {
  let {
    resolvedRoles
  } = _ref18;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretRight, propsClone);
});
const CaretUp24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref19 => {
  let {
    resolvedRoles
  } = _ref19;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretUp, propsClone);
});
const CartEmpty24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref20 => {
  let {
    resolvedRoles
  } = _ref20;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCartEmpty, propsClone);
});
const CartFull24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref21 => {
  let {
    resolvedRoles
  } = _ref21;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCartFull, propsClone);
});
const Chat24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref22 => {
  let {
    resolvedRoles
  } = _ref22;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgChat, propsClone);
});
const Checklist24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref23 => {
  let {
    resolvedRoles
  } = _ref23;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgChecklist, propsClone);
});
const Checkmark24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref24 => {
  let {
    resolvedRoles
  } = _ref24;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCheckmark, propsClone);
});
const Clock24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref25 => {
  let {
    resolvedRoles
  } = _ref25;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgClock, propsClone);
});
const ClosedCaptioning24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref26 => {
  let {
    resolvedRoles
  } = _ref26;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgClosedCaptioning, propsClone);
});
const Cloud24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref27 => {
  let {
    resolvedRoles
  } = _ref27;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCloud, propsClone);
});
const Collaboration24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref28 => {
  let {
    resolvedRoles
  } = _ref28;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCollaboration, propsClone);
});
const CollapsePanel24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref29 => {
  let {
    resolvedRoles
  } = _ref29;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCollapsePanel, propsClone);
});
const Comment24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref30 => {
  let {
    resolvedRoles
  } = _ref30;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgComment, propsClone);
});
const Compare24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref31 => {
  let {
    resolvedRoles
  } = _ref31;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCompare, propsClone);
});
const Complete24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref32 => {
  let {
    resolvedRoles
  } = _ref32;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgComplete, propsClone);
});
const Copy24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref33 => {
  let {
    resolvedRoles
  } = _ref33;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCopy, propsClone);
});
const CtaArrowRight24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref34 => {
  let {
    resolvedRoles
  } = _ref34;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCtaArrowRight, propsClone);
});
const Dashboard24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref35 => {
  let {
    resolvedRoles
  } = _ref35;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDashboard, propsClone);
});
const DataRefresh24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref36 => {
  let {
    resolvedRoles
  } = _ref36;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDataRefresh, propsClone);
});
const DeviceDesktop24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref37 => {
  let {
    resolvedRoles
  } = _ref37;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDeviceDesktop, propsClone);
});
const DeviceMobile24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref38 => {
  let {
    resolvedRoles
  } = _ref38;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDeviceMobile, propsClone);
});
const DeviceTablet24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref39 => {
  let {
    resolvedRoles
  } = _ref39;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDeviceTablet, propsClone);
});
const Devices24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref40 => {
  let {
    resolvedRoles
  } = _ref40;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDevices, propsClone);
});
const DocumentManagement24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref41 => {
  let {
    resolvedRoles
  } = _ref41;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDocumentManagement, propsClone);
});
const Down24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref42 => {
  let {
    resolvedRoles
  } = _ref42;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDown, propsClone);
});
const Download24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref43 => {
  let {
    resolvedRoles
  } = _ref43;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDownload, propsClone);
});
const EditProfile24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref44 => {
  let {
    resolvedRoles
  } = _ref44;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgEditProfile, propsClone);
});
const Edit24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref45 => {
  let {
    resolvedRoles
  } = _ref45;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgEdit, propsClone);
});
const Education24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref46 => {
  let {
    resolvedRoles
  } = _ref46;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgEducation, propsClone);
});
const Error24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref47 => {
  let {
    resolvedRoles
  } = _ref47;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgError, propsClone);
});
const ExpandPanel24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref48 => {
  let {
    resolvedRoles
  } = _ref48;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgExpandPanel, propsClone);
});
const ExportMove24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref49 => {
  let {
    resolvedRoles
  } = _ref49;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgExportMove, propsClone);
});
const ExternalLink24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref50 => {
  let {
    resolvedRoles
  } = _ref50;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgExternalLink, propsClone);
});
const External24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref51 => {
  let {
    resolvedRoles
  } = _ref51;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgExternal, propsClone);
});
const Favorite24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref52 => {
  let {
    resolvedRoles
  } = _ref52;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFavorite, propsClone);
});
const Featured24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref53 => {
  let {
    resolvedRoles
  } = _ref53;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFeatured, propsClone);
});
const Feedback24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref54 => {
  let {
    resolvedRoles
  } = _ref54;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFeedback, propsClone);
});
const Field24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref55 => {
  let {
    resolvedRoles
  } = _ref55;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgField, propsClone);
});
const FileAssembly24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref56 => {
  let {
    resolvedRoles
  } = _ref56;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileAssembly, propsClone);
});
const FileAudio24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref57 => {
  let {
    resolvedRoles
  } = _ref57;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileAudio, propsClone);
});
const FileDocument24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref58 => {
  let {
    resolvedRoles
  } = _ref58;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileDocument, propsClone);
});
const FileGeneric24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref59 => {
  let {
    resolvedRoles
  } = _ref59;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileGeneric, propsClone);
});
const FileImage24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref60 => {
  let {
    resolvedRoles
  } = _ref60;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileImage, propsClone);
});
const FilePart24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref61 => {
  let {
    resolvedRoles
  } = _ref61;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFilePart, propsClone);
});
const FilePdf24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref62 => {
  let {
    resolvedRoles
  } = _ref62;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFilePdf, propsClone);
});
const FilePresentation24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref63 => {
  let {
    resolvedRoles
  } = _ref63;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFilePresentation, propsClone);
});
const FileSpreadsheet24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref64 => {
  let {
    resolvedRoles
  } = _ref64;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileSpreadsheet, propsClone);
});
const FileVideo24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref65 => {
  let {
    resolvedRoles
  } = _ref65;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileVideo, propsClone);
});
const FileZip24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref66 => {
  let {
    resolvedRoles
  } = _ref66;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileZip, propsClone);
});
const FilterTokens24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref67 => {
  let {
    resolvedRoles
  } = _ref67;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFilterTokens, propsClone);
});
const Filter24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref68 => {
  let {
    resolvedRoles
  } = _ref68;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFilter, propsClone);
});
const Flag24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref69 => {
  let {
    resolvedRoles
  } = _ref69;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFlag, propsClone);
});
const FolderOpen24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref70 => {
  let {
    resolvedRoles
  } = _ref70;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFolderOpen, propsClone);
});
const Folder24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref71 => {
  let {
    resolvedRoles
  } = _ref71;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFolder, propsClone);
});
const Forums24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref72 => {
  let {
    resolvedRoles
  } = _ref72;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgForums, propsClone);
});
const Forward24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref73 => {
  let {
    resolvedRoles
  } = _ref73;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgForward, propsClone);
});
const Globe24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref74 => {
  let {
    resolvedRoles
  } = _ref74;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgGlobe, propsClone);
});
const Graph24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref75 => {
  let {
    resolvedRoles
  } = _ref75;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgGraph, propsClone);
});
const Grid24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref76 => {
  let {
    resolvedRoles
  } = _ref76;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgGrid, propsClone);
});
const Help24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref77 => {
  let {
    resolvedRoles
  } = _ref77;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHelp, propsClone);
});
const Hidden24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref78 => {
  let {
    resolvedRoles
  } = _ref78;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHidden, propsClone);
});
const Hierarchy24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref79 => {
  let {
    resolvedRoles
  } = _ref79;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHierarchy, propsClone);
});
const Home24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref80 => {
  let {
    resolvedRoles
  } = _ref80;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHome, propsClone);
});
const Import24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref81 => {
  let {
    resolvedRoles
  } = _ref81;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgImport, propsClone);
});
const Inbox24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref82 => {
  let {
    resolvedRoles
  } = _ref82;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgInbox, propsClone);
});
const Info24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref83 => {
  let {
    resolvedRoles
  } = _ref83;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgInfo, propsClone);
});
const Item24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref84 => {
  let {
    resolvedRoles
  } = _ref84;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgItem, propsClone);
});
const Library24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref85 => {
  let {
    resolvedRoles
  } = _ref85;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgLibrary, propsClone);
});
const Link24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref86 => {
  let {
    resolvedRoles
  } = _ref86;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgLink, propsClone);
});
const List24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref87 => {
  let {
    resolvedRoles
  } = _ref87;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgList, propsClone);
});
const Location24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref88 => {
  let {
    resolvedRoles
  } = _ref88;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgLocation, propsClone);
});
const Lock24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref89 => {
  let {
    resolvedRoles
  } = _ref89;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgLock, propsClone);
});
const Mail24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref90 => {
  let {
    resolvedRoles
  } = _ref90;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgMail, propsClone);
});
const ManageAccess24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref91 => {
  let {
    resolvedRoles
  } = _ref91;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgManageAccess, propsClone);
});
const Maximize24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref92 => {
  let {
    resolvedRoles
  } = _ref92;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgMaximize, propsClone);
});
const Minimize24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref93 => {
  let {
    resolvedRoles
  } = _ref93;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgMinimize, propsClone);
});
const MoreVertical24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref94 => {
  let {
    resolvedRoles
  } = _ref94;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgMoreVertical, propsClone);
});
const More24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref95 => {
  let {
    resolvedRoles
  } = _ref95;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgMore, propsClone);
});
const Mute24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref96 => {
  let {
    resolvedRoles
  } = _ref96;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgMute, propsClone);
});
const NotEditable24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref97 => {
  let {
    resolvedRoles
  } = _ref97;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgNotEditable, propsClone);
});
const NotificationOff24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref98 => {
  let {
    resolvedRoles
  } = _ref98;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgNotificationOff, propsClone);
});
const Notification24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref99 => {
  let {
    resolvedRoles
  } = _ref99;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgNotification, propsClone);
});
const OnlineViewers24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref100 => {
  let {
    resolvedRoles
  } = _ref100;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgOnlineViewers, propsClone);
});
const Paste24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref101 => {
  let {
    resolvedRoles
  } = _ref101;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPaste, propsClone);
});
const PermissionGroup24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref102 => {
  let {
    resolvedRoles
  } = _ref102;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPermissionGroup, propsClone);
});
const PermissionIndividual24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref103 => {
  let {
    resolvedRoles
  } = _ref103;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPermissionIndividual, propsClone);
});
const Photos24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref104 => {
  let {
    resolvedRoles
  } = _ref104;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPhotos, propsClone);
});
const Pin24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref105 => {
  let {
    resolvedRoles
  } = _ref105;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPin, propsClone);
});
const Placeholder24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref106 => {
  let {
    resolvedRoles
  } = _ref106;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaceholder, propsClone);
});
const PlaybackFastForward24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref107 => {
  let {
    resolvedRoles
  } = _ref107;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackFastForward, propsClone);
});
const PlaybackGoToEnd24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref108 => {
  let {
    resolvedRoles
  } = _ref108;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackGoToEnd, propsClone);
});
const PlaybackGoToStart24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref109 => {
  let {
    resolvedRoles
  } = _ref109;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackGoToStart, propsClone);
});
const PlaybackLoop24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref110 => {
  let {
    resolvedRoles
  } = _ref110;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackLoop, propsClone);
});
const PlaybackNext24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref111 => {
  let {
    resolvedRoles
  } = _ref111;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackNext, propsClone);
});
const PlaybackPause24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref112 => {
  let {
    resolvedRoles
  } = _ref112;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackPause, propsClone);
});
const PlaybackPlay24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref113 => {
  let {
    resolvedRoles
  } = _ref113;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackPlay, propsClone);
});
const PlaybackPrevious24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref114 => {
  let {
    resolvedRoles
  } = _ref114;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackPrevious, propsClone);
});
const PlaybackRecord24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref115 => {
  let {
    resolvedRoles
  } = _ref115;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackRecord, propsClone);
});
const PlaybackRewind24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref116 => {
  let {
    resolvedRoles
  } = _ref116;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackRewind, propsClone);
});
const PlaybackShuffle24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref117 => {
  let {
    resolvedRoles
  } = _ref117;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackShuffle, propsClone);
});
const PlaybackStop24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref118 => {
  let {
    resolvedRoles
  } = _ref118;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackStop, propsClone);
});
const Print24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref119 => {
  let {
    resolvedRoles
  } = _ref119;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPrint, propsClone);
});
const ProductsAndServices24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref120 => {
  let {
    resolvedRoles
  } = _ref120;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgProductsAndServices, propsClone);
});
const Profile24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref121 => {
  let {
    resolvedRoles
  } = _ref121;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgProfile, propsClone);
});
const ProjectManagement24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref122 => {
  let {
    resolvedRoles
  } = _ref122;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgProjectManagement, propsClone);
});
const Properties24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref123 => {
  let {
    resolvedRoles
  } = _ref123;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgProperties, propsClone);
});
const Publish24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref124 => {
  let {
    resolvedRoles
  } = _ref124;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPublish, propsClone);
});
const Quantities24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref125 => {
  let {
    resolvedRoles
  } = _ref125;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgQuantities, propsClone);
});
const RecentFile24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref126 => {
  let {
    resolvedRoles
  } = _ref126;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgRecentFile, propsClone);
});
const Recommend24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref127 => {
  let {
    resolvedRoles
  } = _ref127;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgRecommend, propsClone);
});
const Redo24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref128 => {
  let {
    resolvedRoles
  } = _ref128;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgRedo, propsClone);
});
const Remove24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref129 => {
  let {
    resolvedRoles
  } = _ref129;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgRemove, propsClone);
});
const Rename24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref130 => {
  let {
    resolvedRoles
  } = _ref130;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgRename, propsClone);
});
const Report24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref131 => {
  let {
    resolvedRoles
  } = _ref131;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgReport, propsClone);
});
const SaveAs24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref132 => {
  let {
    resolvedRoles
  } = _ref132;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSaveAs, propsClone);
});
const Save24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref133 => {
  let {
    resolvedRoles
  } = _ref133;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSave, propsClone);
});
const Search24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref134 => {
  let {
    resolvedRoles
  } = _ref134;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSearch, propsClone);
});
const Security24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref135 => {
  let {
    resolvedRoles
  } = _ref135;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSecurity, propsClone);
});
const SelectAll24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref136 => {
  let {
    resolvedRoles
  } = _ref136;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSelectAll, propsClone);
});
const SelectNone24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref137 => {
  let {
    resolvedRoles
  } = _ref137;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSelectNone, propsClone);
});
const Service24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref138 => {
  let {
    resolvedRoles
  } = _ref138;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgService, propsClone);
});
const Settings24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref139 => {
  let {
    resolvedRoles
  } = _ref139;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSettings, propsClone);
});
const Share24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref140 => {
  let {
    resolvedRoles
  } = _ref140;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgShare, propsClone);
});
const SignOut24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref141 => {
  let {
    resolvedRoles
  } = _ref141;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSignOut, propsClone);
});
const SocialBlog24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref142 => {
  let {
    resolvedRoles
  } = _ref142;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSocialBlog, propsClone);
});
const SocialFacebook24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref143 => {
  let {
    resolvedRoles
  } = _ref143;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSocialFacebook, propsClone);
});
const SocialInstagram24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref144 => {
  let {
    resolvedRoles
  } = _ref144;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSocialInstagram, propsClone);
});
const SocialLinkedin24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref145 => {
  let {
    resolvedRoles
  } = _ref145;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSocialLinkedin, propsClone);
});
const SocialTwitter24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref146 => {
  let {
    resolvedRoles
  } = _ref146;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSocialTwitter, propsClone);
});
const SocialYoutube24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref147 => {
  let {
    resolvedRoles
  } = _ref147;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSocialYoutube, propsClone);
});
const Sort24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref148 => {
  let {
    resolvedRoles
  } = _ref148;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSort, propsClone);
});
const Subscription24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref149 => {
  let {
    resolvedRoles
  } = _ref149;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSubscription, propsClone);
});
const Support24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref150 => {
  let {
    resolvedRoles
  } = _ref150;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSupport, propsClone);
});
const SurveyEquipment24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref151 => {
  let {
    resolvedRoles
  } = _ref151;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSurveyEquipment, propsClone);
});
const Sync24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref152 => {
  let {
    resolvedRoles
  } = _ref152;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSync, propsClone);
});
const Tag24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref153 => {
  let {
    resolvedRoles
  } = _ref153;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgTag, propsClone);
});
const Trash24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref154 => {
  let {
    resolvedRoles
  } = _ref154;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgTrash, propsClone);
});
const TreeView24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref155 => {
  let {
    resolvedRoles
  } = _ref155;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgTreeView, propsClone);
});
const Unavailable24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref156 => {
  let {
    resolvedRoles
  } = _ref156;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUnavailable, propsClone);
});
const Undo24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref157 => {
  let {
    resolvedRoles
  } = _ref157;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUndo, propsClone);
});
const Unlink24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref158 => {
  let {
    resolvedRoles
  } = _ref158;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUnlink, propsClone);
});
const Unlock24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref159 => {
  let {
    resolvedRoles
  } = _ref159;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUnlock, propsClone);
});
const Unpin24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref160 => {
  let {
    resolvedRoles
  } = _ref160;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUnpin, propsClone);
});
const Up24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref161 => {
  let {
    resolvedRoles
  } = _ref161;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUp, propsClone);
});
const Upload24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref162 => {
  let {
    resolvedRoles
  } = _ref162;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUpload, propsClone);
});
const UserInactive24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref163 => {
  let {
    resolvedRoles
  } = _ref163;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUserInactive, propsClone);
});
const Visible24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref164 => {
  let {
    resolvedRoles
  } = _ref164;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgVisible, propsClone);
});
const Volume24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref165 => {
  let {
    resolvedRoles
  } = _ref165;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgVolume, propsClone);
});
const ZoomIn24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref166 => {
  let {
    resolvedRoles
  } = _ref166;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgZoomIn, propsClone);
});
const ZoomOut24 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref167 => {
  let {
    resolvedRoles
  } = _ref167;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgZoomOut, propsClone);
});
const AddFolder16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref168 => {
  let {
    resolvedRoles
  } = _ref168;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAddFolder$1, propsClone);
});
const AddMember16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref169 => {
  let {
    resolvedRoles
  } = _ref169;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAddMember$1, propsClone);
});
const AddPage16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref170 => {
  let {
    resolvedRoles
  } = _ref170;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAddPage$1, propsClone);
});
const Add16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref171 => {
  let {
    resolvedRoles
  } = _ref171;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAdd$1, propsClone);
});
const Alert16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref172 => {
  let {
    resolvedRoles
  } = _ref172;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAlert$1, propsClone);
});
const Archive16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref173 => {
  let {
    resolvedRoles
  } = _ref173;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgArchive$1, propsClone);
});
const AreaPost16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref174 => {
  let {
    resolvedRoles
  } = _ref174;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAreaPost$1, propsClone);
});
const Attach16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref175 => {
  let {
    resolvedRoles
  } = _ref175;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAttach$1, propsClone);
});
const Attachment16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref176 => {
  let {
    resolvedRoles
  } = _ref176;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAttachment$1, propsClone);
});
const Back16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref177 => {
  let {
    resolvedRoles
  } = _ref177;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgBack$1, propsClone);
});
const BillStack16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref178 => {
  let {
    resolvedRoles
  } = _ref178;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgBillStack$1, propsClone);
});
const Billing16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref179 => {
  let {
    resolvedRoles
  } = _ref179;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgBilling$1, propsClone);
});
const Bookmark16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref180 => {
  let {
    resolvedRoles
  } = _ref180;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgBookmark$1, propsClone);
});
const Building16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref181 => {
  let {
    resolvedRoles
  } = _ref181;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgBuilding$1, propsClone);
});
const Calendar16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref182 => {
  let {
    resolvedRoles
  } = _ref182;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCalendar$1, propsClone);
});
const CaretDown16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref183 => {
  let {
    resolvedRoles
  } = _ref183;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretDown$1, propsClone);
});
const CaretLeft16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref184 => {
  let {
    resolvedRoles
  } = _ref184;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretLeft$1, propsClone);
});
const CaretRight16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref185 => {
  let {
    resolvedRoles
  } = _ref185;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretRight$1, propsClone);
});
const CaretUp16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref186 => {
  let {
    resolvedRoles
  } = _ref186;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretUp$1, propsClone);
});
const CartEmpty16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref187 => {
  let {
    resolvedRoles
  } = _ref187;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCartEmpty$1, propsClone);
});
const CartFull16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref188 => {
  let {
    resolvedRoles
  } = _ref188;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCartFull$1, propsClone);
});
const Chat16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref189 => {
  let {
    resolvedRoles
  } = _ref189;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgChat$1, propsClone);
});
const Checklist16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref190 => {
  let {
    resolvedRoles
  } = _ref190;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgChecklist$1, propsClone);
});
const Checkmark16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref191 => {
  let {
    resolvedRoles
  } = _ref191;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCheckmark$1, propsClone);
});
const Clock16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref192 => {
  let {
    resolvedRoles
  } = _ref192;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgClock$1, propsClone);
});
const ClosedCaptioning16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref193 => {
  let {
    resolvedRoles
  } = _ref193;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgClosedCaptioning$1, propsClone);
});
const Cloud16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref194 => {
  let {
    resolvedRoles
  } = _ref194;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCloud$1, propsClone);
});
const Collaboration16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref195 => {
  let {
    resolvedRoles
  } = _ref195;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCollaboration$1, propsClone);
});
const CollapsePanel16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref196 => {
  let {
    resolvedRoles
  } = _ref196;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCollapsePanel$1, propsClone);
});
const Comment16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref197 => {
  let {
    resolvedRoles
  } = _ref197;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgComment$1, propsClone);
});
const Compare16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref198 => {
  let {
    resolvedRoles
  } = _ref198;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCompare$1, propsClone);
});
const Complete16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref199 => {
  let {
    resolvedRoles
  } = _ref199;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgComplete$1, propsClone);
});
const Copy16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref200 => {
  let {
    resolvedRoles
  } = _ref200;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCopy$1, propsClone);
});
const CtaArrowRight16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref201 => {
  let {
    resolvedRoles
  } = _ref201;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCtaArrowRight$1, propsClone);
});
const Dashboard16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref202 => {
  let {
    resolvedRoles
  } = _ref202;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDashboard$1, propsClone);
});
const DataRefresh16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref203 => {
  let {
    resolvedRoles
  } = _ref203;
  let baseProps = {
    width: "17px",
    height: "18px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDataRefresh$1, propsClone);
});
const DeviceDesktop16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref204 => {
  let {
    resolvedRoles
  } = _ref204;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDeviceDesktop$1, propsClone);
});
const DeviceMobile16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref205 => {
  let {
    resolvedRoles
  } = _ref205;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDeviceMobile$1, propsClone);
});
const DeviceTablet16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref206 => {
  let {
    resolvedRoles
  } = _ref206;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDeviceTablet$1, propsClone);
});
const Devices16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref207 => {
  let {
    resolvedRoles
  } = _ref207;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDevices$1, propsClone);
});
const DocumentManagement16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref208 => {
  let {
    resolvedRoles
  } = _ref208;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDocumentManagement$1, propsClone);
});
const Down16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref209 => {
  let {
    resolvedRoles
  } = _ref209;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDown$1, propsClone);
});
const Download16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref210 => {
  let {
    resolvedRoles
  } = _ref210;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgDownload$1, propsClone);
});
const EditProfile16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref211 => {
  let {
    resolvedRoles
  } = _ref211;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgEditProfile$1, propsClone);
});
const Edit16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref212 => {
  let {
    resolvedRoles
  } = _ref212;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgEdit$1, propsClone);
});
const Education16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref213 => {
  let {
    resolvedRoles
  } = _ref213;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgEducation$1, propsClone);
});
const Error16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref214 => {
  let {
    resolvedRoles
  } = _ref214;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgError$1, propsClone);
});
const ExpandPanel16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref215 => {
  let {
    resolvedRoles
  } = _ref215;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgExpandPanel$1, propsClone);
});
const ExportMove16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref216 => {
  let {
    resolvedRoles
  } = _ref216;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgExportMove$1, propsClone);
});
const ExternalLink16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref217 => {
  let {
    resolvedRoles
  } = _ref217;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgExternalLink$1, propsClone);
});
const External16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref218 => {
  let {
    resolvedRoles
  } = _ref218;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgExternal$1, propsClone);
});
const Favorite16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref219 => {
  let {
    resolvedRoles
  } = _ref219;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFavorite$1, propsClone);
});
const Featured16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref220 => {
  let {
    resolvedRoles
  } = _ref220;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFeatured$1, propsClone);
});
const Feedback16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref221 => {
  let {
    resolvedRoles
  } = _ref221;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFeedback$1, propsClone);
});
const Field16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref222 => {
  let {
    resolvedRoles
  } = _ref222;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgField$1, propsClone);
});
const FileAssembly16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref223 => {
  let {
    resolvedRoles
  } = _ref223;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileAssembly$1, propsClone);
});
const FileAudio16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref224 => {
  let {
    resolvedRoles
  } = _ref224;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileAudio$1, propsClone);
});
const FileDocument16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref225 => {
  let {
    resolvedRoles
  } = _ref225;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileDocument$1, propsClone);
});
const FileGeneric16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref226 => {
  let {
    resolvedRoles
  } = _ref226;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileGeneric$1, propsClone);
});
const FileImage16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref227 => {
  let {
    resolvedRoles
  } = _ref227;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileImage$1, propsClone);
});
const FilePart16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref228 => {
  let {
    resolvedRoles
  } = _ref228;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFilePart$1, propsClone);
});
const FilePdf16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref229 => {
  let {
    resolvedRoles
  } = _ref229;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFilePdf$1, propsClone);
});
const FilePresentation16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref230 => {
  let {
    resolvedRoles
  } = _ref230;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFilePresentation$1, propsClone);
});
const FileSpreadsheet16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref231 => {
  let {
    resolvedRoles
  } = _ref231;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileSpreadsheet$1, propsClone);
});
const FileVideo16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref232 => {
  let {
    resolvedRoles
  } = _ref232;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileVideo$1, propsClone);
});
const FileZip16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref233 => {
  let {
    resolvedRoles
  } = _ref233;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFileZip$1, propsClone);
});
const FilterTokens16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref234 => {
  let {
    resolvedRoles
  } = _ref234;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFilterTokens$1, propsClone);
});
const Filter16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref235 => {
  let {
    resolvedRoles
  } = _ref235;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFilter$1, propsClone);
});
const Flag16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref236 => {
  let {
    resolvedRoles
  } = _ref236;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFlag$1, propsClone);
});
const FolderOpen16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref237 => {
  let {
    resolvedRoles
  } = _ref237;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFolderOpen$1, propsClone);
});
const Folder16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref238 => {
  let {
    resolvedRoles
  } = _ref238;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgFolder$1, propsClone);
});
const Forums16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref239 => {
  let {
    resolvedRoles
  } = _ref239;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgForums$1, propsClone);
});
const Forward16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref240 => {
  let {
    resolvedRoles
  } = _ref240;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgForward$1, propsClone);
});
const Globe16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref241 => {
  let {
    resolvedRoles
  } = _ref241;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgGlobe$1, propsClone);
});
const Graph16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref242 => {
  let {
    resolvedRoles
  } = _ref242;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgGraph$1, propsClone);
});
const Grid16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref243 => {
  let {
    resolvedRoles
  } = _ref243;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgGrid$1, propsClone);
});
const Help16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref244 => {
  let {
    resolvedRoles
  } = _ref244;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHelp$1, propsClone);
});
const Hidden16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref245 => {
  let {
    resolvedRoles
  } = _ref245;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHidden$1, propsClone);
});
const Hierarchy16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref246 => {
  let {
    resolvedRoles
  } = _ref246;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHierarchy$1, propsClone);
});
const Home16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref247 => {
  let {
    resolvedRoles
  } = _ref247;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHome$1, propsClone);
});
const Import16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref248 => {
  let {
    resolvedRoles
  } = _ref248;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgImport$1, propsClone);
});
const Inbox16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref249 => {
  let {
    resolvedRoles
  } = _ref249;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgInbox$1, propsClone);
});
const Info16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref250 => {
  let {
    resolvedRoles
  } = _ref250;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgInfo$1, propsClone);
});
const Item16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref251 => {
  let {
    resolvedRoles
  } = _ref251;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgItem$1, propsClone);
});
const Library16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref252 => {
  let {
    resolvedRoles
  } = _ref252;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgLibrary$1, propsClone);
});
const Link16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref253 => {
  let {
    resolvedRoles
  } = _ref253;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgLink$1, propsClone);
});
const List16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref254 => {
  let {
    resolvedRoles
  } = _ref254;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgList$1, propsClone);
});
const Location16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref255 => {
  let {
    resolvedRoles
  } = _ref255;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgLocation$1, propsClone);
});
const Lock16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref256 => {
  let {
    resolvedRoles
  } = _ref256;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgLock$1, propsClone);
});
const Mail16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref257 => {
  let {
    resolvedRoles
  } = _ref257;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgMail$1, propsClone);
});
const ManageAccess16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref258 => {
  let {
    resolvedRoles
  } = _ref258;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgManageAccess$1, propsClone);
});
const Maximize16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref259 => {
  let {
    resolvedRoles
  } = _ref259;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgMaximize$1, propsClone);
});
const Minimize16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref260 => {
  let {
    resolvedRoles
  } = _ref260;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgMinimize$1, propsClone);
});
const MoreVertical16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref261 => {
  let {
    resolvedRoles
  } = _ref261;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgMoreVertical$1, propsClone);
});
const More16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref262 => {
  let {
    resolvedRoles
  } = _ref262;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgMore$1, propsClone);
});
const Mute16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref263 => {
  let {
    resolvedRoles
  } = _ref263;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgMute$1, propsClone);
});
const NotEditable16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref264 => {
  let {
    resolvedRoles
  } = _ref264;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgNotEditable$1, propsClone);
});
const NotificationOff16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref265 => {
  let {
    resolvedRoles
  } = _ref265;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgNotificationOff$1, propsClone);
});
const Notification16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref266 => {
  let {
    resolvedRoles
  } = _ref266;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgNotification$1, propsClone);
});
const OnlineViewers16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref267 => {
  let {
    resolvedRoles
  } = _ref267;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgOnlineViewers$1, propsClone);
});
const Paste16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref268 => {
  let {
    resolvedRoles
  } = _ref268;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPaste$1, propsClone);
});
const PermissionGroup16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref269 => {
  let {
    resolvedRoles
  } = _ref269;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPermissionGroup$1, propsClone);
});
const PermissionIndividual16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref270 => {
  let {
    resolvedRoles
  } = _ref270;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPermissionIndividual$1, propsClone);
});
const Photos16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref271 => {
  let {
    resolvedRoles
  } = _ref271;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPhotos$1, propsClone);
});
const Pin16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref272 => {
  let {
    resolvedRoles
  } = _ref272;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPin$1, propsClone);
});
const Placeholder16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref273 => {
  let {
    resolvedRoles
  } = _ref273;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaceholder$1, propsClone);
});
const PlaybackFastForward16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref274 => {
  let {
    resolvedRoles
  } = _ref274;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackFastForward$1, propsClone);
});
const PlaybackGoToEnd16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref275 => {
  let {
    resolvedRoles
  } = _ref275;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackGoToEnd$1, propsClone);
});
const PlaybackGoToStart16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref276 => {
  let {
    resolvedRoles
  } = _ref276;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackGoToStart$1, propsClone);
});
const PlaybackLoop16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref277 => {
  let {
    resolvedRoles
  } = _ref277;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackLoop$1, propsClone);
});
const PlaybackNext16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref278 => {
  let {
    resolvedRoles
  } = _ref278;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackNext$1, propsClone);
});
const PlaybackPause16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref279 => {
  let {
    resolvedRoles
  } = _ref279;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackPause$1, propsClone);
});
const PlaybackPlay16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref280 => {
  let {
    resolvedRoles
  } = _ref280;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackPlay$1, propsClone);
});
const PlaybackPrevious16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref281 => {
  let {
    resolvedRoles
  } = _ref281;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackPrevious$1, propsClone);
});
const PlaybackRecord16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref282 => {
  let {
    resolvedRoles
  } = _ref282;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackRecord$1, propsClone);
});
const PlaybackRewind16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref283 => {
  let {
    resolvedRoles
  } = _ref283;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackRewind$1, propsClone);
});
const PlaybackShuffle16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref284 => {
  let {
    resolvedRoles
  } = _ref284;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackShuffle$1, propsClone);
});
const PlaybackStop16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref285 => {
  let {
    resolvedRoles
  } = _ref285;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPlaybackStop$1, propsClone);
});
const Print16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref286 => {
  let {
    resolvedRoles
  } = _ref286;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPrint$1, propsClone);
});
const ProductsAndServices16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref287 => {
  let {
    resolvedRoles
  } = _ref287;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgProductsAndServices$1, propsClone);
});
const Profile16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref288 => {
  let {
    resolvedRoles
  } = _ref288;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgProfile$1, propsClone);
});
const ProjectManagement16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref289 => {
  let {
    resolvedRoles
  } = _ref289;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgProjectManagement$1, propsClone);
});
const Properties16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref290 => {
  let {
    resolvedRoles
  } = _ref290;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgProperties$1, propsClone);
});
const Publish16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref291 => {
  let {
    resolvedRoles
  } = _ref291;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgPublish$1, propsClone);
});
const Quantities16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref292 => {
  let {
    resolvedRoles
  } = _ref292;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgQuantities$1, propsClone);
});
const RecentFile16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref293 => {
  let {
    resolvedRoles
  } = _ref293;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgRecentFile$1, propsClone);
});
const Recommend16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref294 => {
  let {
    resolvedRoles
  } = _ref294;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgRecommend$1, propsClone);
});
const Redo16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref295 => {
  let {
    resolvedRoles
  } = _ref295;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgRedo$1, propsClone);
});
const Remove16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref296 => {
  let {
    resolvedRoles
  } = _ref296;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgRemove$1, propsClone);
});
const Rename16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref297 => {
  let {
    resolvedRoles
  } = _ref297;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgRename$1, propsClone);
});
const Report16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref298 => {
  let {
    resolvedRoles
  } = _ref298;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgReport$1, propsClone);
});
const SaveAs16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref299 => {
  let {
    resolvedRoles
  } = _ref299;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSaveAs$1, propsClone);
});
const Save16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref300 => {
  let {
    resolvedRoles
  } = _ref300;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSave$1, propsClone);
});
const Search16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref301 => {
  let {
    resolvedRoles
  } = _ref301;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSearch$1, propsClone);
});
const Security16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref302 => {
  let {
    resolvedRoles
  } = _ref302;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSecurity$1, propsClone);
});
const SelectAll16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref303 => {
  let {
    resolvedRoles
  } = _ref303;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSelectAll$1, propsClone);
});
const SelectNone16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref304 => {
  let {
    resolvedRoles
  } = _ref304;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSelectNone$1, propsClone);
});
const Service16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref305 => {
  let {
    resolvedRoles
  } = _ref305;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgService$1, propsClone);
});
const Settings16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref306 => {
  let {
    resolvedRoles
  } = _ref306;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSettings$1, propsClone);
});
const Share16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref307 => {
  let {
    resolvedRoles
  } = _ref307;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgShare$1, propsClone);
});
const SignOut16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref308 => {
  let {
    resolvedRoles
  } = _ref308;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSignOut$1, propsClone);
});
const SocialBlog16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref309 => {
  let {
    resolvedRoles
  } = _ref309;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSocialBlog$1, propsClone);
});
const SocialFacebook16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref310 => {
  let {
    resolvedRoles
  } = _ref310;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSocialFacebook$1, propsClone);
});
const SocialInstagram16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref311 => {
  let {
    resolvedRoles
  } = _ref311;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSocialInstagram$1, propsClone);
});
const SocialLinkedin16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref312 => {
  let {
    resolvedRoles
  } = _ref312;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSocialLinkedin$1, propsClone);
});
const SocialTwitter16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref313 => {
  let {
    resolvedRoles
  } = _ref313;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSocialTwitter$1, propsClone);
});
const SocialYoutube16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref314 => {
  let {
    resolvedRoles
  } = _ref314;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSocialYoutube$1, propsClone);
});
const Sort16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref315 => {
  let {
    resolvedRoles
  } = _ref315;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSort$1, propsClone);
});
const Subscription16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref316 => {
  let {
    resolvedRoles
  } = _ref316;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSubscription$1, propsClone);
});
const Support16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref317 => {
  let {
    resolvedRoles
  } = _ref317;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSupport$1, propsClone);
});
const SurveyEquipment16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref318 => {
  let {
    resolvedRoles
  } = _ref318;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSurveyEquipment$1, propsClone);
});
const Sync16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref319 => {
  let {
    resolvedRoles
  } = _ref319;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgSync$1, propsClone);
});
const Tag16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref320 => {
  let {
    resolvedRoles
  } = _ref320;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgTag$1, propsClone);
});
const Trash16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref321 => {
  let {
    resolvedRoles
  } = _ref321;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgTrash$1, propsClone);
});
const TreeView16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref322 => {
  let {
    resolvedRoles
  } = _ref322;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgTreeView$1, propsClone);
});
const Unavailable16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref323 => {
  let {
    resolvedRoles
  } = _ref323;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUnavailable$1, propsClone);
});
const Undo16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref324 => {
  let {
    resolvedRoles
  } = _ref324;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUndo$1, propsClone);
});
const Unlink16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref325 => {
  let {
    resolvedRoles
  } = _ref325;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUnlink$1, propsClone);
});
const Unlock16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref326 => {
  let {
    resolvedRoles
  } = _ref326;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUnlock$1, propsClone);
});
const Unpin16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref327 => {
  let {
    resolvedRoles
  } = _ref327;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUnpin$1, propsClone);
});
const Up16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref328 => {
  let {
    resolvedRoles
  } = _ref328;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUp$1, propsClone);
});
const Upload16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref329 => {
  let {
    resolvedRoles
  } = _ref329;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUpload$1, propsClone);
});
const UserInactive16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref330 => {
  let {
    resolvedRoles
  } = _ref330;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgUserInactive$1, propsClone);
});
const Visible16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref331 => {
  let {
    resolvedRoles
  } = _ref331;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgVisible$1, propsClone);
});
const Volume16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref332 => {
  let {
    resolvedRoles
  } = _ref332;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgVolume$1, propsClone);
});
const ZoomIn16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref333 => {
  let {
    resolvedRoles
  } = _ref333;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgZoomIn$1, propsClone);
});
const ZoomOut16 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref334 => {
  let {
    resolvedRoles
  } = _ref334;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgZoomOut$1, propsClone);
});
const CaretDownMUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref335 => {
  let {
    resolvedRoles
  } = _ref335;
  let baseProps = {
    width: "10px",
    height: "10px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretDownM, propsClone);
});
const CaretDownSUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref336 => {
  let {
    resolvedRoles
  } = _ref336;
  let baseProps = {
    width: "7px",
    height: "4px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretDownS, propsClone);
});
const CaretDownXsUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref337 => {
  let {
    resolvedRoles
  } = _ref337;
  let baseProps = {
    width: "5px",
    height: "3px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretDownXs, propsClone);
});
const CaretLeftMUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref338 => {
  let {
    resolvedRoles
  } = _ref338;
  let baseProps = {
    width: "10px",
    height: "10px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretLeftM, propsClone);
});
const CaretLeftSUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref339 => {
  let {
    resolvedRoles
  } = _ref339;
  let baseProps = {
    width: "4px",
    height: "7px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretLeftS, propsClone);
});
const CaretLeftXsUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref340 => {
  let {
    resolvedRoles
  } = _ref340;
  let baseProps = {
    width: "3px",
    height: "5px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretLeftXs, propsClone);
});
const CaretRightMUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref341 => {
  let {
    resolvedRoles
  } = _ref341;
  let baseProps = {
    width: "10px",
    height: "10px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretRightM, propsClone);
});
const CaretRightSUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref342 => {
  let {
    resolvedRoles
  } = _ref342;
  let baseProps = {
    width: "4px",
    height: "7px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretRightS, propsClone);
});
const CaretRightXsUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref343 => {
  let {
    resolvedRoles
  } = _ref343;
  let baseProps = {
    width: "3px",
    height: "5px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretRightXs, propsClone);
});
const CaretUpMUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref344 => {
  let {
    resolvedRoles
  } = _ref344;
  let baseProps = {
    width: "10px",
    height: "10px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretUpM, propsClone);
});
const CaretUpSUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref345 => {
  let {
    resolvedRoles
  } = _ref345;
  let baseProps = {
    width: "7px",
    height: "4px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretUpS, propsClone);
});
const CaretUpXsUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref346 => {
  let {
    resolvedRoles
  } = _ref346;
  let baseProps = {
    width: "5px",
    height: "3px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCaretUpXs, propsClone);
});
const CheckmarkSUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref347 => {
  let {
    resolvedRoles
  } = _ref347;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCheckmarkS, propsClone);
});
const CheckmarkXsUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref348 => {
  let {
    resolvedRoles
  } = _ref348;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCheckmarkXs, propsClone);
});
const CloseLUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref349 => {
  let {
    resolvedRoles
  } = _ref349;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCloseL, propsClone);
});
const CloseMUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref350 => {
  let {
    resolvedRoles
  } = _ref350;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCloseM, propsClone);
});
const CloseSUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref351 => {
  let {
    resolvedRoles
  } = _ref351;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCloseS, propsClone);
});
const CloseXsUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref352 => {
  let {
    resolvedRoles
  } = _ref352;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgCloseXs, propsClone);
});
const EllipsisMUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref353 => {
  let {
    resolvedRoles
  } = _ref353;
  let baseProps = {
    width: "24px",
    height: "24px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgEllipsisM, propsClone);
});
const EllipsisSUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref354 => {
  let {
    resolvedRoles
  } = _ref354;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgEllipsisS, propsClone);
});
const EllipsisXsUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref355 => {
  let {
    resolvedRoles
  } = _ref355;
  let baseProps = {
    width: "12px",
    height: "12px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgEllipsisXs, propsClone);
});
const HamburgerCloseUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref356 => {
  let {
    resolvedRoles
  } = _ref356;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHamburgerClose, propsClone);
});
const HamburgerDefaultUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref357 => {
  let {
    resolvedRoles
  } = _ref357;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHamburgerDefault, propsClone);
});
const HoldSUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref358 => {
  let {
    resolvedRoles
  } = _ref358;
  let baseProps = {
    width: "5px",
    height: "5px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHoldS, propsClone);
});
const HoldXsUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref359 => {
  let {
    resolvedRoles
  } = _ref359;
  let baseProps = {
    width: "3px",
    height: "3px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHoldXs, propsClone);
});
const OperatorMinusSUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref360 => {
  let {
    resolvedRoles
  } = _ref360;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgOperatorMinusS, propsClone);
});
const OperatorMinusXsUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref361 => {
  let {
    resolvedRoles
  } = _ref361;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgOperatorMinusXs, propsClone);
});
const OperatorPlusSUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref362 => {
  let {
    resolvedRoles
  } = _ref362;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgOperatorPlusS, propsClone);
});
const OperatorPlusXsUI = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref363 => {
  let {
    resolvedRoles
  } = _ref363;
  let baseProps = {
    width: "16px",
    height: "16px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgOperatorPlusXs, propsClone);
});
const Alert12 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref364 => {
  let {
    resolvedRoles
  } = _ref364;
  let baseProps = {
    width: "12px",
    height: "12px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgAlert$2, propsClone);
});
const Complete12 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref365 => {
  let {
    resolvedRoles
  } = _ref365;
  let baseProps = {
    width: "12px",
    height: "12px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgComplete$2, propsClone);
});
const Error12 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref366 => {
  let {
    resolvedRoles
  } = _ref366;
  let baseProps = {
    width: "12px",
    height: "12px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgError$2, propsClone);
});
const Help12 = props => /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, _ref367 => {
  let {
    resolvedRoles
  } = _ref367;
  let baseProps = {
    width: "12px",
    height: "12px"
  };
  const propsClone = Object.assign(baseProps, props, {
    className: cx(css(stylesheet(props, resolvedRoles)), props.className)
  });
  if (props.stylesheet) delete propsClone.stylesheet;
  return /*#__PURE__*/React.createElement(SvgHelp$2, propsClone);
});
/* eslint-enable */

export { AVAILABLE_NAMES, AVAILABLE_SIZES, Add16, Add24, AddFolder16, AddFolder24, AddMember16, AddMember24, AddPage16, AddPage24, Alert12, Alert16, Alert24, Archive16, Archive24, AreaPost16, AreaPost24, Attach16, Attach24, Attachment16, Attachment24, Back16, Back24, BillStack16, BillStack24, Billing16, Billing24, Bookmark16, Bookmark24, Building16, Building24, Calendar16, Calendar24, CaretDown16, CaretDown24, CaretDownMUI, CaretDownSUI, CaretDownXsUI, CaretLeft16, CaretLeft24, CaretLeftMUI, CaretLeftSUI, CaretLeftXsUI, CaretRight16, CaretRight24, CaretRightMUI, CaretRightSUI, CaretRightXsUI, CaretUp16, CaretUp24, CaretUpMUI, CaretUpSUI, CaretUpXsUI, CartEmpty16, CartEmpty24, CartFull16, CartFull24, Chat16, Chat24, Checklist16, Checklist24, Checkmark16, Checkmark24, CheckmarkSUI, CheckmarkXsUI, Clock16, Clock24, CloseLUI, CloseMUI, CloseSUI, CloseXsUI, ClosedCaptioning16, ClosedCaptioning24, Cloud16, Cloud24, Collaboration16, Collaboration24, CollapsePanel16, CollapsePanel24, Comment16, Comment24, Compare16, Compare24, Complete12, Complete16, Complete24, Copy16, Copy24, CtaArrowRight16, CtaArrowRight24, Dashboard16, Dashboard24, DataRefresh16, DataRefresh24, DeviceDesktop16, DeviceDesktop24, DeviceMobile16, DeviceMobile24, DeviceTablet16, DeviceTablet24, Devices16, Devices24, DocumentManagement16, DocumentManagement24, Down16, Down24, Download16, Download24, Edit16, Edit24, EditProfile16, EditProfile24, Education16, Education24, EllipsisMUI, EllipsisSUI, EllipsisXsUI, Error12, Error16, Error24, ExpandPanel16, ExpandPanel24, ExportMove16, ExportMove24, External16, External24, ExternalLink16, ExternalLink24, Favorite16, Favorite24, Featured16, Featured24, Feedback16, Feedback24, Field16, Field24, FileAssembly16, FileAssembly24, FileAudio16, FileAudio24, FileDocument16, FileDocument24, FileGeneric16, FileGeneric24, FileImage16, FileImage24, FilePart16, FilePart24, FilePdf16, FilePdf24, FilePresentation16, FilePresentation24, FileSpreadsheet16, FileSpreadsheet24, FileVideo16, FileVideo24, FileZip16, FileZip24, Filter16, Filter24, FilterTokens16, FilterTokens24, Flag16, Flag24, Folder16, Folder24, FolderOpen16, FolderOpen24, Forums16, Forums24, Forward16, Forward24, Globe16, Globe24, Graph16, Graph24, Grid16, Grid24, HamburgerCloseUI, HamburgerDefaultUI, Help12, Help16, Help24, Hidden16, Hidden24, Hierarchy16, Hierarchy24, HoldSUI, HoldXsUI, Home16, Home24, Import16, Import24, Inbox16, Inbox24, Info16, Info24, Item16, Item24, Library16, Library24, Link16, Link24, List16, List24, Location16, Location24, Lock16, Lock24, Mail16, Mail24, ManageAccess16, ManageAccess24, Maximize16, Maximize24, Minimize16, Minimize24, More16, More24, MoreVertical16, MoreVertical24, Mute16, Mute24, NotEditable16, NotEditable24, Notification16, Notification24, NotificationOff16, NotificationOff24, OnlineViewers16, OnlineViewers24, OperatorMinusSUI, OperatorMinusXsUI, OperatorPlusSUI, OperatorPlusXsUI, Paste16, Paste24, PermissionGroup16, PermissionGroup24, PermissionIndividual16, PermissionIndividual24, Photos16, Photos24, Pin16, Pin24, Placeholder16, Placeholder24, PlaybackFastForward16, PlaybackFastForward24, PlaybackGoToEnd16, PlaybackGoToEnd24, PlaybackGoToStart16, PlaybackGoToStart24, PlaybackLoop16, PlaybackLoop24, PlaybackNext16, PlaybackNext24, PlaybackPause16, PlaybackPause24, PlaybackPlay16, PlaybackPlay24, PlaybackPrevious16, PlaybackPrevious24, PlaybackRecord16, PlaybackRecord24, PlaybackRewind16, PlaybackRewind24, PlaybackShuffle16, PlaybackShuffle24, PlaybackStop16, PlaybackStop24, Print16, Print24, ProductsAndServices16, ProductsAndServices24, Profile16, Profile24, ProjectManagement16, ProjectManagement24, Properties16, Properties24, Publish16, Publish24, Quantities16, Quantities24, RecentFile16, RecentFile24, Recommend16, Recommend24, Redo16, Redo24, Remove16, Remove24, Rename16, Rename24, Report16, Report24, Save16, Save24, SaveAs16, SaveAs24, Search16, Search24, Security16, Security24, SelectAll16, SelectAll24, SelectNone16, SelectNone24, Service16, Service24, Settings16, Settings24, Share16, Share24, SignOut16, SignOut24, SocialBlog16, SocialBlog24, SocialFacebook16, SocialFacebook24, SocialInstagram16, SocialInstagram24, SocialLinkedin16, SocialLinkedin24, SocialTwitter16, SocialTwitter24, SocialYoutube16, SocialYoutube24, Sort16, Sort24, Subscription16, Subscription24, Support16, Support24, SurveyEquipment16, SurveyEquipment24, Sync16, Sync24, Tag16, Tag24, Trash16, Trash24, TreeView16, TreeView24, Unavailable16, Unavailable24, Undo16, Undo24, Unlink16, Unlink24, Unlock16, Unlock24, Unpin16, Unpin24, Up16, Up24, Upload16, Upload24, UserInactive16, UserInactive24, Visible16, Visible24, Volume16, Volume24, ZoomIn16, ZoomIn24, ZoomOut16, ZoomOut24, names, higIconSets as sets, sizes };
